// Keyed by short, stable kebab-case keys (e.g. "forgot-password-title") rather
// than the literal English string — makes entries easy to find/grep later and
// keeps translations intact if the English copy is later reworded.
export default {
   "forgot-password-title": "Şifrenizi mi unuttunuz?",
   "forgot-password-description":
      "Doğrulama kodu almak ve şifrenizi kurtarmak için aşağıya e-posta adresinizi girin",
   email: "E-posta",
   cancel: "İptal",
   submit: "Gönder",
   "menu-section-stakeholders": "Paydaşlar",
   "menu-section-setup": "Kurulum",
   "menu-section-implementation": "Uygulama",
   "menu-section-support": "Destek",
   "menu-item-experts": "Uzmanlar",
   "menu-item-approvers": "Onaylayıcılar",
   "menu-item-organizations": "Kuruluşlar",
   "menu-item-requests": "Talepler",
   "menu-item-assessments": "Değerlendirmeler",
   "menu-item-modules": "Modüller",
   "menu-item-targets": "Hedefler",
   "menu-item-workspaces": "Çalışma Alanları",
   "menu-item-tickets": "Biletler",
   "menu-section-organization-management": "Organizasyon Yönetimi",
   "menu-section-my-account": "Hesabım",
   "menu-item-profile": "Profil",
   "menu-item-team": "Ekip",
   "menu-item-help-desk": "Yardım masası",

   name: "Ad",
   country: "Ülke",
   "phone-number": "Telefon numarası",
   expertise: "Uzmanlık",
   "disabled-reason": "Devre Dışı Bırakma Nedeni",
   "not-applicable": "Yok",
   export: "Dışa Aktar",
   "status-pending": "Beklemede",
   "status-rejected": "Reddedildi",
   "status-active": "Aktif",
   "status-disabled": "Devre Dışı",

   "experts-management-title": "Uzmanlar",
   "experts-request-tab": "Uzman talebi",
   "experts-approved-tab": "Onaylı uzmanlar",
   "experts-deleted-button": "Silinen uzmanlar",
   "experts-status-deactivated": "Devre Dışı",

   "filter-search-label": "Neyi arıyorsunuz?",
   "search-placeholder": "Ara",
   "search-by-name-placeholder": "Ada göre ara",
   "search-task-by-name-placeholder": "Bir görevi adına göre ara",
   "search-module-by-name-placeholder": "Bir modülü adına göre ara",
   "search-workspace-by-name-placeholder": "Bir çalışma alanını adına göre ara",
   "search-assessment-by-name-placeholder": "Bir değerlendirmeyi adına göre ara",
   "search-expert-by-name-placeholder": "Bir uzmanı adına göre ara",
   "search-request-by-name-placeholder": "Talep eden kuruluşun adına göre bir talep ara",
   "search-request-by-email-placeholder": "Talep eden kuruluşun e-postasına göre bir talep ara",
   "search-request-by-name-or-email-placeholder": "Adına veya e-postasına göre ara",
   "search-invoice-by-name-placeholder": "Bir faturayı adına göre ara",
   "search-organization-by-name-placeholder": "Bir kuruluşu adına göre ara",
   "filter-by-type-placeholder": "Türe göre filtrele",
   "filter-by-start-date-placeholder": "Başlangıç tarihine göre filtrele",
   "filter-by-end-date-placeholder": "Bitiş tarihine göre filtrele",
   "filter-by-year-placeholder": "Yıla göre filtrele",
   "filter-tasks-by-assigned-member-placeholder": "Görevleri atanan üyeye göre filtrele",
   "filter-tasks-by-status-placeholder": "Görevleri duruma göre filtrele",
   "filter-workspace-request-by-status-placeholder": "Çalışma alanı talebini duruma göre filtrele",
   "filter-workspace-by-country-placeholder": "Çalışma alanlarını ülkeye göre filtrele",
   "filter-experts-by-country-placeholder": "Uzmanları ülkeye göre filtrele",
   "filter-by-submission-date-placeholder": "Gönderim tarihine göre filtrele",
   "filter-by-assessments-placeholder": "Değerlendirmelere göre filtrele",
   "filter-by-assessment-placeholder": "Değerlendirmeye göre filtrele",
   "filter-by-workspace-placeholder": "Çalışma alanına göre filtrele",
   "filter-by-score-placeholder": "Puana göre filtrele",
   "filter-by-country-placeholder": "Ülkeye göre filtrele",
   "filter-by-operating-countries-placeholder": "Faaliyet gösterilen ülkelere göre filtrele",
   "filter-by-sectors-placeholder": "Sektöre göre filtrele",
   "export-organizations-button": "Kuruluşları dışa aktar",
   "filter-by-module-placeholder": "Modüle göre filtrele",
   "filter-by-round-placeholder": "Tura göre filtrele",
   "filter-by-section-placeholder": "Bölüme göre filtrele",
   "filter-by-owner-placeholder": "Sahibe göre filtrele",
   "search-by-its-name-placeholder": "Ada göre ara",
   "guided-assessment": "Rehberli Değerlendirme",
   "self-assessment": "Öz Değerlendirme",
   "clear-all-button": "Tümünü temizle",
   "filters-button": "Filtreler",
   workspace: "Çalışma Alanı",
   assessment: "Değerlendirme",
   score: "Puan",
   city: "Şehir",
   "operating-countries": "Faaliyet gösterilen ülkeler",
   sectors: "Sektörler",
   type: "Tür",
   organizations: "Kuruluşlar",
   "select-workspace-placeholder": "Çalışma alanını seçin",
   "select-assessment-placeholder": "Değerlendirmeyi seçin",
   "select-score-range-placeholder": "Puan aralığını seçin",
   "select-country-placeholder": "Ülkeyi seçin",
   "select-base-city-placeholder": "Bulunduğunuz şehri seçin",
   "select-sectors-placeholder": "Sektörleri seçin",
   "select-type-placeholder": "Türü seçin",

   "toast-oops-title": "Hata! Bir sorun oluştu!",
   "toast-request-accepted-success-title": "Talep başarıyla kabul edildi!",
   "toast-request-accepted-success-description":
      "Bu talep başarıyla kabul edildi, yanıt talep eden kullanıcıya bildirilecektir.",
   "toast-request-accept-error-description":
      "Bu talebi kabul ederken bir sorun yaşadık, lütfen tekrar deneyin.",
   "toast-request-rejected-success-title": "Talep başarıyla reddedildi!",
   "toast-request-rejected-success-description":
      "Bu talep başarıyla reddedildi, yanıt talep eden kullanıcıya bildirilecektir.",
   "toast-request-reject-error-description":
      "Bu talebi reddederken bir sorun yaşadık, lütfen tekrar deneyin.",
   "toast-requests-accepted-success-title": "Talepler başarıyla kabul edildi!",
   "toast-requests-accepted-success-description":
      "Talepler başarıyla kabul edildi, yanıt talep eden kullanıcılara bildirilecektir.",
   "toast-requests-accept-error-description":
      "Bu talepleri kabul ederken bir sorun yaşadık, lütfen tekrar deneyin.",
   "toast-requests-rejected-success-title": "Talepler başarıyla reddedildi!",
   "toast-requests-rejected-success-description":
      "Talepler başarıyla reddedildi, yanıt talep eden kullanıcılara bildirilecektir.",
   "toast-requests-reject-error-description":
      "Bu talepleri reddederken bir sorun yaşadık, lütfen tekrar deneyin.",
   "approve-all-button": "Tümünü onayla",
   "reject-all-button": "Tümünü reddet",

   "search-target-placeholder": "Değerlendirme veya modül adına göre bir hedef ara",
   "show-active-rounds-checkbox": "Aktif turları göster",

   "general-score-column": "Genel puan",
   "submissions-column": "Gönderimler",
   "tasks-column": "Görevler",
   "areas-complete-text": "alan tamamlandı",
   "organizations-progress-summary-title": "Kuruluşların ilerleme özeti",
   "export-progress-summary-button": "İlerleme Özetini Dışa Aktar",
   "select-module-performance-label": "Kuruluşların performansını görmek için modülü seçin",
   "all-modules-placeholder": "Tüm modüller",

   "registration-request-tab": "Kayıt talebi",
   "workspace-request-tab": "Çalışma alanı talebi",
   "assessment-request-tab": "Değerlendirme talebi",
   "status-approved": "Onaylandı",
   "requesting-user-column": "Talep eden kullanıcı",
   "request-date-column": "Talep tarihi",
   "approval-date-column": "Onay tarihi",
   "processed-by-column": "İşleyen",
   "workspace-name-column": "Çalışma alanı adı",
   "assessment-name-column": "Değerlendirme adı",
   "consultant-name-column": "Danışman adı",
   "rejection-date-column": "Ret tarihi",
   "accept-request-title": "Talebi Kabul Et",
   "accept-request-button": "Talebi kabul et",
   "accept-request-description": "Bu talebi kabul etmek üzeresiniz. Bu işlem geri alınamaz.",
   "reject-request": "Talebi reddet",
   "reject-request-description": "Bu talebi reddetmek üzeresiniz. Bu işlem geri alınamaz.",
   "confirm-continue-text": "Devam etmek istediğinizden emin misiniz?",
   "reject-button": "Reddet",
   "approve-button": "Onayla",
   "organization-request-title": "Kuruluş Talebi",
   "foundation-label": "Kuruluş tarihi",
   "address-label": "Adres",
   "organization-sectors-label": "Kuruluş Sektörleri",
   "organization-type-label": "Kuruluş Türü",
   "organization-size-label": "Kuruluş Büyüklüğü",
   "organization-name-label": "Kuruluş adı",
   "organization-description-label": "Kuruluş açıklaması",

   "organization-deleted-success-title": "Kuruluş başarıyla silindi!",
   "organization-deleted-success-description": "Bu kuruluş başarıyla silindi.",
   "organization-delete-error-description":
      "Bu kuruluşu silerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "organization-restored-success-title": "Kuruluş başarıyla geri yüklendi!",
   "organization-restored-success-description": "Bu kuruluş başarıyla geri yüklendi.",
   "organization-restore-error-description":
      "Bu kuruluşu devre dışı bırakırken bir sorun yaşadık, lütfen tekrar deneyin.",
   "organization-restore-failed-error-description":
      "Bu kuruluşu geri yüklerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "organization-disabled-success-title": "Kuruluş başarıyla devre dışı bırakıldı!",
   "organization-disabled-success-description": "Bu kuruluş başarıyla devre dışı bırakıldı.",
   "disable-organization-title": "Kuruluşu devre dışı bırak",
   "disable-organization-description-text":
      "Bu kuruluşu devre dışı bırakmak üzeresiniz. Geri yüklenene kadar devre dışı bırakılan kuruluşlar listesine taşınacaktır.",
   "reason-for-disabling-label": "Devre dışı bırakma nedeni",
   "disable-organization-reason-placeholder":
      "Lütfen bu kuruluşu devre dışı bırakma nedenini girin",
   "disable-button": "Devre Dışı Bırak",
   "restore-organization-title": "Kuruluşu geri yükle",
   "registration-date-column": "Kayıt Tarihi",
   "organization-list-title": "Kuruluş listesi",
   "enroll-organizations-button": "Başka bir çalışma alanına kaydet",
   "registered-organizations-label": "Kayıtlı kuruluşlar",
   "average-score-label": "Ortalama puan",
   "registered-as-of-text": "Kayıt tarihi",
   "social-networks-title": "Sosyal Ağlar",
   "offices-title": "Ofisler",
   "ongoing-projects-label": "Devam eden projeler",
   "members-label": "Üyeler",
   "representative-label": "Temsilci",
   "representative-name-label": "Temsilci adı",
   "representative-title-label": "Temsilci unvanı",
   "representative-location-label": "Temsilci konumu",
   "representative-phone-label": "Temsilci telefonu",
   "representative-skype-label": "Temsilci skype",
   "representative-email-label": "Temsilci e-postası",

   "workspace-required-validation": "Çalışma alanı gereklidir",
   "organizations-enrolled-success-title": "Kuruluşlar başarıyla kaydedildi!",
   "organizations-enrolled-success-description":
      "Bu kuruluşlar seçtiğiniz çalışma alanına başarıyla kaydedildi.",
   "organizations-enroll-error-description":
      "Bu kuruluşları kaydederken bir sorun yaşadık, lütfen tekrar deneyin.",
   "enroll-organization-modal-title": "Kuruluşu başka bir çalışma alanına kaydet",
   "select-workspace-to-enroll-label": "Kuruluşları kaydetmek için çalışma alanını seçin",
   "confirm-button": "Onayla",
   "delete-button": "Sil",
   "delete-organization-title": "Kuruluşu sil",
   "delete-organization-description": "Bu kuruluşu silmek üzeresiniz. Bu işlem geri alınamaz.",

   "update-successful-message": "Güncelleme başarılı oldu",
   "max-50-symbols-validation": "Maksimum 50 karakter",
   "min-3-symbols-validation": "Minimum 3 karakter",
   "invalid-email-validation": "Geçersiz e-posta",
   "required-validation": "Zorunlu",
   "edit-organization-details-title": "Kuruluş bilgilerini düzenle",
   "project-number-title": "Proje sayısı",
   "ongoing-project-number-label": "Devam eden proje sayısı",
   "social-label": "Sosyal Ağlar",
   "website-label": "Web sitesi",
   "facebook-label": "Facebook",
   "twitter-label": "Twitter",
   "linkedin-label": "Linkedin",
   "instagram-label": "Instagram",
   "back-button": "Geri",
   "update-button": "Güncelle",

   "representative-removed-success-title": "Temsilci bilgileri başarıyla kaldırıldı!",
   "representative-removed-success-description": "Temsilci bilgileriniz kaldırıldı.",
   "representative-remove-error-description":
      "Temsilci bilgilerini kaldırırken bir sorun yaşadık, lütfen tekrar deneyin.",
   "profile-status-changed-title": "Profil durumunuz değiştirildi!",
   "profile-status-changed-description": "Profil durumunuz başarıyla değiştirildi.",
   "profile-status-change-error-description":
      "Profilin durumunu değiştirirken bir sorun yaşadık, lütfen tekrar deneyin.",
   "go-back-to-organizations-link": "Kuruluşlara geri dön",
   "print-profile-button": "Profili yazdır",
   "make-profile-public-button": "Profili herkese açık yap",
   "make-profile-private-button": "Profili özel yap",
   "complete-profile-reminder-title": "Profilinizi tamamlamayı unutmayın!",
   "complete-profile-reminder-description":
      "Eksiksiz ve herkese açık bir profil ile topluluk içindeki görünürlüğünüzü artırın.",
   "complete-profile-now-button": "Profili şimdi tamamla",
   "profile-status-label": "Profil durumu",
   "private-status": "Özel",
   "public-status": "Herkese açık",
   "organization-email-label": "Kuruluş e-postası",
   "base-country-label": "Temel ülke",
   "zip-code-label": "Posta kodu",
   "about-label": "Hakkında",
   "foundation-date-label": "Kuruluş tarihi",
   "organizations-size-label": "Kuruluşların büyüklüğü",
   "countries-where-operate-label": "Kuruluşun faaliyet gösterdiği ülkeler",
   "sector-that-works-label": "Kuruluşun çalıştığı sektör",
   "representative-details-title": "Temsilci bilgileri",
   "delete-all-representative-info-button": "Tüm temsilci bilgilerini sil",
   "add-representative-details-button": "Temsilci bilgileri ekle",
   "no-information-available-text": "Bilgi mevcut değil",
   "location-label": "Konum",
   "edit-representative-details-button": "Temsilci bilgilerini düzenle",
   "assessments-scores-title": "Değerlendirme sonuçları",
   "assessments-scores-description":
      "Bu kuruluşun tamamlanan değerlendirmelerdeki sonuçlarını kontrol edin.",
   "select-self-assessment-placeholder": "Öz değerlendirmeyi seçin",
   "no-self-assessment-yet-title": "Henüz öz değerlendirme yok",
   "no-self-assessment-yet-description": "Bu kuruluş henüz bir öz değerlendirme tamamlamadı",
   "select-guided-assessment-placeholder": "Rehberli değerlendirmeyi seçin",
   "no-guided-assessment-yet-title": "Henüz rehberli değerlendirme yok",
   "no-guided-assessment-yet-description": "Bu kuruluş henüz bir rehberli değerlendirme tamamlamadı",
   "team-member-list-title": "Ekip üyeleri listesi",
   "team-member-list-description":
      "Ekip üyelerinizi ekleyin ve kuruluşunuzu güçlendirmek için iş birliği yapın. Bu bölüm yalnızca sizin tarafınızdan görülebilir. Profiliniz herkese açık olsa bile, eklediğiniz üyeleri başka kimse göremez.",
   "latest-round-label": "Son tur",
   "size-label": "Boyut",
   "select-number-placeholder": "Sayıyı seçin",
   "select-date-placeholder": "Bir tarih seçin",

   "profile-updated-success-title": "Profil başarıyla güncellendi!",
   "profile-updated-success-description": "Profil bilgileriniz doğru şekilde güncellendi.",
   "profile-update-error-description":
      "Profil bilgilerinizi güncellerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "international-name-required-validation": "Uluslararası ad gereklidir",
   "date-of-establishment-required-validation": "Kuruluş tarihi gereklidir",
   "address-required-validation": "Adres gereklidir",
   "zip-code-required-validation": "Posta kodu gereklidir",
   "email-required-validation": "E-posta gereklidir",
   "invalid-phone-number-validation": "Geçersiz telefon numarası",
   "phone-number-required-validation": "Telefon numarası gereklidir",
   "at-least-one-sector-required-validation": "En az bir sektör gereklidir",
   "organization-size-required-validation": "Kuruluş büyüklüğü gereklidir",
   "at-least-one-country-required-validation": "En az bir ülke gereklidir",
   "base-country-required-validation": "Temel ülke gereklidir",
   "city-required-validation": "Şehir gereklidir",
   "edit-profile-title": "Profili Düzenle",
   "organization-details-tab": "Kuruluş Bilgileri",
   "international-name-placeholder": "Uluslararası ad",
   "description-placeholder": "Açıklama",
   "foundation-year-label": "Kuruluş yılı",
   "select-organization-size-placeholder": "Kuruluş büyüklüğünü seçin",
   "countries-where-operates-label": "Kuruluşun faaliyet gösterdiği ülkeler",
   "select-operating-countries-placeholder": "Faaliyet gösterilen ülkeleri seçin",
   "working-sector-label": "Çalışma sektörü",
   "select-sectors-alt-placeholder": "Sektörleri seçin",
   "contact-information-tab": "İletişim Bilgileri",
   "organizations-email-label": "Kuruluş e-postası",
   "select-base-country-placeholder": "Temel ülkeyi seçin",
   "select-a-city-placeholder": "Bir şehir seçin",
   "save-changes-button": "Değişiklikleri kaydet",

   // Profile information page (account profile edit forms)
   "name-label": "Ad",
   "city-label": "Şehir",
   "birthdate-label": "Doğum tarihi",
   "select-your-prefix": "Seçiniz",
   "area-of-expertise-colon-label": "Uzmanlık alanı:",
   "years-suffix-label": "yıl",
   "professional-details-title": "Profesyonel detaylar",
   "enter-current-password-placeholder": "Mevcut şifrenizi girin",
   "enter-new-password-placeholder": "Yeni şifrenizi girin",
   "enter-new-password-again-placeholder": "Yeni şifrenizi tekrar girin",
   "enter-your-email-placeholder": "E-postanızı girin",

   // Login information page (LoginInfo.js)
   "account-information-label": "Hesap bilgileri",
   "email-label": "E-posta",
   "current-password-label": "Mevcut şifre",
   "new-password-label": "Yeni şifre",
   "password-hint-intro-text": "Hesabınızı korumak için şifreniz en az şunları içermelidir:",
   "password-hint-length": "8 karakter",
   "password-hint-uppercase": "Bir büyük harf",
   "password-hint-lowercase": "Bir küçük harf",
   "password-hint-number": "Bir rakam",
   "password-hint-special": "Bir özel karakter",
   "change-password-here-text": "Şifrenizi buradan değiştirebilirsiniz",
   "email-changed-success-title": "E-posta başarıyla değiştirildi!",
   "email-changed-success-description": "E-postanız doğru şekilde güncellendi.",
   "email-update-error-description": "E-postanızı değiştirirken bir sorun oluştu, lütfen tekrar deneyin.",
   "password-changed-success-title": "Şifre başarıyla değiştirildi!",
   "password-changed-success-description": "Şifreniz doğru şekilde güncellendi.",
   "password-update-error-description":
      "Şifrenizi değiştirirken bir sorun oluştu, lütfen tekrar deneyin.",
   "current-password-required-validation": "Mevcut şifre gereklidir",
   "new-password-required-validation": "Yeni şifre gereklidir",
   "confirm-new-password-required-validation": "Yeni şifre onayı gereklidir",

   // Account management: deactivate/delete account (LoginInfo.js)
   "account-management-title": "Hesap yönetimi",
   "deactivate-account-title": "Hesabı devre dışı bırak",
   "deactivate-account-description":
      "Hesabınızı buradan devre dışı bırakabilirsiniz. Bu, hesabınızı geçici olarak kullanılamaz hale getirecektir. Ancak bu işlem tamamen geri alınabilir ve",
   "deactivate-account-explanation":
      "hesabınızı istediğiniz zaman tekrar giriş yaparak yeniden etkinleştirebilirsiniz.",
   "delete-account-title": "Hesabı sil",
   "delete-account-description":
      "Hesabınızı silmek, tüm verilerinizi sistemimizden kalıcı olarak kaldıracaktır.",
   "delete-account-explanation":
      "Bu işlem geri alınamaz; hesabınız silindikten sonra bilgilerinizin veya içeriğinizin hiçbirini kurtaramazsınız.",
   "delete-account-explanation-2": "Devam etmek istediğinizden eminseniz,",
   "delete-account-explanation-3":
      "hesabınızla ilişkili tüm hizmetlere ve verilere erişiminizi kaybedeceğinizi lütfen unutmayın.",
   "delete-account-modal-title": "Hesabınızı silin",
   "deactivate-account-modal-title": "Hesabınızı devre dışı bırakın",
   "delete-account-modal-description": "Gitmenize üzüldük ama kararınıza saygı duyuyoruz!",
   "deactivate-account-modal-description":
      "Bir ara mı vermeyi düşünüyorsunuz? Hesabınızı devre dışı bırakmak her zaman bir seçenektir.",
   "confirm-account-deletion-title": "Hesap silmeyi onayla",
   "confirm-account-deactivation-title": "Hesap devre dışı bırakmayı onayla",
   "confirm-delete-account-description":
      "Hesabınızı ve verilerinizi kalıcı olarak silmek üzeresiniz.",
   "confirm-deactivate-account-description": "Hesabınızı devre dışı bırakmak üzeresiniz.",
   "confirm-action-other-desc": "Devam etmek istediğinizden emin misiniz?",
   "delete-reason-1": "Artık hizmete ihtiyacım yok.",
   "delete-reason-2": "İhtiyaçlarıma daha uygun başka bir hizmet buldum.",
   "delete-reason-3": "Kötü bir deneyim yaşadım.",
   "delete-reason-4": "Veri gizliliğim konusunda endişeliyim.",
   "deactivate-reason-1": "Kısa bir molaya ihtiyacım var.",
   "deactivate-reason-2": "Şu anda platformu kullanamayacak kadar meşgulüm.",
   "deactivate-reason-3": "Kişisel meselelerle uğraşıyorum.",
   "deactivate-reason-4": "Şimdilik başka önceliklere odaklanmak istiyorum.",
   "other-please-specify-label": "Diğer (lütfen belirtin)",
   "enter-your-answer-placeholder": "Cevabınızı buraya girin",
   "delete-account-feedback-prompt":
      "Görüşünüzü duymak isteriz. Hesabınızı neden silmeyi düşündüğünüzü paylaşır mısınız?",
   "deactivate-account-feedback-prompt":
      "Görüşünüzü duymak isteriz. Hesabınızı neden devre dışı bırakmayı düşündüğünüzü paylaşır mısınız?",
   "delete-account-followup-question":
      "Bizimle olduğunuz için teşekkür ederiz. Deneyiminizi daha iyi hale getirmek için yapabileceğimiz bir şey var mıydı?",
   "deactivate-account-followup-question":
      "Her zaman gelişmeye çalışıyoruz. Önerileriniz veya yorumlarınız varsa, duymaktan mutluluk duyarız",
   "delete-account-error-description": "Hesabınızı silerken bir sorun oluştu, lütfen tekrar deneyin.",
   "deactivate-account-error-description":
      "Hesabınızı devre dışı bırakırken bir sorun oluştu, lütfen tekrar deneyin.",

   // Payment information page (PaymentInfo.js, SuccessPaymentInfo.js, FailedPaymentInfo.js)
   "choose-perfect-plan-title": "Sizin için mükemmel planı seçin",
   "billed-annually-text": "Yıllık faturalandırılır",
   "workspaces-suffix-label": "çalışma alanı",
   "members-suffix-label": "üye",
   "data-storage-limit-suffix-label": "veri depolama limiti",
   "see-all-plan-details-link": "Tüm plan detaylarını gör",
   "plan-selected-label": "Plan seçildi",
   "select-this-plan-button": "Bu planı seç",
   "view-billing-portal-button": "Faturalandırma portalını görüntüle",
   "checkout-button": "Ödeme yap",
   "active-subscription-error-description":
      "Kullanıcının zaten aktif bir aboneliği var. Lütfen farklı bir plan seçin.",
   "payment-billing-error-description":
      "Bu ödemeyi faturalandırırken bir sorun oluştu, lütfen tekrar deneyin.",
   "purchase-successful-title": "Satın alma başarılı!",
   "payment-processed-success-text": "Ödemeniz başarıyla işlendi.",
   "thank-you-for-purchase-text": "Satın aldığınız için teşekkür ederiz!",
   "go-back-to-payment-info-text": "Ödeme bilgilerine geri dön",
   "purchase-failed-title": "Satın alma başarısız oldu",
   "purchase-failed-description":
      "Maalesef, son satın alma denemeniz başarılı olmadı. Ödeme işlemede bir sorun olmuş veya verilen bilgilerde bir problem olmuş olabilir. Lütfen ödeme bilgilerinizi kontrol edip tekrar deneyin.",
   "apologize-inconvenience-text": "Yaşanan aksaklık için özür dileriz ve sabrınız için teşekkür ederiz.",

   // Profile edit form validation messages (validationSchema.js)
   "min-3-symbols-validation": "Minimum 3 karakter",
   "max-50-symbols-validation": "Maksimum 50 karakter",
   "invalid-organization-email-validation": "Geçersiz kurum e-postası",
   "organization-address-required-validation": "Kurum adresi gereklidir",
   "operating-countries-required-validation": "Faaliyet gösterilen ülkeler gereklidir",

   // Account deleted/deactivated confirmation page (AccountDeletedORDeactivated.js)
   "account-action-icon-alt": "hesap işlemi",
   "account-deactivated-notice-text": "Hesabınız talebiniz üzerine başarıyla devre dışı bırakıldı.",
   "account-deleted-notice-text": "Hesabınız talebiniz üzerine başarıyla silindi.",
   "positive-experience-farewell-text":
      "Bizimle olumlu bir deneyim yaşadığınıza inanıyoruz ve geri dönmeye karar verdiğinizde her zaman memnuniyetle karşılanacağınızı bilmenizi isteriz.",
   "kaporg-best-regards-text": "Saygılarımızla, KAPorg ekibi.",

   // Edit profile picture modal (EditProfilePicture.js)
   "edit-profile-picture-title": "Profil fotoğrafını düzenle",
   "change-profile-picture-button": "Profil fotoğrafını değiştir",
   "delete-profile-picture-button": "Profil fotoğrafını sil",
   "profile-picture-updated-success-title": "Profil fotoğrafı başarıyla güncellendi!",
   "profile-picture-updated-success-description": "Profil fotoğrafınız doğru şekilde güncellendi.",
   "profile-picture-update-error-description":
      "Profil fotoğrafınızı güncellerken bir sorun oluştu, lütfen tekrar deneyin.",
   "profile-picture-deleted-success-title": "Profil fotoğrafı başarıyla silindi!",
   "profile-picture-deleted-success-description": "Profil fotoğrafınız silindi.",
   "profile-picture-delete-error-description":
      "Profil fotoğrafınızı silerken bir sorun oluştu, lütfen tekrar deneyin.",

   "name-required-validation": "Ad gereklidir",
   "gender-required-validation": "Cinsiyet gereklidir",
   "role-required-validation": "Rol gereklidir",
   "team-member-added-success-title": "Ekip üyesi başarıyla eklendi!",
   "team-member-added-success-description": "Bu üye ekip veritabanınıza başarıyla eklendi.",
   "team-member-add-error-description":
      "Bu üyeyi ekip veritabanınıza eklerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "add-new-member-title": "Yeni üye ekle",
   "gender-label": "Cinsiyet",
   "select-gender-placeholder": "Cinsiyet seçin",
   "role-label": "Rol",
   "select-role-placeholder": "Rol seçin",
   "make-my-profile-public-button": "Profilimi herkese açık yap",
   "make-my-profile-private-button": "Profilimi özel yap",
   "make-profile-public-title": "Profili herkese açık yap",
   "make-profile-private-title": "Profili özel yap",
   "profile-visibility-notice-public":
      "Ulusal kuruluşunuzu herkese açık yaparak bağışçılar ve uzmanlar bilgilerinizi ve sonuçlarınızı görebilecek. Bu nedenle, herkese açık hale getirmeden önce tüm bilgilerinizin eksiksiz olduğundan emin olmanızı öneririz.",
   "profile-visibility-notice-private":
      "Ulusal kuruluşunuzu özel yaparak bağışçılar ve uzmanlar bilgilerinizi ve sonuçlarınızı görebilecek. Bu nedenle, özel hale getirmeden önce tüm bilgilerinizin eksiksiz olduğundan emin olmanızı öneririz.",
   "delete-member-title": "Üyeyi sil",
   "delete-member-description": "Bu üyeyi silmek üzeresiniz. Bu işlem geri alınamaz.",
   "delete-all-representative-details-title": "Tüm temsilci bilgilerini sil",
   "delete-representative-info-description-1": "Temsilcinizin tüm bilgilerini silmek üzeresiniz.",
   "delete-representative-info-description-2": "Dilerseniz daha sonra tekrar ekleyebilirsiniz.",
   "delete-representative-info-description-3":
      "Unutmayın, eksiksiz bir profile sahip olmak, topluluk içinde daha iyi görünürlük ve iletişim fırsatları için çok önemlidir.",
   "organizations-management-title": "Kuruluş yönetimi",

   "representative-updated-success-title": "Temsilci bilgileri başarıyla güncellendi!",
   "representative-updated-success-description": "Temsilci bilgileriniz doğru şekilde güncellendi.",
   "representative-update-error-description":
      "Temsilci bilgilerinizi güncellerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "edit-representative-detail-title": "Temsilci bilgisini düzenle",
   "full-name-label": "Tam Ad",
   "phone-label": "Telefon",
   "edit-representative-button": "Temsilciyi düzenle",
   "representative-added-success-title": "Temsilci bilgileri başarıyla eklendi!",
   "representative-added-success-description": "Temsilci bilgileriniz doğru şekilde eklendi.",
   "representative-add-error-description":
      "Temsilci bilgilerinizi eklerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "create-representative-detail-title": "Yeni bir temsilci bilgisi oluştur",

   "team-member-removed-success-title": "Ekip üyesi başarıyla kaldırıldı!",
   "team-member-removed-success-description": "Bu üye ekip veritabanınızdan başarıyla kaldırıldı.",
   "team-member-remove-error-description":
      "Bu üyeyi ekip veritabanınızdan kaldırırken bir sorun yaşadık, lütfen tekrar deneyin.",
   "fullname-column": "Tam ad",
   "member-search-label": "Hangi üyeyi arıyorsunuz?",
   "search-member-by-name-placeholder": "Bir üyeyi adına göre arayın",
   "add-member-button": "Üye ekle",
   "new-member-button": "Yeni üye",
   "birthdate-label": "Doğum tarihi",
   "email-field-label": "E-posta",
   "name": "Ad",
   "email": "E-posta",
   "cancel": "İptal",
   "no-assessments-listed-text": "Listelenmiş değerlendirme yok",
   "remaining-months-days-text": "{months} ay, {days} gün",
   "more-actions-label": "Diğer işlemler",
   "sort-ascending-alt": "Artan sırala",
   "sort-descending-alt": "Azalan sırala",
   "error-unauthorized-text": "Üzgünüz, bu sayfaya erişim yetkiniz yok.",
   "error-page-not-found-text": "Üzgünüz, ziyaret ettiğiniz sayfa mevcut değil.",
   "error-oops-title": "Hata...",
   "back-home-button": "Ana sayfaya dön",
   "error-something-wrong-text": "Bir şeyler ters gitti gibi görünüyor. Üzerinde çalışıyoruz",

   "requests-management-title": "Talep yönetimi",
   "archived-assessments-link": "Arşivlenmiş değerlendirmeler",
   "deleted-assessments-link": "Silinmiş değerlendirmeler",
   "add-new-assessment-button": "Yeni değerlendirme",
   "assessment-list-title": "Değerlendirmeler",
   "archive-button": "Arşivle",
   "archive-assessment-title": "Değerlendirmeyi arşivle",
   "delete-assessment-title": "Değerlendirmeyi sil",
   "archive-assessment-description": "Bu değerlendirmeyi arşivlemek üzeresiniz.",
   "delete-assessment-description": "Bu değerlendirmeyi silmek üzeresiniz.",

   "start-date-after-previous-end-validation":
      "Başlangıç tarihi önceki bitiş tarihinden büyük olmalıdır",
   "end-date-after-start-validation": "Bitiş tarihi başlangıç tarihinden büyük olmalıdır",
   "assessment-name-empty-validation": "Değerlendirme adı boş olamaz",
   "submission-round-label-empty-validation": "Gönderim turu etiketi boş olamaz",
   "date-fields-required-validation": "Tarih alanları gereklidir",
   "start-date-required-validation": "Başlangıç tarihi gereklidir",
   "end-date-required-validation": "Bitiş tarihi gereklidir",
   "assessment-created-success-title": "Değerlendirme başarıyla oluşturuldu!",
   "assessment-created-success-description":
      "Yeni bir değerlendirme oluşturuldu ve veritabanınıza eklendi.",
   "assessment-create-error-description":
      "Bu değerlendirmeyi oluştururken bir sorun yaşadık, lütfen tekrar deneyin.",
   "assessment-details-title": "Değerlendirme detayları",
   "assessment-name-label": "Değerlendirme adı",
   "enter-assessment-name-placeholder": "Değerlendirme adını girin",
   "assessment-type-label": "Değerlendirme türü",
   "submission-round-label-field": "Gönderim turu etiketi",
   "enter-submission-round-placeholder": "Gönderim turunu girin",
   "start-date-label": "Başlangıç tarihi",
   "end-date-label": "Bitiş tarihi",
   "add-new-submission-round-button": "Yeni gönderim turu ekle",
   "dynamic-range-label": "Dinamik aralık",
   "select-score-range-description":
      "Değerlendirmenizin puan değişkenleri için aralığı seçin (en fazla 5)",
   "score-variables-label": "puan değişkenleri",
   "from-label": "Başlangıç",
   "to-label": "bitiş",
   "score-label-field": "Puan etiketi",
   "score-description-field": "Puan açıklaması",
   "enter-label-description-placeholder": "Etiket için bir açıklama girin",
   "add-assessment-button": "Değerlendirme ekle",
   "assessment-assigned-success-title": "Değerlendirme başarıyla atandı!",
   "assessment-assigned-success-description":
      "Bu değerlendirme ekip üyelerinize başarıyla atandı. Bu işlem hakkında bilgilendirilecekler.",
   "assessment-assign-error-description":
      "Bu değerlendirmeyi ekip üyelerinize atarken bir sorun yaşadık, lütfen tekrar deneyin.",
   "assign-assessment-to-team-title": "Değerlendirmeyi ekibe ata",
   "project-management-label": "Proje yönetimi",

   "assessment-updated-success-title": "Değerlendirme başarıyla güncellendi!",
   "assessment-updated-success-description": "Bu değerlendirme doğru şekilde güncellendi.",
   "assessment-update-error-description":
      "Bu değerlendirmeyi güncellerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "edit-assessment-title": "Değerlendirmeyi düzenle",
   "edit-assessment-of-team-title": "Bu ekibin değerlendirmesini düzenle",
   "select-project-management-placeholder": "Proje yönetimini seçin",
   "module-assigned-success-title": "Modül başarıyla atandı!",
   "module-assigned-success-description":
      "Bu modül personel üyelerinize başarıyla atandı. Bu işlem hakkında bilgilendirilecekler.",
   "module-unassigned-success-title": "Modül ataması başarıyla kaldırıldı!",
   "module-unassigned-success-description":
      "Bu modülün ataması personel üyesi tarafından başarıyla kaldırıldı.",
   "module-assign-error-description":
      "Bu modülü personel üyelerinize atarken bir sorun yaşadık, lütfen tekrar deneyin.",
   "assign-module-to-members-title": "Modülü üyelere ata",
   "module-name-label": "Modül adı",
   "members-to-assign-label": "Bu modülün atanacağı üyeler",
   "unassign-button": "Atamayı kaldır",
   "assign-module-button": "Modülü ata",
   "member-required-validation": "Üye gereklidir",

   "comparison-created-success-title": "Yeni karşılaştırma sürümü oluşturuldu!",
   "comparison-created-success-description":
      "Yeni karşılaştırma sürümü başarıyla oluşturuldu ve incelemeye hazır.",
   "comparison-create-error-description":
      "Bu karşılaştırma sürümünü oluştururken bir sorun yaşadık, lütfen tekrar deneyin.",
   "duplicate-for-comparison-title": "Karşılaştırma için çoğalt",
   "duplicate-comparison-description-1":
      "Bu, değerlendirmenin bir kopyasını oluşturacak ve sonuç karşılaştırması için her iki sürümü bağlayacaktır.",
   "duplicate-comparison-description-2":
      "Çoğaltıldıktan sonra, değerlendirmeler ve ilişkili modüller değiştirilemez.",
   "current-assessment-label": "Mevcut değerlendirme",
   "new-comparison-version-label": "Yeni karşılaştırma sürümü",
   "comparison-suffix-label": "Karşılaştırma",
   "duplicate-comparison-note":
      "Not: Gerekirse, bağlantıyı daha sonra kaldırarak bunları bağımsız olarak düzenleyebilirsiniz, ancak karşılaştırma artık kullanılamayacaktır.",
   "duplicate-button": "Çoğalt",
   "assessments-unlinked-success-title": "Değerlendirmelerin bağlantısı kaldırıldı!",
   "assessments-unlinked-success-description":
      "Değerlendirmelerin bağlantısı başarıyla kaldırıldı ve artık bağımsız olarak düzenlenebilirler.",
   "assessments-unlink-error-description":
      "Değerlendirmelerin bağlantısını kaldırırken bir sorun yaşadık, lütfen tekrar deneyin.",
   "unlink-assessments-title": "Bu değerlendirmelerin bağlantısı kaldırılsın mı?",
   "unlink-assessments-description":
      "Artık karşılaştırma için bağlı olmayacaklar ve karşılaştırma görünümü artık kullanılamayacak.",
   "original-assessment-label": "Orijinal Değerlendirme",
   "duplicated-assessment-label": "Çoğaltılmış Değerlendirme",
   "unlink-assessments-note":
      "Not: Bağlantı kaldırıldıktan sonra, her değerlendirme bağımsız olarak düzenlenebilir.",
   "unlink-button": "Bağlantıyı kaldır",
   "expert-name-column": "Uzman adı",
   "years-of-experience-column": "Deneyim yılı",
   "expert-cv-column": "Uzman Özgeçmişi",
   "cv-link-text": "Özgeçmiş Bağlantısı",
   "no-cv-available-text": "Özgeçmiş Mevcut Değil",
   "areas-of-expertise-column": "Uzmanlık alanları",
   "select-expert-request-access-title": "Bir uzman seçin ve erişim talep edin",
   "first-choose-expert-subtitle": "Önce bir uzman seçin",
   "choose-expert-guide-hint": "Değerlendirmenizi yönlendirecek bir uzman seçin",
   "request-access-button": "Erişim talep et",
   "go-back-experts-list-link": "Uzman listesine geri dön",
   "no-description-available-text": "Açıklama mevcut değil",
   "no-expertise-listed-text": "Uzmanlık listelenmemiş",
   "nationality-label": "Uyruk",
   "no-nationality-listed-text": "Uyruk listelenmemiş",
   "country-of-residence-label": "İkamet ülkesi",
   "no-country-of-residence-text": "İkamet ülkesi yok",
   "no-operating-countries-listed-text": "Faaliyet gösterilen ülke listelenmemiş",
   "linkedin-profile-label": "LinkedIn profili",
   "no-linkedin-profile-text": "LinkedIn profili sağlanmadı",
   "no-phone-number-listed-text": "Telefon numarası listelenmemiş",
   "highest-degree-label": "Alınan en yüksek derece",
   "no-highest-degree-listed-text": "Alınan en yüksek derece listelenmemiş",
   "fields-of-study-label": "Çalışma alanları",
   "no-study-fields-listed-text": "Çalışma alanı listelenmemiş",
   "educational-institution-label": "Eğitim kurumu",
   "no-educational-institution-listed-text": "Eğitim kurumu listelenmemiş",
   "languages-label": "Diller",
   "no-languages-listed-text": "Dil listelenmemiş",
   "cv-label": "Özgeçmiş",
   "no-cv-listed-text": "Özgeçmiş listelenmemiş",
   "certification-training-label": "Sertifika veya özel eğitim",
   "no-certification-listed-text": "Sertifika veya özel eğitim listelenmemiş",

   "archived-assessments-list-title": "Arşivlenmiş Değerlendirmeler listesi",
   "deleted-assessments-title": "Silinen Değerlendirmeler",
   "delete-permanently-button": "Kalıcı olarak sil",
   "unarchive-assessments-button": "Değerlendirmelerin arşivini kaldır",
   "restore-assessments-button": "Değerlendirmeleri geri yükle",
   "deleted-assessments-description":
      "Burada silinen değerlendirmeleri görüntüleyebilir ve geri yükleyebilirsiniz. 60 gün içinde geri yüklenmeyen değerlendirmeler kalıcı olarak silinecektir.",
   "delete-assessment-permanently-title": "Değerlendirmeyi kalıcı olarak sil",
   "delete-assessments-permanently-title": "Değerlendirmeleri kalıcı olarak sil",
   "delete-selected-assessment-permanently-description":
      "Seçili değerlendirmeyi kalıcı olarak silmek üzeresiniz.",
   "delete-selected-assessments-permanently-description":
      "Seçili değerlendirmeleri kalıcı olarak silmek üzeresiniz.",
   "action-cannot-be-undone-confirm-text":
      "Bu işlem geri alınamaz. Devam etmek istediğinizden emin misiniz?",

   "request-sent-success-title": "İstek başarıyla gönderildi!",
   "request-sent-success-description":
      "İsteğiniz yöneticiye gönderildi. İstek yanıtlandığında yanıtla birlikte bir e-posta alacaksınız.",
   "request-send-error-description": "İsteğinizi gönderirken bir sorun yaşadık, lütfen tekrar deneyin.",
   "request-rejected-title": "Ah hayır! İsteğiniz reddedilmiş görünüyor",
   "request-rejected-description-line1":
      "Şu anda bu değerlendirmeye erişemezsiniz çünkü isteğiniz reddedildi.",
   "request-rejected-description-line2": "Ama endişelenmeyin! Tekrar erişim talep edebilirsiniz.",
   "request-pending-title": "Bu değerlendirme için zaten erişim talep ettiniz!",
   "request-pending-description-line1":
      "İsteğiniz bu değerlendirmenin yöneticisine gönderildi. İstek yanıtlandığında yanıtla birlikte bir e-posta alacaksınız.",
   "request-pending-description-line2": "En kısa sürede sizinle iletişime geçeceğiz.",
   "request-access-title": "Bu değerlendirme için erişim talep edin",
   "request-access-description-part1": "Bu rehberli değerlendirmenin kilidini açın böylece",
   "request-access-description-part2": "uzmanlarımızı atayabiliriz",
   "request-access-description-part3": "çalışma alanınızdan",
   "request-access-description-part4":
      "değerlendirme süreci boyunca size doğrudan destek olmaları için",
   "request-access-description-part5":
      "ve daha iyi ortaklıklar kurmanın ve gelecekteki programlar için finansman sağlamanın yollarını keşfetmenize yardımcı olabiliriz.",

   "guided-assessments-title": "Rehberli Değerlendirmeler",
   "assessments-list-title": "Değerlendirmeler listesi",
   "organizations-name-column": "Kuruluşun adı",
   "assessment-column": "Değerlendirme",
   "status-column": "Durum",
   "not-started-status": "Başlamadı",
   "in-progress-status": "Devam ediyor",
   "completed-status": "Tamamlandı",

   "success-title": "Başarılı",
   "module-submitted-success-description": "Modül başarıyla gönderildi",
   "no-submission-rounds-text": "Gönderim turu yok",
   "submission-rounds-title": "Gönderim turları",
   "round-target-label": "Hedef",
   "module-submitted-modal-title": "Bu modülü başarıyla gönderdiniz!",
   "next-round-active-description":
      "Lütfen bir sonraki gönderim turu aktif olduğunda bu değerlendirmeye geri dönün.",
   "remaining-time-current-round-label": "Mevcut turun kalan süresi",
   "start-label": "Başlangıç",
   "end-label": "Bitiş",
   "linked-modules-title": "Bağlı modüller",
   "no-linked-modules-text": "Bağlı modül yok",
   "finished-status": "Tamamlandı",
   "completed-text": "tamamlandı",

   "assigned-to-label": "Atanan",
   "assign-member-button": "Üye ata",
   "submitted-at-label": "Gönderim tarihi",
   "edit-assignment-button": "Atamayı düzenle",
   "assign-to-team-button": "Ekibe ata",
   "assessment-assigned-to-label": "Değerlendirme şuna atandı:",
   "expert-modules-description":
      "Bunlar, seçtiğiniz uzmanın yanıtlayacağı modüllerdir. Uzman modülleri gönderdiğinde, sonuçları ve yanıtları Sonuçlar bölümünde görüntüleyebileceksiniz.",

   "no-self-assessments-yet-title":
      "Görünüşe göre bu çalışma alanında henüz öz değerlendirme yok!",
   "no-guided-assessments-yet-title":
      "Görünüşe göre bu çalışma alanında henüz rehberli değerlendirme yok!",
   "work-on-guided-assessments-instead-description":
      "Ama endişelenmeyin, bunun yerine rehberli değerlendirmeler üzerinde çalışabilirsiniz.",
   "work-on-self-assessments-instead-description":
      "Ama endişelenmeyin, bunun yerine öz değerlendirmeler üzerinde çalışabilirsiniz.",

   "name-column": "Ad",
   "type-column": "Tür",
   "created-by-column": "Oluşturan",
   "created-date-column": "Oluşturulma tarihi",
   "edit-action": "Düzenle",
   "founded-label": "Kuruluş",
   "areas-label": "alan",
   "staff-label": "personel",
   "contact-label": "İletişim",
   "online-label": "Çevrimiçi",
   "unlink-assessment-action": "Değerlendirme Bağlantısını Kaldır",
   "edit-assessment-alt": "Değerlendirmeyi düzenle",
   "archive-assessment-alt": "Değerlendirmeyi arşivle",
   "delete-assessment-alt": "Değerlendirmeyi sil",
   "unlink-assessment-alt": "Değerlendirme bağlantısını kaldır",

   "assessment-deleted-success-title": "Değerlendirme başarıyla silindi!",
   "assessment-deleted-success-description": "Bu değerlendirme veritabanınızdan başarıyla silindi.",
   "assessment-delete-error-description":
      "Bu değerlendirmeyi silerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "assessments-deleted-success-title": "Değerlendirmeler başarıyla silindi!",
   "assessments-deleted-success-description":
      "Bu değerlendirmeler veritabanınızdan başarıyla silindi.",
   "assessments-delete-error-description":
      "Bu değerlendirmeleri silerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "assessment-restored-success-title": "Değerlendirme başarıyla geri yüklendi!",
   "assessment-restored-success-description": "Bu değerlendirme başarıyla geri yüklendi.",
   "assessment-unarchive-error-description":
      "Bu değerlendirmenin arşivini kaldırırken bir sorun yaşadık, lütfen tekrar deneyin.",
   "assessments-unarchived-success-title": "Değerlendirmelerin arşivi başarıyla kaldırıldı!",
   "assessments-unarchived-success-description":
      "Bu değerlendirmelerin arşivi başarıyla kaldırıldı.",
   "assessments-unarchive-error-description":
      "Bu değerlendirmelerin arşivini kaldırırken bir sorun yaşadık, lütfen tekrar deneyin.",
   "assessment-archived-success-title": "Değerlendirme başarıyla arşivlendi!",
   "assessment-archived-success-description": "Bu değerlendirme başarıyla arşivlendi.",
   "assessment-archive-error-description":
      "Bu değerlendirmeyi arşive eklerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "assessment-trashed-success-title": "Değerlendirme çöp kutusuna başarıyla eklendi!",
   "assessment-trashed-success-description": "Bu değerlendirme çöp kutusuna başarıyla eklendi.",
   "assessment-trash-error-description":
      "Bu değerlendirmeyi çöp kutusuna eklerken bir sorun yaşadık, lütfen tekrar deneyin.",

   "assessment-modules-title": "Değerlendirme Modülleri",
   "module-name-column": "Modül Adı",
   "go-to-module-button": "Modüle Git",

   "consultant-organization-list-title": "Danışman Kuruluş listesi",
   "country-column": "Ülke",
   "progress-column": "İlerleme",
   "submitted-status": "Gönderildi",
   "go-to-assessment-button": "Değerlendirmeye git",

   "module-submitted-toast": "Modül başarıyla gönderildi.",
   "no-permission-submit-module-warning": "Bir modül göndermek için izniniz yok!",
   "submit-button": "Gönder",
   "module-submitted-text": "Bu modül gönderildi.",

   "choose-consultant-guide-title": "Değerlendirmenize rehberlik edecek bir danışman seçin",
   "consultant-profile-title": "Danışman Profili",
   "consultant-label": "Danışman",
   "experience-title": "Deneyim",
   "education-title": "Eğitim",
   "school-label": "Okul",
   "skills-title": "Beceriler",
   "select-this-consultant-button": "Bu Danışmanı Seç",
   "enrolled-guided-assessment-success-title": "Rehberli değerlendirmeye başarıyla kaydoldunuz!",
   "consultant-contact-soon-description-part1": "Danışman",
   "consultant-contact-soon-description-part2":
      "değerlendirmelerinize başlamak için yakında sizinle iletişime geçecek.",
   "go-to-assessments-button": "Değerlendirmelere git",

   "improve-score-help-title":
      "Puanınızı iyileştirmek ve kuruluşunuzu daha da büyütmek isterseniz, KAPorg ekibi size yardımcı olmak için burada!",
   "request-guided-assessment-description-part1":
      "Uzmanlarımızı çalışma alanınızdan atayarak değerlendirme süreci boyunca size doğrudan destek olmalarını ve daha iyi ortaklıklar kurmanın ve gelecekteki programlar için finansman sağlamanın yollarını keşfetmenize yardımcı olmalarını sağlamak için şimdi rehberli bir değerlendirme talep edin.",
   "request-guided-assessment-description-part2":
      "Şimdi talep edin, en kısa sürede sizinle iletişime geçeceğiz.",
   "request-assessment-code-button": "Değerlendirme kodu talep et",
   "have-assessment-code-button": "Bir değerlendirme kodum var",
   "assessment-code-title": "Değerlendirme kodu",
   "enter-assessment-code-description":
      "Değerlendirmenize erişmek için lütfen değerlendirme kodunuzu aşağıya yazın",
   "enter-code-here-label": "Kodunuzu buraya girin",
   "please-enter-code-error": "Lütfen kodu girin",
   "assessment-list-label": "Değerlendirmeler listesi",
   "select-an-assessment-placeholder": "-Bir değerlendirme seçin-",
   "select-assessment-error": "Bir değerlendirme seçmelisiniz",
   "submit-request-button": "Talebi gönder",
   "request-assessment-code-title": "Değerlendirme Kodu Talep Et",
   "request-assessment-code-description":
      "Lütfen değerlendirmenizi talep edin, sizinle iletişime geçeceğiz. Talep kabul edildiğinde kodu içeren bir e-posta alacaksınız.",
   "select-assessment-from-list-description": "Aşağıdaki listeden bir değerlendirme seçin",
   "code-valid-select-consultant-toast": "Kodunuz geçerliydi ve artık danışmanı seçebilirsiniz",

   "my-modules-tab": "Modüllerim",
   "template-library-tab": "Şablon kütüphanesi",

   "module-deleted-success-title": "Modül başarıyla silindi!",
   "module-deleted-success-description": "Bu modül veritabanınızdan başarıyla kaldırıldı.",
   "module-delete-error-description":
      "Bu modülü silerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "module-cannot-be-deleted-error": "Modül silinemez",
   "preview-action": "Önizle",
   "download-action": "İndir",
   "turn-into-template-action": "Şablona dönüştür",
   "preview-template-alt": "Şablonu önizle",
   "edit-module-alt": "Modülü düzenle",
   "download-module-alt": "Modülü indir",
   "turn-into-template-alt": "Şablona dönüştür",
   "delete-module-alt": "Modülü sil",
   "title-column": "Başlık",
   "deleted-modules-button": "Silinen modüller",
   "add-module-button": "Yeni modül",
   "add-module-modal-button": "Modül ekle",
   "add-new-module-title": "Yeni modül ekle",
   "add-new-assessment-title": "Yeni değerlendirme ekle",
   "survey-status-editing": "Düzenleniyor",
   "survey-status-archived": "Arşivlendi",
   "survey-status-deployed": "Yayınlandı",
   "survey-status-locked": "Kilitli",

   "how-start-title": "Nasıl başlamak istersiniz?",
   "create-form-title": "Form oluştur",
   "create-form-description": "Boş bir yapıyla başlayın, ilerledikçe bölümler ve sorular ekleyin.",
   "import-form-title": "Form içe aktar",
   "import-form-description": "Önceden tanımlanmış bölümler ve sorular içeren bir dosya yükleyin.",
   "use-template-title": "Bir şablon kullan",
   "use-template-description":
      "Sistemde zaten kayıtlı bir formla başlayın ve ihtiyaçlarınıza göre kolayca ayarlayın.",
   "continue-button": "Devam et",

   "module-details-title": "Modül Detayları",
   "enter-module-name-placeholder": "Modül adını girin",
   "enter-module-description-placeholder": "Modül açıklamasını girin",
   "default-language-label": "Varsayılan dil",
   "select-default-language-module-placeholder": "Modülün varsayılan dilini seçin",
   "select-assessment-label": "Değerlendirme Seç",
   "select-assessment-module-placeholder": "Modülün değerlendirmesini seçin",

   "delete-module-title": "Modülü sil",
   "delete-template-title": "Şablonu sil",
   "delete-module-confirm-description": "Bu modülü silmek üzeresiniz. Bu işlem geri alınamaz.",
   "delete-template-confirm-description": "Bu şablonu silmek üzeresiniz. Bu işlem geri alınamaz.",

   "module-restored-success-title": "Modül başarıyla geri yüklendi!",
   "module-restored-success-description": "Bu modül başarıyla geri yüklendi.",
   "module-restore-error-description":
      "Bu modülü geri yüklerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "deleted-modules-list-title": "Silinen modüller listesi",
   "restore-modules-button": "Modülleri geri yükle",
   "deleted-modules-description":
      "Burada silinen modülleri görüntüleyebilir ve geri yükleyebilirsiniz. 60 gün içinde geri yüklenmeyen modüller kalıcı olarak silinecektir.",

   "module-name-required-validation": "Modül adı zorunludur",
   "upload-module-file-label": "Modül dosyasını yükle",
   "drag-drop-file-text": "Dosyayı buraya sürükleyip bırakın veya",
   "click-to-select-file-text": "dosya seçmek için tıklayın",
   "max-file-size-text": "Maksimum dosya boyutu: 20MB",

   "module-create-error-description": "Bu modülü oluştururken bir sorun yaşadık, lütfen tekrar deneyin.",
   "make-module-template-label": "Bu modülü bir şablon yap",

   "not-a-xlsx-file-error": "xlsx dosyası değil",
   "upload-valid-xlsx-error": "Lütfen göndermeden önce geçerli bir xlsx dosyası yükleyin.",
   "error-title": "Hata",
   "survey-imported-success-description": "Modül başarıyla içe aktarıldı",
   "survey-import-failed-error": "Modül içe aktarılamadı.",
   "copy-file-name-tooltip": "Dosya adını kopyala",
   "copied-tooltip": "Kopyalandı!",
   "module-must-have-right-format-text":
      "Modülünüzün doğru şekilde içe aktarılması için doğru formatta olması gerekir.",
   "download-format-link": "Formatı indir",
   "enter-description-placeholder": "Açıklama girin",

   "min-3-characters-validation": "En az 3 karakter",
   "language-required-validation": "Dil zorunludur",
   "assessment-required-validation": "Değerlendirme zorunludur",
   "new-module-suffix": "Yeni Modül",

   "edit-module-title": "Modülü düzenle",
   "module-description-label": "Modül açıklaması",

   "template-deleted-success-title": "Şablon başarıyla silindi!",
   "template-deleted-success-description": "Bu şablon veritabanınızdan başarıyla kaldırıldı.",
   "template-delete-error-description":
      "Bu şablonu silerken bir sorun yaşadık, lütfen tekrar deneyin.",
   "edit-template-alt": "Şablonu düzenle",
   "download-template-alt": "Şablonu indir",
   "duplicate-template-alt": "Şablonu çoğalt",
   "delete-template-alt": "Şablonu sil",
   "copy-action": "Kopyala",
   "module-title-column": "Modül başlığı",
   "created-on-column": "Oluşturulma tarihi",
   "last-updated-column": "Son güncelleme",

   "copy-suffix-label": "Kopya",
   "template-duplicated-success-title": "Şablon başarıyla çoğaltıldı!",
   "template-duplicated-success-description":
      "Şablonunuz başarıyla çoğaltıldı. Artık yeni kopyayı düzenleyebilir ve özelleştirebilirsiniz.",
   "template-duplicate-error-description":
      "Bu şablonu çoğaltırken bir sorun yaşadık, lütfen tekrar deneyin.",
   "copy-template-title": "Şablonu kopyala",
   "copy-template-description":
      "Bu modülün yapısına dayalı olarak yeniden kullanılabilir bir şablon oluşturmak üzeresiniz. Bu şablonu yeni modüller oluşturmak için hızlıca kullanabileceksiniz.",
   "template-name-label": "Şablon adı",
   "template-name-required-validation": "Şablon adı zorunludur",
   "enter-template-name-placeholder": "Şablon adını girin",
   "description-optional-label": "(isteğe bağlı)",
   "template-description-hint-placeholder":
      "Ekibinizin bu şablonu ne zaman kullanacağını anlamasına yardımcı olacak kısa bir not",

   "no-templates-found-title": "Şablon bulunamadı",
   "no-templates-found-description":
      "Şu anda kullanılabilir şablon yok. Daha sonra tekrar deneyin veya yeni bir tane oluşturun!",
   "sections-label": "Bölümler:",
   "use-template-button": "Şablonu kullan",

   "template-created-success-title": "Şablon başarıyla oluşturuldu!",
   "template-created-success-description":
      "Yeni şablonunuz bu modülün yapısından oluşturuldu. Artık onu düzenleyebilir veya yeni modüller oluşturmak için hızlıca kullanabilirsiniz.",
   "template-create-error-description":
      "Bu şablonu oluştururken bir sorun yaşadık, lütfen tekrar deneyin.",
   "convert-module-to-template-title": "Modülü şablona dönüştür",
   "module-label": "Modül",
   "structure-logic-copied-note":
      "Not: Yalnızca yapı ve mantık kopyalanacak, yanıtlar dahil edilmeyecektir.",
   "create-template-button": "Şablon oluştur",

   "fetch-drafts-error": "Taslaklar getirilemedi",
   "module-saved-draft-success": "Modül taslak olarak başarıyla kaydedildi",
   "save-draft-error": "Taslak kaydedilemedi",
   "reject-module-error": "Modül reddedilemedi",
   "submit-module-error": "Modül gönderilemedi",
   "preview-other-modules-text": "Bu değerlendirmedeki diğer modülleri önizle",
   "my-saved-drafts-button": "Kayıtlı taslaklarım",
   "save-as-draft-button": "Taslak olarak kaydet",
   "processing-text": "İşleniyor...",
   "submit-module-button": "Modülü gönder",
   "reject-module-button": "Modülü reddet",
   "approve-module-button": "Modülü onayla",

   "change-status-button": "Durumu değiştir",
   "change-module-status-editing-title": "Modül durumunu Düzenleniyor olarak değiştir",
   "change-module-status-editing-confirm-description":
      "Modül durumunu Düzenleniyor olarak değiştirmek üzeresiniz.",

   "language-label": "Dil",
   "select-language-placeholder": "Dil seçin",
   "print-module-button": "Modülü Yazdır",

   "save-as-draft-title": "Taslak olarak kaydet",
   "save-draft-description":
      "Bu modülün taslağını kaydetmek için, daha sonra inceleyebilmeniz için bir ad verin. Kaydettiğiniz taslaklar veritabanımızda saklanır.",
   "save-draft-button": "Taslağı Kaydet",

   "start-new-draft-button": "Yeni bir taslak başlat",
   "my-saved-draft-title": "Kayıtlı taslağım",
   "unsubmitted-drafts-description": "Bu modül için gönderilmemiş taslaklarınız var.",
   "continue-draft-or-new-question":
      "Bir taslakla devam etmek mi yoksa yeni bir tane mi başlatmak istiyorsunuz?",
   "my-draft-label": "Taslağım",
   "no-drafts-found-text": "Taslak bulunamadı. Yeni bir taslak başlatın.",

   "submit-module-confirm-description-part1":
      "Bu modülü göndermek üzeresiniz. Devam ettiğinizde, yanıtlarınız incelenmek ve onaylanmak üzere proje yöneticisine gönderilecektir.",
   "submit-module-confirm-description-part2":
      "Gönderildikten sonra herhangi bir değişiklik yapamayacağınız için lütfen tüm yanıtlarınızın doğru olduğundan emin olun.",

   "approve-request-confirm-description":
      "Bu isteği onaylamak üzeresiniz. Bu işlem geri alınamaz.",
   "feedback-required-validation": "Geri bildirim gereklidir",
   "reject-module-description-part1":
      "Lütfen bu modülün neden reddedildiğine dair ayrıntılı geri bildirim sağlayın.",
   "reject-module-description-part2":
      "Bu, sorumlu ekip üyesinin gerekli düzeltmeleri yapması için bir rehber görevi görecektir.",
   "why-rejecting-module-label": "Bu modülü neden reddediyorsunuz?",
   "enter-rejection-reason-placeholder": "Lütfen reddetme nedenini girin",

   "module-status-label": "Modül durumu:",
   "survey-status-published": "Yayınlandı",
   "edit-module-details-tooltip": "Modül Detaylarını Düzenle",
   "page-preparing-text": "Sayfa hazırlanıyor...",

   "add-section-to-module-tooltip": "Modüle bölüm ekle",
   "add-inner-section-tooltip": "İç bölüm ekle",

   "question-type-section": "Bölüm",
   "question-type-select-one": "Birini seç",
   "question-type-text": "Metin",
   "question-type-file-upload": "Dosya yükle",
   "question-type-date": "Tarih",
   "question-type-phone-number": "Telefon numarası",
   "question-type-rating": "Değerlendirme",
   "question-type-ranking": "Sıralama",
   "question-type-select-multiple": "Birden fazla seç",
   "question-type-note": "Not",
   "question-type-date-time": "Tarih ve saat",
   "question-type-time": "Saat",
   "question-type-number": "Sayı",
   "question-type-acknowledge": "Onay",
   "question-type-matrix": "Matris",
   "type-section-label-placeholder": "Lütfen bölüm etiketinizi yazın",
   "type-question-label-placeholder": "Lütfen soru etiketinizi yazın",

   "option-placeholder": "Seçenek",
   "enter-note-text-above": "Lütfen not metninizi yukarıya girin.",
   "calculate-question-coming-soon": "Hesaplama sorusu - yakında...",
   "file-upload-caps-label": "DOSYA YÜKLE",
   "items-to-be-ranked-label": "Sıralanacak öğeler",
   "text-question-type-label": "Metin Soru Türü",
   "question-displayed-as-table-text": "Bu soru bir tablo olarak görüntülenecek",
   "row-questions-title": "Satır soruları",
   "columns-questions-title": "Sütun soruları",
   "allow-numbers-range-only-text": "Yalnızca bir aralıktan sayılara izin ver",
   "gps-question-coming-soon": "GPS sorusu - yakında...",
   "type-label-optional-placeholder": "Bir etiket yazın (isteğe bağlı)",
   "optional-placeholder": "İsteğe bağlı",
   "reverse-answers-order-button": "Yanıt sırasını tersine çevir",
   "type-answer-choice-placeholder": "Bir yanıt seçeneği yazın",
   "label-text": "Etiket",
   "select-an-option-placeholder": "Bir seçenek seçin",
   "select-a-scale-placeholder": "Bir ölçek seçin",
   "enter-bulk-action-placeholder": "Toplu işlem girin",
   "to-divider-label": "Bitiş",
   "collect-date-info-text": "Tarih bilgisi topla",
   "collect-time-info-text": "Saat bilgisi topla",
   "collect-phone-number-info-text": "Telefon numarası bilgisi topla",
   "type-a-question-placeholder": "Bir soru yazın",
   "min-label": "min:",
   "max-label": "maks:",
   "max-options-chosen-text": "Seçilebilecek maksimum seçenek sayısı",
   "all-options-label": "Tümü",
   "answer-genius-label": "Cevap dehası",
   "add-choices-button": "Seçenek Ekle",
   "bulk-actions-label": "Toplu İşlemler",
   "enter-each-answer-choice-line-text": "Her yanıt seçeneğini ayrı bir satıra girin.",

   // Question editor (admin/survey v2) - EditorFooter, QuestionEditorWrapper
   "required-answer-label": "Zorunlu cevap",
   "delete-question-confirm-title": "Bu soruyu silmek istediğinizden emin misiniz?",
   "delete-section-confirm-title": "Bu bölümü silmek istediğinizden emin misiniz?",
   "this-action-cannot-be-undone-text": "Bu işlem geri alınamaz",
   "yes-confirm-button": "Evet",
   "no-confirm-button": "Hayır",
   "add-new-question-button": "Yeni soru ekle",
   "add-new-inner-section-button": "Yeni alt bölüm ekle",
   "add-new-section-button": "Yeni bölüm ekle",

   // Skip logic (admin/survey v2)
   "show-logic-button": "Mantığı Göster",
   "display-condition-prefix-text": "Göster",
   "question-word-label": "Soru",
   "when-following-conditions-apply-text": "aşağıdaki koşullar sağlandığında:",
   "add-another-condition-button": "Başka Koşul Ekle",
   "should-match-all-the-criteria-placeholder-text": "tüm kriterlerle eşleşmelidir",
   "should-match-all-of-these-criteria-text": "bu kriterlerin tümüyle eşleşmelidir",
   "should-match-any-of-these-criteria-text": "bu kriterlerden herhangi biriyle eşleşmelidir",
   "operator-was-not-answered-label": "Yanıtlanmadı",
   "operator-was-answered-label": "Yanıtlandı",
   "operator-equals-label": "Eşittir (=)",
   "operator-not-equals-label": "Eşit değildir (!=)",
   "operator-greater-than-label": "Büyüktür (>)",
   "operator-less-than-label": "Küçüktür (<)",
   "operator-greater-than-or-equal-label": "Büyük veya eşittir (>=)",
   "operator-less-than-or-equal-label": "Küçük veya eşittir (<=)",

   // Question submission types (admin/survey v2 preview/answer rendering)
   "field-required-text": "Bu alan zorunludur",
   "type-your-answer-here-placeholder": "Cevabınızı buraya yazın",
   "you-must-select-text": "Seçim yapmalısınız",
   "you-must-enter-date-and-time-text": "Bir tarih ve saat girmelisiniz",
   "you-must-enter-a-number-text": "Bir sayı girmelisiniz",
   "drag-drop-files-text": "Dosyaları buraya sürükleyip bırakın veya seçmek için tıklayın",
   "uploaded-file-label": "Yüklenen Dosya:",
   "you-must-upload-file-text": "Bir dosya yüklemelisiniz",
   "all-rankings-must-be-selected-text": "Tüm sıralamalar seçilmelidir",
   "please-specify-placeholder": "Lütfen belirtin",
   "you-can-select-up-to-text": "En fazla",
   "choices-suffix-text": "seçenek seçebilirsiniz.",
   "you-must-select-at-least-one-text": "En az bir seçim yapmalısınız",
   "you-must-select-one-text": "Bir seçim yapmalısınız",
   "you-must-select-a-time-text": "Bir saat seçmelisiniz",

   // Approver feature (survey Preview + approve/reject modals)
   "no-submission-made-yet-text": "Bu modül için henüz herhangi bir gönderim yapılmadı.",
   "approval-successful-title": "Başarılı",
   "submission-approved-successfully-text": "Gönderim başarıyla onaylandı",
   "fetch-submission-answers-error": "Gönderim yanıtları alınamadı",
   "approve-without-review-button": "İncelemeden onayla",
   "send-for-approval-button": "Onaya gönder",
   "approve-module-pending-approver-description":
      "Bu modülü onaylamak üzeresiniz. İşleme devam ettiğinizde, durumu şu şekilde işaretlenmeden önce nihai inceleme için onaylayıcıya gönderilecektir:",
   "approve-module-final-description-part1":
      "Bu modül için nihai onayı vermek üzeresiniz. İşleme devam ettiğinizde durumu şu şekilde işaretlenecektir:",
   "approve-module-final-description-part2":
      "ve sonuçları analiz için kullanılabilir olacaktır. Bu işlem geri alınamaz. Devam etmek istediğinizden emin misiniz?",
   "send-to-approver-for-review-label": "Nihai inceleme için onaylayıcıya gönder",
   "approver-review-recommended-hint": "Önerilir - bunu atlamak modülü hemen sonlandırır.",
   "skipping-approver-review-warning-text":
      "Onaylayıcı incelemesini atlıyorsunuz. Bu modül ikinci bir kontrol yapılmadan tamamlanacak.",
   "enter-detailed-feedback-placeholder": "Lütfen ayrıntılı geri bildiriminizi buraya yazın",

   // Approver management (admin/approver)
   "department-team-label": "Departman/Ekip",
   "enter-approver-name-placeholder": "Onaylayıcı adını girin",
   "enter-approver-email-placeholder": "Onaylayıcı e-postasını girin",
   "enter-approver-department-placeholder": "Onaylayıcı departmanını girin",
   "approver-added-success-title": "Onaylayıcı başarıyla eklendi!",
   "approver-added-success-description": "Bu onaylayıcı artık değerlendirmelere atanabilir.",
   "approver-updated-success-title": "Onaylayıcı başarıyla güncellendi!",
   "approver-updated-success-description": "Bu onaylayıcının bilgileri güncellendi.",
   "approver-add-error-description": "Bu onaylayıcıyı eklerken bir sorun oluştu, lütfen tekrar deneyin.",
   "approver-update-error-description": "Bu onaylayıcıyı güncellerken bir sorun oluştu, lütfen tekrar deneyin.",
   "approver-delete-error-description": "Bu onaylayıcıyı silerken bir sorun oluştu, lütfen tekrar deneyin.",
   "approver-deleted-success-title": "Onaylayıcı başarıyla silindi!",
   "approver-deleted-success-description": "Bu onaylayıcı kaldırıldı.",
   "delete-approver-title": "Onaylayıcıyı sil",
   "delete-approver-confirm-text": "Bu onaylayıcıyı silmek üzeresiniz.",
   "add-approver-title": "Onaylayıcı Ekle",
   "edit-approver-title": "Onaylayıcıyı Düzenle",
   "add-approver-button": "Onaylayıcı ekle",
   "approvers-title": "Onaylayıcılar",
   "search-approver-by-name-placeholder": "Adına göre bir onaylayıcı ara",
   "filter-approvers-by-department-placeholder": "Onaylayıcıları departmana göre filtrele",

   // Approver submissions (approver-facing pages)
   "no-data-text": "Veri yok",
   "submitted-by-column": "Gönderen",
   "pending-modules-title": "Beklemedeki modüller",
   "approved-modules-title": "Onaylanan modüller",
   "rejected-modules-title": "Reddedilen modüller",
   "filter-tasks-by-submission-date-placeholder": "Görevleri gönderim tarihine göre filtrele",
   "module-approvals-title": "Modül onayları",
   "pending-modules-review-description":
      "Bu, incelemenizi bekleyen modüllerin listesidir. Devam etmek için, kabul veya reddedebileceğiniz her modüle tıklayın.",
   "the-approver-label": "onaylayıcı",
   "approver-label": "Onaylayıcı",
   "select-an-approver-placeholder": "Bir onaylayıcı seçin",
   "go-to-revise-module-button": "Modülü düzeltmeye git",
   "rejected-module-information-title": "Reddedilen modül bilgisi",
   "feedback-from-label-prefix": "Şu kişiden geri bildirim:",
   "the-project-manager-label": "proje yöneticisi",
   "awaiting-approver-status": "Onaylayıcı bekleniyor",

   // Editor page, edit panel, edit survey details (admin/survey v2 editor)
   "module-title-label": "Modül başlığı",
   "enter-module-title-placeholder": "Modül başlığını girin",
   "module-description-label": "Modül Açıklaması",
   "assigned-assessment-label": "Atanan Değerlendirme",
   "survey-updated-success-title": "Anket başarıyla güncellendi!",
   "module-updated-success-description": "Bu modül doğru şekilde güncellendi.",
   "edit-module-error-description": "Bu modülü düzenlerken bir sorun oluştu, lütfen tekrar deneyin.",
   "form-builder-tab-label": "Form Oluşturucu",
   "logic-builder-tab-label": "Mantık Oluşturucu",
   "translate-questions-tab-label": "Soruları Çevir",
   "score-questions-tab-label": "Soruları Puanla",
   "stay-here-button": "Burada kal",
   "change-tab-button": "Sekmeyi değiştir",
   "unsaved-progress-title": "Kaydedilmemiş ilerleme",
   "unsaved-changes-tab-text": "Bu sekmede kaydedilmemiş değişiklikleriniz var.",
   "confirm-proceed-without-saving-part1": "İlerlemek istediğinizden emin misiniz",
   "confirm-proceed-without-saving-part2": "ilerlemeyi kaydetmeden?",
   "module-status-changed-success-title": "Modül durumu başarıyla değiştirildi!",
   "module-status-changed-success-description": "Bu modülün durumu doğru şekilde değiştirildi.",
   "problem-occurred-title": "Bir sorun oluştu!",
   "change-status-error-description":
      "Bu modülün durumunu değiştirirken bir sorun oluştu, lütfen tekrar deneyin.",
   "publish-module-button": "Modülü Yayınla",
   "change-status-to-editing-button": "Durumu Düzenlemeye değiştir",
   "changes-saved-success-description": "Değişiklikler başarıyla kaydedildi",
   "save-progress-button": "İlerlemeyi Kaydet",
   "skip-logic-saved-success-description": "Atlama mantığı başarıyla eklendi",
   "score-points-saved-success-description": "Puanlar başarıyla eklendi",
   "total-module-score-label": "Toplam Modül Puanı:",
   "points-suffix": "puan",
   "answers-column-label": "Cevaplar",
   "score-column-label": "Puan",
   "input-score-placeholder": "Puanı girin",
   "max-score-label": "Maksimum Puan:",
   "date-answer-label": "Tarih cevabı",
   "time-answer-label": "Saat cevabı",
   "answer-keywords-label": "Cevap anahtar kelimeleri",
   "section-score-label": "Bölüm puanı:",
   "number-range-hint-prefix": "Bu soru için aralık",
   "number-range-hint-value": "1 ile 50 arası",
   "number-range-hint-suffix": ". Lütfen puanlama için doğru cevap seçeneklerini seçin:",
   "select-right-answer-choices-placeholder": "Doğru cevap seçeneklerini seçin",
   "single-number-option-label": "Tek sayı",
   "range-option-label": "Aralık",
   "enter-range-correct-answers-label": "Doğru cevapların aralığını girin",
   "to-connector-label": "ile",
   "enter-correct-number-label": "Doğru sayıyı girin",
   "input-number-placeholder": "Sayı girin",
   "ranking-score-instructions-text":
      "Lütfen seçenekleri doğru sıraya göre düzenleyin, ardından her birine bir puan verin",
   "input-phone-number-placeholder": "Telefon numarasını girin",

   // Translate panel (admin/survey v2 editor)
   "main-module-title": "Ana Modül",
   "main-module-description-text": "Bunlar ana modülünüzdeki sorulardır",
   "default-language-placeholder": "Varsayılan Dil",
   "translate-module-title": "Modülü Çevir",
   "write-translation-here-text": "Her sorunun çevirisini buraya yazın",
   "translate-to-label": "Şuna Çevir",
   "select-a-language-placeholder": "--Bir Dil Seçin--",
   "select-language-first-error": "Lütfen önce bir dil seçin",
   "translation-saved-success-description": "Çeviri başarıyla kaydedildi",
   "save-translation-button": "Çeviriyi kaydet",

   // Action Plan admin-side resource/expert modals (workspace/actionPlan/adminActionPlan)
   "module-required-validation": "Modül zorunludur",
   "at-least-one-section-required-validation": "En az bir bölüm zorunludur",
   "resource-type-required-validation": "Kaynak türü zorunludur",
   "at-least-one-attachment-required-validation": "En az bir ek zorunludur",
   "description-required-validation": "Açıklama zorunludur",
   "tagged-topics-required-validation": "Etiketlenmiş konular zorunludur",
   "invalid-url-format-validation": "Geçersiz URL biçimi",
   "link-url-required-validation": "Bağlantı URL'si zorunludur",
   "agree-to-terms-required-validation": "Şartları kabul etmelisiniz",
   "section-required-validation": "Bölüm zorunludur",
   "resources-added-success-title": "Kaynaklar başarıyla eklendi!",
   "resources-added-success-description": "Bu kaynaklar oluşturuldu ve veritabanınıza eklendi.",
   "upload-resource-matching-type-error": "Lütfen seçilen türle eşleşen bir kaynak yükleyin.",
   "resources-updated-success-title": "Kaynaklar başarıyla güncellendi!",
   "resources-updated-success-description": "Bu kaynaklar başarıyla güncellendi.",
   "add-new-resource-title": "Yeni kaynak",
   "edit-resource-title": "Kaynağı düzenle",
   "resource-upload-shared-repository-notice":
      "Platforma yüklediğiniz her kaynak, KAPorg'un paylaşılan deposunda yayınlanacak ve diğer kullanıcıların indirip paylaşmasına açık olacak, böylece topluluk desteğini güçlendirecektir.",
   "select-module-link-resource-label": "Bu kaynağı bağlamak istediğiniz modülü seçin",
   "all-modules-in-assessment-placeholder": "Bu değerlendirmedeki tüm modüller",
   "select-section-link-resource-label": "Bu kaynağı bağlamak istediğiniz modülün bölümünü seçin",
   "all-sections-of-module-placeholder": "Modülün tüm bölümleri",
   "resource-information-title": "Kaynak bilgisi",
   "select-resource-type-label": "Kaynak türünü seçin",
   "before-upload-select-type-hint": "Bir kaynağı yüklemeden önce türünü seçmelisiniz",
   "paste-link-here-label": "Bağlantıyı buraya yapıştırın",
   "enter-link-url-placeholder": "Bağlantı URL'sini girin",
   "upload-file-here-label": "Dosyayı buraya yükleyin",
   "drag-drop-file-here-prefix": "Dosyayı buraya sürükleyip bırakın veya",
   "click-to-select-file-text": "dosyayı seçmek için tıklayın",
   "max-file-size-text": "Maksimum dosya boyutu: 20MB",
   "enter-resource-description-label": "Kaynağın açıklamasını girin",
   "tagged-topics-label": "Etiketlenmiş konular",
   "enter-tagged-topics-placeholder": "Bu kaynağın ilişkilendirilebileceği konuları girin",
   "upload-rights-confirmation-text":
      "Bu materyali yükleyerek, bunu yapmak için gerekli hak ve izinlere sahip olduğumu onaylıyorum.",
   "add-resource-button": "Kaynak ekle",
   "expert-name-column": "Uzman adı",
   "operating-countries-column": "Faaliyet gösterilen ülkeler",
   "years-of-experience-column": "Deneyim yılı",
   "expert-cv-column": "Uzman özgeçmişi",
   "areas-of-expertise-column": "Uzmanlık alanları",
   "assign-experts-to-assessment-title": "Bu değerlendirmeye uzman ata",
   "select-expert-assign-assessment-text": "Bu değerlendirmeye atamak istediğiniz uzmanı seçin.",
   "search-resource-by-name-placeholder": "Adına göre bir kaynak ara",
   "assign-expert-to-assessment-button": "Uzmanı bu değerlendirmeye ata",
   "expert-assigned-success-title": "Uzman başarıyla atandı!",
   "expert-assigned-success-description": "Bu uzman atandı ve eylem planı veritabanınıza eklendi.",
   "assign-expert-error-description":
      "Bu uzmanı eylem planınıza atarken bir sorun oluştu, lütfen tekrar deneyin.",
   "expert-removed-success-title": "Uzman başarıyla kaldırıldı!",
   "expert-removed-success-description": "Bu uzman eylem planı veritabanınızdan kaldırıldı.",
   "remove-expert-from-assessment-button": "Uzmanı bu değerlendirmeden kaldır",
   "email-label-colon": "E-posta:",
   "description-label-colon": "Açıklama:",
   "no-description-available-text": "Açıklama mevcut değil",
   "no-expertise-listed-text": "Uzmanlık listelenmemiş",
   "field-of-study-label": "Çalışma alanı",
   "no-field-of-study-listed-text": "Çalışma alanı listelenmemiş",
   "no-operating-countries-listed-text": "Faaliyet ülkesi listelenmemiş",
   "languages-label": "Diller",
   "no-languages-listed-text": "Dil listelenmemiş",
   "linkedin-profile-label": "LinkedIn profili",
   "no-linkedin-profile-text": "LinkedIn profili sağlanmadı",
   "delete-collection-title": "Koleksiyonu sil",
   "delete-collection-confirm-text": "Bu koleksiyonu silmek üzeresiniz. Bu işlem geri alınamaz.",
   "delete-resource-title": "Kaynağı sil",
   "delete-resource-confirm-text": "Bu kaynağı silmek üzeresiniz. Bu işlem geri alınamaz.",
   "collection-deleted-success-title": "Koleksiyon başarıyla silindi!",
   "collection-deleted-success-description": "Bu koleksiyon veritabanınızdan başarıyla kaldırıldı.",
   "resource-deleted-success-title": "Kaynak başarıyla silindi!",
   "resource-deleted-success-description": "Bu kaynak veritabanınızdan başarıyla kaldırıldı.",
   "delete-resource-error-description": "Bu kaynağı silerken bir sorun oluştu, lütfen tekrar deneyin.",
   "resource-preview-title": "Kaynak önizlemesi",
   "document-type-label": "Belge",
   "video-type-label": "Video",
   "slide-type-label": "Slayt",
   "tags-and-categories-label": "Etiketler ve kategoriler",
   "upload-date-label": "Yükleme tarihi",
   "description-label": "Açıklama",

   // Action Plan view/manager-side task modals (workspace/actionPlan/viewActionPlan)
   "status-label-colon": "Durum:",
   "assign-to-label-colon": "Atanan:",
   "deadline-label-colon": "Son tarih:",
   "resources-attached-section-text": "Bu bölüme eklenen kaynaklar",
   "resource-link-label-colon": "Kaynağın bağlantısı budur:",
   "task-title-required-validation": "Görev başlığı zorunludur",
   "deadline-required-validation": "Son tarih zorunludur",
   "create-new-task-title": "Yeni görev oluştur",
   "edit-task-title": "Görevi düzenle",
   "task-title-label": "Görev başlığı",
   "task-title-example-placeholder": "Çalışanlarınıza ne sıklıkla eğitim veriyorsunuz?",
   "enter-task-instruction-placeholder":
      "Göreve atanan kişiye yardımcı olacak bir not veya talimat girin",
   "assign-task-to-label": "Görevi ata",
   "select-member-assign-task-placeholder": "Bu görevi atamak için üyeyi seçin",
   "cant-find-member-assign-task-text": "Görev atamak için üyeyi bulamıyor musunuz?",
   "add-in-organization-management-text": "Organizasyon yönetiminde ekleyin",
   "upload-files-complete-task-label": "Bu görevi tamamlamak için gerekli dosyaları yükleyin",
   "can-add-up-to-3-resources-text": "En fazla 3 kaynak ekleyebilirsiniz",
   "deadline-label": "Son tarih",
   "resource-link-optional-label": "Kaynağınız bir bağlantı mı? Lütfen buraya girin",
   "enter-resource-link-placeholder": "Kaynağınızın bağlantısını girin",
   "assign-task-title": "Görev ata",
   "assign-task-at-least-one-member-validation": "Görevi en az bir üyeye ata",
   "deadline-valid-date-validation": "Son tarih geçerli bir tarih olmalıdır",
   "select-deadline-placeholder": "Son tarihi seçin",
   "task-added-assigned-success-title": "Görev başarıyla eklendi ve atandı!",
   "task-added-assigned-success-description":
      "Bu görev başarıyla atandı, seçtiğiniz üye bu konuda bilgilendirilecektir.",
   "assign-task-error-description": "Bu görevi atarken bir sorun oluştu, lütfen tekrar deneyin.",
   "select-status-title": "Durumu seçin",
   "task-updated-success-title": "Görev başarıyla güncellendi!",
   "task-updated-success-description": "Bu görev veritabanınızda başarıyla güncellendi.",
   "update-task-error-description": "Bu görevi güncellerken bir sorun oluştu, lütfen tekrar deneyin.",
   "task-deleted-success-title": "Görev başarıyla silindi!",
   "task-deleted-success-description": "Bu görev veritabanınızdan başarıyla kaldırıldı.",
   "delete-task-error-description": "Bu görevi silerken bir sorun oluştu, lütfen tekrar deneyin.",
   "delete-task-title": "Görevi sil",
   "delete-task-confirm-text": "Bu görevi silmek üzeresiniz. Bu işlem geri alınamaz.",
   "rounds-filter-label": "Turlar",
   "managers-filter-label": "Yöneticiler",
   "generate-report-button": "Rapor oluştur",
   "generate-report-title": "Rapor Oluştur",
   "choose-sections-report-text": "Rapora dahil edilecek bölümleri seçin.",
   "include-module-breakdown-label": "Modül Dökümünü Dahil Et",
   "of-label": "/",
   "sections-selected-suffix": "bölüm seçildi",
   "generate-button": "Oluştur",
   "report-preview-title": "Rapor önizlemesi",
   "edit-sections-button": "Bölümleri düzenle",
   "assessment-report-eyebrow-text": "Değerlendirme Raporu",
   "no-sections-data-selected-text": "Verisi olan seçili bölüm yok.",
   "assessment-report-pdf-heading": "DEĞERLENDİRME RAPORU",
   "exported-on-label": "Şu tarihte dışa aktarıldı:",
   "page-word": "Sayfa",
   "add-review-note-title": "İnceleme notu ekle",
   "edit-review-note-title": "İnceleme notunu düzenle",
   "note-title-required-validation": "Lütfen bir not başlığı girin",
   "enter-note-title-placeholder": "Not başlığını girin",
   "round-covered-label": "Kapsanan tur",
   "select-option-required-validation": "Lütfen bir seçenek belirleyin",
   "note-required-validation": "Lütfen notlarınızı girin",
   "summarize-progress-placeholder": "Önemli ilerlemeleri, kararları veya sorunları özetleyin.",
   "add-note-button": "Not ekle",
   "staff-members-fetch-error":
      "Personel üyelerini getirirken bir sorun oluştu, lütfen sayfayı yenileyin.",
   "task-priority-fetch-error":
      "Görev önceliğini getirirken bir sorun oluştu, lütfen sayfayı yenileyin.",
   "select-section-add-task-error": "Bu görevi eklemek için lütfen bir bölüm seçin.",
   "add-task-error-description": "Bu görevi eklerken bir sorun oluştu, lütfen tekrar deneyin.",
   "add-new-task-title": "Yeni görev ekle",
   "task-name-label": "Görev adı",
   "task-name-required-validation": "Lütfen bir görev adı girin",
   "enter-task-name-placeholder": "Görev adını girin",
   "linked-questions-label": "Bağlantılı sorular",
   "select-questions-required-validation": "Lütfen soruları seçin",
   "linked-questions-helper-text": "Bu görevin geliştirmeyi amaçladığı soruları seçin",
   "select-questions-placeholder": "Soruları seçin",
   "task-description-required-validation": "Lütfen bir açıklama girin",
   "enter-task-description-placeholder": "Görevin açıklamasını girin",
   "select-member-required-validation": "Lütfen bir üye seçin",
   "select-deadline-required-validation": "Lütfen bir son tarih seçin",
   "priority-label": "Öncelik",
   "select-priority-required-validation": "Lütfen öncelik seçin",
   "select-priority-placeholder": "Önceliği seçin",
   "resources-label": "Kaynaklar",
   "select-resources-placeholder": "Bu göreve bağlı kaynakları seçin",
   "select-resources-required-validation": "Lütfen kaynak seçin",
   "search-resource-placeholder": "Bir kaynak ara",
   "browse-resources-library-text": "Kaynak kütüphanesine göz at",
   "add-task-button": "Görev ekle",
   "confirm-selection-button": "Seçimi onayla",
   "resource-library-title": "Kaynak Kütüphanesi",
   "collections-tab-label": "Koleksiyonlar",
   "workspace-breadcrumb-label": "Çalışma alanı",
   "resources-breadcrumb-label": "Kaynaklar",
   "results-breadcrumb-label": "Sonuçlar",
   "action-plan-breadcrumb-label": "Eylem planı",
   "respondents-count-label": "katılımcı",
   "of-word": "/",
   "copy-tasks-title": "Görevleri kopyala",
   "copy-tasks-description-text":
      "Önceki turunuzdaki tüm görevler, eylem planınızın zaman içinde eksiksiz kalmasını sağlamak için kopyalanacaktır.",
   "previous-round-label": "Önceki tur:",
   "tasks-copied-label": "Kopyalanan görevler",
   "task-statistics-fetch-error": "Görev istatistiklerini yüklerken bir sorun oluştu, lütfen tekrar deneyin.",
   "delete-note-confirm-text": "Bu inceleme notunu silmek üzeresiniz. Bu işlem geri alınamaz.",
   "delete-view-title": "Görünümü sil",
   "delete-view-confirm-text": "Bu görünümü silmek üzeresiniz. Bu işlem geri alınamaz.",
   "rename-view-title": "Görünümü yeniden adlandır",
   "save-button": "Kaydet",
   "select-a-resource-title": "Bir kaynak seçin",
   "set-a-reminder-title": "Hatırlatıcı ayarla",
   "reminder-description-text":
      "Ekibinizin ilerleme notlarını eklemek veya güncellemek için ne zaman hatırlatılmak istediğinizi seçin.",
   "reminder-type-label": "Hatırlatıcı türü",
   "select-reminder-type-required-validation": "Lütfen bir hatırlatıcı türü seçin",
   "select-day-required-validation": "Lütfen bir gün seçin",
   "select-a-day-placeholder": "Bir gün seçin",
   "reminder-repeat-prefix-text":
      "Bu, ilk hatırlatma tarihiniz olacak. Gelecekteki hatırlatmalar her",
   "repeat-interval-week": "hafta",
   "repeat-interval-2-weeks": "2 hafta",
   "repeat-interval-month": "ay",
   "repeat-interval-3-months": "3 ay",
   "repeat-interval-year": "yıl",
   "reminder-repeat-suffix-text": "aynı gün tekrarlanacak.",
   "next-reminder-date-label": "Sonraki hatırlatma tarihi:",
   "save-reminder-button": "Hatırlatıcıyı kaydet",
   "my-workspaces-tab": "Çalışma alanlarım",
   "all-workspaces-tab": "Tüm çalışma alanları",
   "fetch-workspaces-error-description":
      "Çalışma alanlarını getirirken bir sorun oluştu, lütfen tekrar deneyin.",
   "archived-workspaces-title": "Arşivlenmiş çalışma alanları",
   "deleted-workspaces-button": "Silinmiş çalışma alanları",
   "new-workspace-button": "Yeni Çalışma Alanı",
   "remove-action": "Kaldır",
   "workspace-name-label": "Çalışma alanı adı",
   "enter-workspace-name-placeholder": "Çalışma alanınızın adını girin",
   "workspace-description-label": "Çalışma alanı açıklaması",
   "enter-workspace-description-placeholder": "Çalışma alanı açıklamasını girin",
   "workspace-countries-label": "Çalışma alanı ülkeleri",
   "select-a-country-placeholder": "Bir ülke seçin",
   "workspace-assessment-label": "Çalışma alanı değerlendirmesi",
   "select-default-assessment-survey-placeholder": "Anketin varsayılan değerlendirmesini seçin",
   "select-default-assessment-module-placeholder": "Modülün varsayılan değerlendirmesini seçin",
   "workspace-duplicate-name-validation": "Bu çalışma alanı zaten mevcut. Lütfen başka bir ad deneyin.",
   "workspace-created-success-title": "Çalışma alanı başarıyla oluşturuldu!",
   "workspace-created-success-description": "Yeni bir çalışma alanı oluşturuldu ve veritabanınıza eklendi",
   "create-workspace-error-description":
      "Bu çalışma alanını oluştururken bir sorun oluştu, lütfen tekrar deneyin.",
   "add-new-workspace-title": "Yeni çalışma alanı ekle",
   "workspace-updated-success-title": "Çalışma alanı başarıyla güncellendi!",
   "workspace-updated-success-description": "Bu çalışma alanı başarıyla güncellendi.",
   "update-workspace-error-description":
      "Bu çalışma alanını güncellerken bir sorun oluştu, lütfen tekrar deneyin.",
   "edit-workspace-title": "Çalışma alanını düzenle",
   "at-least-one-assessment-required-validation": "En az bir değerlendirme gereklidir",
   "workspace-archived-success-title": "Çalışma alanı başarıyla arşivlendi!",
   "workspace-archived-success-description": "Bu çalışma alanı başarıyla arşivlendi.",
   "archive-workspace-error-description":
      "Bu çalışma alanını arşivlerken bir sorun oluştu, lütfen tekrar deneyin.",
   "archive-workspace-title": "Çalışma Alanını Arşivle",
   "archive-workspace-confirm-text": "Bu çalışma alanını arşivlemek üzeresiniz.",
   "workspace-deleted-success-title": "Çalışma alanı başarıyla silindi!",
   "workspace-deleted-success-description": "Bu çalışma alanı başarıyla kaldırıldı.",
   "delete-workspace-error-description":
      "Bu çalışma alanını silerken bir sorun oluştu, lütfen tekrar deneyin.",
   "delete-workspace-title": "Çalışma Alanını Sil",
   "delete-workspace-confirm-text": "Bu çalışma alanını silmek üzeresiniz.",
   "workspace-restored-success-title": "Çalışma alanı başarıyla geri yüklendi!",
   "restore-workspace-error-description":
      "Bu çalışma alanını geri yüklerken bir sorun oluştu, lütfen tekrar deneyin.",
   "workspace-deleted-permanently-success-description":
      "Bu çalışma alanı veritabanınızdan başarıyla silindi.",
   "restore-assessment-error-description":
      "Bu değerlendirmeyi geri yüklerken bir sorun oluştu, lütfen tekrar deneyin.",
   "restore-workspaces-button": "Çalışma alanlarını geri yükle",
   "delete-workspace-permanently-title": "Çalışma alanını kalıcı olarak sil",
   "delete-workspace-permanently-confirm-text":
      "Bu çalışma alanını kalıcı olarak silmek üzeresiniz. Bu işlem geri alınamaz.",
   "workspaces-unarchived-success-title": "Çalışma alanlarının arşivi başarıyla kaldırıldı!",
   "workspaces-unarchived-success-description":
      "Bu çalışma alanlarının arşivi kaldırıldı ve veritabanınıza eklendi.",
   "unarchive-workspace-error-description":
      "Bu çalışma alanının arşivini kaldırırken bir sorun oluştu, lütfen tekrar deneyin.",
   "workspaces-deleted-success-title": "Çalışma alanları başarıyla silindi!",
   "workspaces-deleted-success-description": "Bu çalışma alanları veritabanınızdan silindi.",
   "deleted-workspaces-list-title": "Silinmiş çalışma alanları listesi",
   "deleted-workspaces-retention-text":
      "Burada silinmiş çalışma alanlarını görüntüleyebilir ve geri yükleyebilirsiniz. 60 gün içinde geri yüklenmeyen çalışma alanları kalıcı olarak silinecektir.",
   "request-canceled-success-title": "İstek başarıyla iptal edildi!",
   "request-canceled-success-description": "İsteğiniz iptal edildi.",
   "cancel-request-error-description": "Bu isteği iptal ederken bir sorun oluştu, lütfen tekrar deneyin.",
   "cancel-request-button": "İsteği İptal Et",
   "send-request-success-description":
      "İsteğiniz yöneticiye gönderildi. İstek yanıtlandığında bir e-posta alacaksınız.",
   "send-request-error-description": "İsteğinizi gönderirken bir sorun oluştu, lütfen tekrar deneyin.",
   "no-workspaces-here-title": "Burada çalışma alanı yok!",
   "request-part-workspace-description":
      "Ama merak etmeyin, «Tüm çalışma alanları» bölümünden bir çalışma alanına katılmayı talep edebilirsiniz.",
   "go-to-all-workspaces-button": "Tüm çalışma alanlarına git",
   "create-workspaces-tagline-text":
      "Kuruluşların büyümesini ve gelişimini desteklemek için tasarlanmış çalışma alanları oluşturun.",
   "export-workspaces-button": "Çalışma Alanlarını Dışa Aktar",
   "all-workspaces-consultant-heading": "Tüm Çalışma Alanları",
   "assess-partners-consultant-description":
      "Yerel Ortakları/STK'ları değerlendirmeye başlayın ve onlara mevcut performanslarına ilişkin ayrıntılı bir rapor sunun.",
   "access-workspace-organization-text": "Bir çalışma alanına erişin ve kuruluşunuza erişmeye başlayın.",
   "no-workspace-created-yet-description":
      "Görünüşe göre henüz bir çalışma alanı oluşturmadınız. Ama merak etmeyin, burada oluşturabilirsiniz.",
   "untitled-label": "Başlıksız",
   "no-section-label": "Bölüm Yok",
   "swot-analysis-title": "SWOT Analizi",
   "swot-analysis-subtitle-text": "Güçlü yönleri, zayıf yönleri, fırsatları ve tehditleri analiz edin",
   "related-module-label": "İlgili Modül",
   "select-module-placeholder": "Modül seçin",
   "enter-analysis-description-placeholder": "Analizin açıklamasını girin",
   "swot-strengths-title": "Güçlü Yönler",
   "swot-weaknesses-title": "Zayıf Yönler",
   "swot-opportunities-title": "Fırsatlar",
   "swot-threats-title": "Tehditler",
   "related-sections-label": "İlgili Bölümler",
   "select-sections-placeholder": "Bölümleri seçin",
   "analysis-label": "Analiz",
   "describe-strengths-placeholder": "Güçlü yönleri açıklayın",
   "describe-weaknesses-placeholder": "Zayıf yönleri açıklayın",
   "describe-opportunities-placeholder": "Fırsatları açıklayın",
   "describe-threats-placeholder": "Tehditleri açıklayın",
   "add-analysis-button": "Analiz ekle",
   "scores-label": "Puanlar",
   "guided-assessment-label": "Yönlendirilmiş değerlendirme",
   "self-assessment-label": "Öz değerlendirme",
   "highlights-title": "Öne Çıkanlar",
   "highlights-subtitle-text": "Önemli bulguları vurgulayın ve sonuçlara dayalı öneriler sunun",
   "choose-chart-analyze-label": "Analiz etmek istediğiniz grafiği seçin",
   "select-chart-analyze-text": "Analiz etmek istediğiniz grafiği seçin",
   "change-button": "Değiştir",
   "select-a-module-first-placeholder": "Önce bir modül seçin",
   "add-comparison-label": "Karşılaştırma Ekle",
   "insight-label": "Öngörü",
   "max-400-characters-validation": "En fazla 400 karakter",
   "describe-key-points-placeholder":
      "Bu grafikten vurgulamak istediğiniz önemli noktaları açıklayın...",
   "select-chart-to-analyze-title": "Analiz etmek için bir grafik seçin",
   "choose-chart-from-list-text": "Analiz etmek için listedeki mevcut grafiklerden birini seçin.",
   "report-title": "Rapor",
   "upload-report-insights-text":
      "Raporunuzu yükleyin, böylece bu değerlendirmenin öngörülerinin bir parçası olsun.",
   "upload-file-here-label": "Dosyayı buraya yükleyin",
   "current-file-text": "Mevcut dosya",
   "remove-file-aria-label": "Dosyayı kaldır",
   "doc-pdf-pptx-text": "DOC, PDF veya PPTX",
   "only-doc-pdf-pptx-error": "Sadece DOC, PDF veya PPTX dosyalarına izin verilir.",
   "file-must-be-smaller-than-prefix": "Dosya şundan daha küçük olmalıdır:",
   "missing-assessment-org-warning": "Değerlendirme veya kuruluş bilgileri eksik.",
   "upload-report-file-warning": "Lütfen bir rapor dosyası yükleyin.",
   "title-required-validation": "Başlık gereklidir",
   "ticket-type-required-validation": "Bilet türü gereklidir",
   "message-required-validation": "Mesaj gereklidir",
   "ticket-added-success-title": "Bilet başarıyla eklendi!",
   "ticket-added-success-description":
      "Bu bilet, bilet geçmişi veritabanınıza başarıyla eklendi, talebinize çok yakında biri yanıt verecektir.",
   "add-ticket-error-description": "Bu bileti eklerken bir sorun oluştu, lütfen tekrar deneyin.",
   "upload-jpg-png-gif-webp-error": "Lütfen sadece JPG, PNG, GIF veya WEBP dosyaları yükleyin.",
   "add-new-ticket-title": "Yeni bir bilet ekle",
   "ticket-type-label": "Bilet türü",
   "select-ticket-type-placeholder": "Bilet türünü seçin",
   "summary-label": "Özet",
   "enter-title-placeholder": "Başlık girin",
   "describe-problem-detail-label": "Sorunu ayrıntılı olarak açıklayın",
   "type-something-placeholder": "Buraya bir şeyler yazın",
   "attach-evidence-label": "Önemli gördüğünüz herhangi bir kanıtı ekleyin",
   "jpg-png-gif-webp-text": "JPG, PNG, GIF ve WEBP",
   "add-ticket-button": "Bilet ekle",
   "tickets-deleted-success-title": "Seçili biletler başarıyla silindi!",
   "tickets-deleted-success-description": "Bu seçili biletler veritabanından başarıyla silindi",
   "delete-tickets-error-description": "Bu seçili biletleri silerken bir sorun oluştu, lütfen tekrar deneyin.",
   "delete-selected-tickets-title": "Seçili biletleri sil",
   "delete-selected-tickets-confirm-text": "Bu seçili biletleri silmek üzeresiniz.",
   "collection-updated-success-title": "Koleksiyon başarıyla güncellendi!",
   "collection-updated-success-description": "Bu koleksiyon doğru şekilde güncellendi.",
   "update-collection-error-description": "Bu koleksiyonu güncellerken bir sorun oluştu, lütfen tekrar deneyin.",
   "collection-added-success-title": "Koleksiyon başarıyla eklendi!",
   "collection-added-success-description": "Bu koleksiyon oluşturuldu ve veritabanınıza eklendi.",
   "add-collection-error-description": "Bu koleksiyonu eklerken bir sorun oluştu, lütfen tekrar deneyin.",
   "edit-collection-title": "Koleksiyonu düzenle",
   "add-new-collection-title": "Yeni koleksiyon ekle",
   "new-collection-button-label": "Yeni Koleksiyon",
   "name-collection-label": "Koleksiyon adı",
   "enter-collection-name-placeholder": "Koleksiyon adını girin",
   "enter-collection-description-placeholder": "Koleksiyon açıklamasını girin",
   "select-the-assessment-label": "Değerlendirmeyi seçin",
   "select-resources-collection-placeholder": "Bu koleksiyona bağlı kaynakları seçin",
   "see-more-text": "Daha fazla gör",
   "make-collection-public-label": "Bu koleksiyonu herkese açık ve görünür yap",
   "add-collection-button": "Koleksiyon ekle",
   "global-status": "Genel",
   "owner-colon-label": "Sahip:",
   "resources-colon-label": "Kaynaklar:",
   "resource-added-collection-success-title": "Kaynak koleksiyona eklendi!",
   "resource-added-collection-success-description": "Bu kaynak koleksiyona başarıyla eklendi.",
   "add-resource-collection-error-description":
      "Bu kaynağı koleksiyona eklerken bir sorun oluştu, lütfen tekrar deneyin.",
   "add-to-collection-title": "Koleksiyona ekle",
   "resource-updated-success-title": "Kaynak başarıyla güncellendi!",
   "resource-updated-success-description":
      "Bu kaynak doğru şekilde güncellendi. Yeni bir sürüm oluşturuldu",
   "update-resource-error-description": "Bu kaynağı güncellerken bir sorun oluştu, lütfen tekrar deneyin.",
   "resource-added-success-title": "Kaynak başarıyla eklendi!",
   "resource-added-success-description": "Bu kaynak oluşturuldu ve veritabanınıza eklendi.",
   "add-resource-error-description": "Bu kaynağı eklerken bir sorun oluştu, lütfen tekrar deneyin.",
   "edit-resource-title": "Kaynağı düzenle",
   "select-resource-type-label": "Kaynak türünü seçin",
   "select-resource-type-required-validation": "Lütfen kaynak türünü seçin",
   "video-placeholder-text": "Video",
   "select-type-before-upload-text": "Bir kaynak yüklemeden önce türünü seçmelisiniz",
   "enter-resource-link-label": "Lütfen kaynak bağlantısını buraya girin",
   "valid-url-required-validation": "Lütfen geçerli bir URL girin",
   "enter-resource-link-placeholder": "Kaynağınızın bağlantısını girin",
   "select-a-file-required-validation": "Lütfen bir dosya seçin",
   "click-to-select-files-text": "dosya seçmek için tıklayın",
   "resource-version-colon-label": "Kaynak sürümü:",
   "make-resource-private-label": "Bu kaynağı özel yap",
   "resource-name-label": "Kaynak adı",
   "enter-resource-name-placeholder": "Kaynağın adını girin",
   "tags-label": "Etiketler",
   "enter-resource-tags-placeholder": "Bu kaynağın ilişkilendirilebileceği konuları girin",
   "select-module-label": "Modülü seçin",
   "select-section-label": "Bölümü seçin",
   "upload-consent-text":
      "Yüklediğiniz herhangi bir kaynak, seçtiğiniz görünürlük düzeyine göre KAPorg deposunda saklanacak ve seçilen kitlenin erişimine açık olacaktır. Devam ederek, bu materyali yüklemek için gerekli hak ve izinlere sahip olduğunuzu onaylarsınız.",
   "add-resource-button": "Kaynak ekle",
   "file-label": "Dosya",
   "views-suffix": "Görüntülenme",
   "rating-suffix": "Değerlendirme",
   "owner-label": "Sahip",
   "visibility-label": "Görünürlük",
   "linked-to-label": "Bağlantılı olduğu",
   "last-update-date-label": "Son güncelleme tarihi",
   "resource-version-label": "Kaynak sürümü",
   "targets-updated-success-title": "Hedefler başarıyla güncellendi!",
   "targets-updated-success-description": "Tüm değişiklikler başarıyla kaydedildi.",
   "save-targets-error-description":
      "Tüm değişiklikleri kaydederken bir sorun oluştu, lütfen tekrar deneyin.",
   "current-target-label": "Mevcut hedef:",
   "no-active-rounds-text": "Aktif tur yok",
   "no-target-set-yet-text": "Henüz hedef belirlenmedi",
   "no-assessments-found-text": "Değerlendirme bulunamadı",
   "no-modules-yet-title": "Henüz Modül Yok",
   "no-modules-assigned-description":
      "Bu değerlendirmeye atanmış modül yok. Eklendiklerinde burada görünecekler.",
   "enter-target-placeholder": "Hedefi girin",
   "ticket-history-title": "Bilet geçmişi",
   "help-desk-title": "Yardım masası",
   "delete-selected-rows-text": "Seçili satırları sil",
   "add-new-ticket-text": "Yeni bilet",
   "subject-column": "Konu",
   "creation-date-column": "Oluşturulma Tarihi",
   "organization-column": "Kuruluş",
   "last-response-column": "Son yanıt",
   "ticket-preview-title": "Bilet önizleme",
   "ticket-status-closed": "Kapatıldı",
   "ticket-summary-title": "Bilet özeti",
   "user-email-label": "Kullanıcı e-postası",
   "ticket-subject-label": "Bilet konusu",
   "mark-as-resolved-button": "Bileti kapat",
   "mark-ticket-resolved-title": "Bu bilet kapatılsın mı?",
   "mark-ticket-resolved-confirm-text": "Bu bileti kapatmak istediğinizden emin misiniz? Kuruluş, daha fazla yardıma ihtiyaç duyarsa yine de yanıt verebilir.",
   "ticket-resolved-success-title": "Bilet kapatıldı",
   "ticket-resolved-success-description": "Bilet kapatıldı.",
   "resolve-ticket-error-description": "Bilet kapatılırken bir hata oluştu. Lütfen tekrar deneyin.",
   "type-your-message-placeholder": "Mesajınızı buraya yazın...",
   "filter-tickets-by-type-placeholder": "Türe göre filtrele",
   "filter-tickets-by-status-placeholder": "Duruma göre filtrele",
   "summary-results-title": "Özet Sonuçlar",
   "graphs-view-tab": "Grafik görünümü",
   "table-view-tab": "Tablo görünümü",
   "expert-insights-tab": "Uzman Görüşleri",
   "no-dashboard-results-yet-title": "Bu panoda henüz sonuç yok",
   "results-appear-here-description": "Veriler mevcut olduğunda, sonuçlarınız burada görünecektir.",
   "submission-round-column": "Gönderim turu",
   "submission-label-column": "Gönderim etiketi",
   "select-module-first-text": "Lütfen önce bir modül seçin.",
   "select-at-least-one-submission-round-text": "Lütfen en az bir gönderim turu seçin.",
   "unable-detect-organization-text": "Kuruluşunuz tespit edilemedi. Lütfen tekrar giriş yapın.",
   "download-table-label": "Tabloyu indir",
   "score-overview-title": "Puan genel görünümü",
   "toggle-score-overview-aria-label": "Puan genel görünümünü aç/kapat",
   "visualizations-title": "Görselleştirmeler",
   "search-a-graph-placeholder": "Bir grafik ara",
   "select-view-placeholder": "Görünüm seçin",
   "save-view-button": "Görünümü kaydet",
   "save-dashboard-button": "Panoyu kaydet",
   "edit-dashboard-button": "Panoyu düzenle",
   "download-dashboard-label": "Panoyu indir",
   "round-label": "Tur",
   "manager-label": "Yönetici",
   "select-an-organization-placeholder": "Bir kuruluş seçin",
   "select-all-option": "Tümünü seç",
   "all-placeholder": "Tümü",
   "score-percent-label": "Puan (%)",
   "task-completion-percent-label": "Görev Tamamlama (%)",
   "task-status-percent-label": "Görev durumu (%)",
   "value-label": "Değer",
   "first-round-label": "İlk tur",
   "second-round-label": "İkinci tur",
   "improvement-percent-label": "İyileşme %",
   "result-label": "Sonuç",
   "current-label": "Mevcut",
   "target-word": "Hedef",
   "overall-score-label": "Genel puan",
   "of-tasks-completed-label": "tamamlanan görev",
   "leading-label": "Öncü",
   "developing-label": "Gelişmekte",
   "lagging-label": "Geride",
   "section-word": "Bölüm",
   "task-completion-label": "Görev tamamlama",
   "indicator-word": "Gösterge",
   "progress-word": "İlerleme",
   "current-round-label": "Mevcut Tur:",
   "change-label": "Değişim:",
   "improvement-label": "İyileşme",
   "task-count-label": "Görev sayısı",
   "assessment-results-per-module-title": "Modüle göre değerlendirme sonuçları",
   "assessment-results-per-section-title": "Bölüme göre değerlendirme sonuçları",
   "performance-map-title": "Performans haritası",
   "assessment-results-per-organization-title": "Kuruluşa göre değerlendirme sonuçları",
   "module-results-per-organization-title": "Kuruluşa göre modül sonuçları",
   "section-results-per-organization-title": "Kuruluşa göre bölüm sonuçları",
   "assessment-targets-per-organization-title": "Kuruluşa göre değerlendirme hedefleri",
   "module-targets-per-organization-title": "Kuruluşa göre modül hedefleri",
   "section-targets-per-organization-title": "Kuruluşa göre bölüm hedefleri",
   "improvement-tracker-per-organization-title": "Kuruluşa göre iyileşme takibi",
   "target-score-task-progress-per-organization-title": "Kuruluşa göre hedef, puan ve görev ilerlemesi",
   "assessment-results-per-round-title": "Tura göre değerlendirme sonuçları",
   "module-results-per-round-title": "Tura göre modül sonuçları",
   "section-results-per-round-title": "Tura göre bölüm sonuçları",
   "assessment-targets-per-round-title": "Tura göre değerlendirme hedefleri",
   "module-targets-per-round-title": "Tura göre modül hedefleri",
   "section-targets-per-round-title": "Tura göre bölüm hedefleri",
   "improvement-tracker-per-assessment-title": "Değerlendirmeye göre iyileşme takibi",
   "target-score-task-progress-per-assessment-title": "Değerlendirmeye göre hedef, puan ve görev ilerlemesi",
   "radar-chart-type-label": "Radar grafiği",
   "tier-list-type-label": "Seviye listesi",
   "score-progress-across-rounds-title": "Turlar boyunca puan gelişimi",
   "module-score-progress-across-rounds-title": "Turlar boyunca modül puan gelişimi",
   "bar-chart-type-label": "Çubuk grafik",
   "table-type-label": "Tablo",
   "modules-word": "Modüller",
   "sections-word": "Bölümler",
   "task-status-per-assessment-title": "Değerlendirmeye göre görev durumu",
   "module-task-completion-title": "Modül görev tamamlanma durumu",
   "section-task-completion-title": "Bölüm görev tamamlanma durumu",
   "task-completion-per-organization-title": "Kuruluşa göre görev tamamlanma durumu",
   "improvement-tracker-title": "İyileşme takibi",
   "donut-chart-type-label": "Halka grafik",
   "task-updated-success-message": "Görev başarıyla güncellendi.",
   "task-added-success-message": "Görev başarıyla eklendi.",
   "export-tasks-error-message": "Görevleri dışa aktarırken bir sorun oluştu, lütfen tekrar deneyin.",
   "tasks-copied-success-title": "Görevler başarıyla kopyalandı!",
   "tasks-copied-success-description": "Önceki turdaki tüm görevler mevcut tura kopyalandı.",
   "results-not-yet-approved-title": "Sonuçlar henüz onaylanmadı!",
   "results-not-yet-approved-description": "Görevler, bu değerlendirmedeki tüm modüllerin onaylanmış gönderimleri olduğunda kopyalanabilir. Görevleri kopyalamadan önce lütfen gönderimlerinizi onaylayın.",
   "tasks-already-copied-title": "Bu tur için görevler zaten kopyalandı",
   "tasks-already-copied-description": "Görevler her tur için yalnızca bir kez kopyalanabilir. Eksik göreviniz varsa lütfen yöneticinizle iletişime geçin.",
   "copy-tasks-error-title": "Hata! Bir sorun oluştu!",
   "copy-tasks-error-description": "Önceki turdaki görevleri kopyalarken bir sorun oluştu, lütfen tekrar deneyin.",
   "resource-label-colon": "Kaynak:",
   "edit-module-alt-text": "Modülü düzenle",
   "delete-module-alt-text": "Modülü sil",
   "task-status-updated-message": "Görev durumu güncellendi.",
   "failed-update-task-status-message": "Görev durumu güncellenemedi.",
   "plan-summary-title": "Plan özeti",
   "select-organization-to-view-plan-text": "Plan özetini görüntülemek için yukarıdan bir organizasyon seçin.",
   "select-organization-placeholder": "Organizasyon seçin",
   "previous-round-readonly-notice-text": "Bu, verilerini korumak için salt okunur olan önceki bir turdur. Değişiklikleri yalnızca mevcut turda yapabilirsiniz.",
   "viewing-previous-round-button": "Önceki bir turu görüntülüyorsunuz",
   "go-to-current-round-button": "Mevcut tura git",
   "staff-member-label": "Personel üyesi",
   "export-plan-button": "Planı dışa aktar",
   "task-column-header": "Görev",
   "responsible-column-header": "Sorumlu",
   "due-date-column-header": "Son tarih",
   "see-less-link": "Daha az gör",
   "see-all-link": "Tümünü gör",
   "no-linked-questions-text": "Bağlantılı soru yok",
   "resources-label-colon": "Kaynaklar:",
   "no-tasks-for-staff-member-text": "Seçilen personel üyesi için görev bulunamadı",
   "add-tasks-improve-score-text": "Puanınızı artırmak için bu göstergeye görev ekleyin",
   "result-label-colon": "Sonuç:",
   "target-label-colon": "Hedef:",
   "review-note-added-success-description": "İnceleme notu başarıyla eklendi.",
   "reminder-set-title": "Hatırlatıcı ayarlandı",
   "reminder-scheduled-success-description": "Hatırlatıcınız başarıyla planlandı.",
   "review-notes-title": "İnceleme notları",
   "set-reminder-button": "Hatırlatıcı ayarla",
   "print-summary-button": "Özeti yazdır",
   "export-notes-button": "Notları dışa aktar",
   "note-word": "Not",
   "no-note-created-yet-text": "Henüz not oluşturulmadı.",
   "no-review-notes-available-text": "Kullanılabilir inceleme notu yok.",
   "no-score-selected-text": "Puan seçilmedi",
   "filters-colon-label": "Filtreler:",
   "none-word": "Yok",
   "graph-word": "Grafik",
   "no-chart-content-text": "Grafik içeriği yok",
   "filter-colon-label": "Filtre:",
   "action-plan-word": "Aksiyon Planı",
   "results-word": "Sonuçlar",
   "no-charts-available-title": "Kullanılabilir grafik yok",
   "no-charts-data-export-text": "Dışa aktarılacak verisi olan grafik yok.",
   "summary-action-plan-dashboard-title": "Aksiyon Planı Panosu Özeti",
   "summary-results-dashboard-title": "Sonuçlar Panosu Özeti",
   "assessment-colon-label": "Değerlendirme:",
   "assessment-word": "Değerlendirme",
   "download-svg-action": "SVG indir",
   "download-png-action": "PNG indir",
   "included-in-report-tooltip-text": "Rapor oluşturulurken dahil edilir",
   "no-visualization-selected-text": "Görselleştirme seçilmedi",
   "drop-visualization-here-text": "Görselleştirmeyi buraya bırakın",
   "add-graph-button": "Grafik ekle",
   "delete-block-tooltip-text": "Bloğu sil",
   "no-filters-selected-text": "Filtre seçilmedi",
   "filters-word": "Filtreler",
   "untitled-graph-text": "Başlıksız grafik",
   "graph-preview-unavailable-text": "Grafik önizlemesi kullanılamıyor",
   "filter-word": "Filtre",
   "global-suffix-label": "(genel)",
   "organization-word": "Kuruluş",
   "staff-word": "Personel",
   "generic-problem-occurred-title": "Hata! Bir sorun oluştu",
   "view-saved-success-title": "Görünüm başarıyla kaydedildi!",
   "view-saved-success-description": "Kontrol paneli görünümünüz başarıyla kaydedildi.",
   "problem-saving-view-description": "Bu görünümü kaydederken bir sorun oluştu, lütfen tekrar deneyin.",
   "select-view-before-rename-text": "Yeniden adlandırmadan önce bir görünüm seçin.",
   "select-view-before-delete-text": "Silmeden önce bir görünüm seçin.",
   "view-deleted-success-title": "Görünüm başarıyla silindi!",
   "view-deleted-success-description": "Seçilen görünüm kontrol panelinizden silindi.",
   "problem-deleting-view-description": "Bu görünümü silerken bir sorun oluştu, lütfen tekrar deneyin.",
   "view-renamed-success-title": "Görünüm başarıyla yeniden adlandırıldı!",
   "view-renamed-success-description": "Seçilen görünümün adı başarıyla güncellendi.",
   "problem-renaming-view-description": "Bu görünümü yeniden adlandırırken bir sorun oluştu, lütfen tekrar deneyin.",
   "view-word": "Görünüm",
   "compare-with-self-assessment-label": "Öz değerlendirme ile karşılaştır",
   "comparison-limited-one-org-text": "Bu karşılaştırma aynı anda tek bir kuruluşla sınırlıdır",
   "assessment-not-linked-self-text": "Bu değerlendirme bir öz değerlendirmeyle bağlantılı değil",
   "dashboard-word": "Kontrol paneli",
   "self-assessments-menu-item": "Öz değerlendirmeler",
   "guided-assessments-menu-item": "Yönlendirilmiş değerlendirmeler",
   "module-request-menu-item": "Modül talebi",
   "action-plan-menu-item": "Aksiyon planı",
   "my-performance-menu-item": "Performansım",
   "task-management-menu-item": "Görev yönetimi",
   "resources-menu-item": "Kaynaklar",
   "organization-management-menu-item": "Kuruluş yönetimi",
   "quick-search-tooltip-text": "Hızlı arama",
   "notifications-tooltip-text": "Bildirimler",
   "help-desk-word": "Yardım Masası",
   "go-back-previous-menu-text": "Önceki menüye dön",
   "go-back-to-action-plan-link": "Aksiyon planına dön",
   "go-back-to-module-list-link": "Modül listesine dön",
   "go-back-to-modules-list-link": "Modüller listesine dön",
   "go-back-to-templates-list-link": "Şablon listesine dön",
   "go-back-to-action-plan-section-link": "Aksiyon planı bölümüne dön",
   "go-back-to-assessment-link": "Değerlendirmeye dön",
   "go-back-to-assessments-link": "Değerlendirmelere dön",
   "go-back-to-assigned-modules-list-link": "Atanan modüller listesine dön",
   "go-back-to-approved-modules-list-link": "Onaylanan modüller listesine dön",
   "go-back-to-pending-modules-list-link": "Bekleyen modüller listesine dön",
   "go-back-to-guided-assessment-link": "Yönlendirilmiş değerlendirmeye dön",
   "go-back-to-guided-assessment-list-link": "Yönlendirilmiş değerlendirme listesine dön",
   "go-back-to-workspaces-link": "Çalışma alanlarına dön",
   "profile-preview-alt-text": "Profil Önizlemesi",
   "org-role-abbreviation": "Kur.",
   "role-super-admin-label": "Süper Yönetici",
   "role-consultant-label": "Danışman",
   "role-donor-label": "Bağışçı",
   "role-national-organization-label": "Ulusal Kuruluş",
   "role-international-organization-label": "Uluslararası Kuruluş",
   "male-label": "Erkek",
   "female-label": "Kadın",
   "no-self-assessments-here-text": "Burada öz değerlendirme yok",
   "no-guided-assessments-here-text": "Burada yönlendirilmiş değerlendirme yok",
   "self-assessment-panel-title": "Öz değerlendirme",
   "guided-assessment-panel-title": "Yönlendirilmiş değerlendirme",
   "sort-progress-by-label": "İlerlemeyi sırala:",
   "highest-to-lowest-option": "Yüksekten alçağa",
   "lowest-to-highest-option": "Alçaktan yükseğe",
   "modules-count-suffix": "modül",
   "answer-pending-status": "Yanıt bekleniyor",
   "unlock-assessment-text": "Değerlendirmenin kilidini aç",
   "select-assessment-see-results-text": "Sonuçlarını ayrıntılı görmek için bir değerlendirme seçin.",
   "linked-badge-label": "Bağlı",
   "no-assessments-available-title": "Kullanılabilir değerlendirme yok.",
   "start-adding-view-results-text": "Toplanan sonuçları görmek için bir tane ekleyerek başlayın.",
   "assessment-selected-suffix": "değerlendirme seçildi",
   "action-plan-panel-description-text": "Burada her değerlendirmedeki sonuçlarınıza dayalı bir aksiyon planı bulacaksınız.",
   "select-one-see-plan-detail-text": "Planı ayrıntılı görmek için birini seçin.",
   "search-for-assessment-placeholder": "Değerlendirme ara",
   "areas-to-improve-label": "İyileştirilecek modüller:",
   "no-assessments-here-text": "Burada değerlendirme yok!",
   "selected-assessment-title": "Seçilen değerlendirme",
   "no-assessment-selected-text": "Değerlendirme seçilmedi",
   "number-of-resources-label": "Kaynak sayısı:",
   "areas-in-label": "Alanlar:",
   "indicators-to-improve-label": "İyileştirilecek göstergeler:",
   "no-data-available-to-display-text": "Görüntülenecek veri bulunmuyor.",
   "self-evaluate-screen-description-text": "Bu ekran, tamamladığınız anketlere göre kendinizi değerlendirmenizi sağlar",
   "maximum-organizations-warning-text": "En fazla 5 kuruluş!",
   "search-organization-placeholder": "Kuruluş ara",
   "sort-order-tooltip-text": "Sıralama düzeni",
   "get-results-tooltip-text": "Sonuçları al",
   "report-word": "Rapor",
   "capacity-gaps-title": "Kapasite Açıkları",
   "capacity-gaps-description-text": "Hangi modüllerin ve bölümlerin güçlü, hangilerinin zayıf olduğu ve hedeflerine göre nasıl performans gösterdikleri.",
   "performance-overview-title": "Performans Genel Bakışı",
   "performance-overview-description-text": "Grubun bu turdaki durumu: kuruluş puanları, değerlendirmenin puan kategorilerine nasıl dağıldıkları ve tur hedefine göre nerede durdukları.",
   "progress-across-rounds-title": "Turlar Arasındaki İlerleme",
   "progress-across-rounds-description-text": "Grubun bu turda bölüm düzeyinde nerede olduğu ve önceki turdan bu yana her kuruluşun nasıl değiştiği — kimin geliştiği, kimin gerilediği ve ne kadar.",
   "action-plan-status-title": "Aksiyon Planı Durumu",
   "action-plan-status-description-text": "Seçilen tur için kuruluş başına görev tamamlanma durumu ve bunun hedefe ulaşmayla ilişkisi.",
   "score-band-deficient": "Zayıf",
   "score-band-insufficient": "Yetersiz",
   "score-band-satisfactory": "Yeterli",
   "score-band-very-good": "Çok İyi",
   "score-band-excellent": "Mükemmel",
   "module-rejected-success-description": "Modül başarıyla reddedildi",
   "failed-reject-module-description": "Bu modül reddedilemedi",
   "module-accepted-success-description": "Modül başarıyla kabul edildi",
   "failed-accept-module-description": "Bu modül kabul edilemedi",
   "module-requests-title": "Modül talepleri",
   "pending-modules-review-description-text": "Bu, incelemenizi bekleyen modüllerin listesidir. Devam etmek için, kabul veya reddedebileceğiniz her modüle tıklayın.",

   // Login / Registration pages
   "welcome-back-title": "Tekrar hoş geldiniz!",
   "login-into-account-subtitle": "Hesabınıza giriş yapın",
   "email-placeholder": "yourmail@gmail.com",
   "password-label": "Şifre",
   "toggle-password-visibility-label": "Şifreyi göster/gizle",
   "remember-me-label": "Beni hatırla?",
   "log-in-button": "Giriş yap",
   "no-account-yet-text": "Hesabınız yok mu?",
   "sign-up-link": "Kaydol",
   "max-16-symbols-validation": "En fazla 16 karakter",
   "go-back-icon-alt": "Geri",
   "go-back-to-login-link": "Girişe geri dön",
   "welcome-to-kaporg-title": "KAPorg'a hoş geldiniz!",
   "which-profile-title": "Hangi profil sizi en iyi tanımlıyor?",
   "profile-organization-label": "Organizasyon",
   "profile-donors-label": "Bağışçılar",
   "profile-expert-label": "Uzman",
   "signup-role-title": "KAPorg'u nasıl kullanacaksınız?",
   "signup-role-subtitle": "Sorumluluklarınıza en uygun rolü seçin.",
   "profile-donor-label": "Bağışçı",
   "signup-role-organization-description": "Sürdürülebilir kurumsal kapasite oluşturun",
   "signup-role-donor-description": "Kurumsal portföy performansını denetleyin",
   "signup-role-expert-description": "Bağımsız stratejik rehberlik sağlayın",
   "signup-create-account-as-an": "Hesap oluşturun:",
   "signup-create-account-as-a": "Hesap oluşturun:",
   "showcase-login-headline": "Kuruluşları [[kapasite geliştirmeye]] öncülük etmeleri için güçlendiriyoruz",
   "showcase-organization-headline": "Yetkinliklerinizi değerlendirin ve [[misyonunuzu güçlendirin]]",
   "showcase-donor-headline": "Portföy performansını izleyin ve [[ölçülebilir sonuçlar elde edin]]",
   "showcase-expert-headline": "Stratejik rehberlik sağlayın ve [[kurumsal kapasiteyi yükseltin]]",
   "signup-step-profile": "Profil",
   "signup-step-expertise": "Uzmanlık",
   "profile-details-title": "Profil bilgileri",
   "upload-photo-text": "Fotoğraf yükle",
   "adjust-your-photo-title": "Fotoğrafınızı ayarlayın",
   "change-photo-text": "Fotoğrafı değiştir",
   "signup-step-account": "Hesap",
   "signup-step-contact": "İletişim",
   "enter-organization-email-placeholder": "Kuruluşun e-posta adresini girin",
   "code-must-have-6-digits-validation": "Kod 6 haneli olmalıdır",
   "code-incorrect-text": "Kod yanlış",
   "confirmation-email-shortly-text": "Kısa süre içinde bir onay e-postası alacaksınız",
   "go-to-homepage-button": "Ana sayfaya git",
   "didnt-get-email-text": "E-postayı almadınız mı? Spam klasörünüzü kontrol edin veya şu adrese yazın:",
   "language-selector-label": "Dil seçin",
   "auth-tagline-transforming-title": "Kapasite geliştirmeyi dönüştürüyoruz",
   "auth-tagline-transforming-description": "Dijital çağ için",
   "auth-tagline-elevate-title": "Kuruluşunuzu geliştirin",
   "auth-tagline-elevate-description": "amaçlı değerlendirmeyle!",
   "auth-tagline-changemakers-title": "Değişim yaratanlarla bağlantı kurun",
   "auth-tagline-changemakers-description": "size en çok ihtiyaç duyanlarla.",
   "auth-tagline-miss-you-title": "Sizi özleyeceğiz,",
   "auth-tagline-miss-you-description": "Yakında geri dönmenizi umuyoruz.",
   "auth-tagline-collaborations-title": "Etkili iş birliklerinden",
   "auth-tagline-collaborations-description": "oluşan bir dünyaya dalın!",
   "auth-tagline-expertise-title": "Uzmanlığınız",
   "auth-tagline-expertise-description": "ve görüşleriniz ilerlemeyi besliyor!",

   // National organization registration form
   "go-back-to-profile-selection-link": "Profil seçimine geri dön",
   "create-account-title": "Hesap oluştur",
   "as-an-org-label": "bir Kuruluş olarak",
   "login-details-title": "Giriş bilgileri",
   "confirm-password-label": "Şifreyi onayla",
   "type-description-placeholder": "Açıklama yazın",
   "working-sectors-label": "Çalışma sektörleri",
   "enter-organization-name-placeholder": "Kuruluşun adını girin",
   "enter-organization-address-placeholder": "Kuruluşun adresini girin",
   "enter-organization-zip-code-placeholder": "Kuruluşun posta kodunu girin",
   "terms-agreement-prefix-text": "Okudum ve kabul ediyorum",
   "terms-of-service-privacy-policy-link": "Hizmet Şartları, Gizlilik Politikası",
   "and-conjunction-text": "ve",
   "cookie-policy-link": "Çerez Politikası.",
   "invalid-email-address-validation": "Geçersiz e-posta adresi",
   "password-min-length-validation": "Şifre en az 8 karakter olmalıdır",
   "password-complexity-validation": "Şifre en az bir büyük harf, bir rakam ve belirtilen sembollerden birini (!, @, #, $, %, ^, &, *) içermelidir",
   "password-required-validation": "Şifre gereklidir",
   "passwords-must-match-validation": "Şifreler eşleşmelidir",
   "confirm-password-required-validation": "Şifre onayı gereklidir",
   "organization-name-required-validation": "Uluslararası Kuruluş adı gereklidir",
   "foundation-year-required-validation": "Kuruluş yılı gereklidir",
   "sectors-min-validation": "En az bir sektör seçilmelidir",
   "sectors-required-validation": "Sektörler gereklidir",
   "organization-address-required-validation": "Kuruluş adresi gereklidir",
   "invalid-organization-email-validation": "Geçersiz kuruluş e-postası",
   "organization-email-required-validation": "Kuruluşun e-postası gereklidir",
   "accept-terms-required-validation": "Şart ve koşulları kabul etmelisiniz",

   // Donor registration form
   "as-an-international-donor-label": "Uluslararası bağışçı olarak",
   "donor-organization-name-required-validation": "Kuruluş Adı gereklidir",
   "invitation-code-label": "Davet kodu",
   "enter-invitation-code-placeholder": "Davet kodunuzu girin",
   "invitation-code-min-length-validation": "Davet kodu en az 12 karakter olmalıdır",
   "invitation-code-required-validation": "Davet Kodu gereklidir",
   "invalid-invitation-code-format-validation": "Geçersiz davet kodu formatı",
   "no-invitation-code-help-text": "Davet kodunuz yoksa lütfen bize buradan e-posta gönderin:",

   // Terms/Conditions modal
   "close-icon-alt": "Kapat",
   "terms-of-service-tab-label": "Hizmet şartları",
   "privacy-policy-tab-label": "Gizlilik politikası",
   "cookie-policy-tab-label": "Çerez politikası",
   "got-it-button": "Anladım!",

   // Shared auth thunk toasts (donor/expert registration)
   "account-created-success-description": "Hesap başarıyla oluşturuldu.",
   "unexpected-error-description": "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.",
   "verification-code-sent-description": "E-postanıza bir doğrulama kodu gönderildi.",
   "expert-user-created-success-description": "Uzman kullanıcı başarıyla oluşturuldu",

   // Expert registration step one
   "as-an-expert-label": "Uzman olarak",

   // Expert registration step three
   "lets-start-profile-info-title": "Profil bilgilerinizle başlayalım",
   "enter-full-name-placeholder": "Adınızı ve soyadınızı girin",
   "personal-statement-label": "Kişisel beyan/motivasyon",
   "enter-personal-statement-placeholder": "Kişisel beyanınızı girin",
   "select-nationality-placeholder": "Uyruğunuzu seçin",
   "select-country-of-residence-placeholder": "İkamet ülkenizi seçin",
   "operating-countries-label": "Faaliyet gösterilen ülkeler",
   "enter-linkedin-profile-placeholder": "LinkedIn profilinizi girin",
   "full-name-required-validation": "Ad soyad gereklidir",
   "nationality-required-validation": "Uyruk gereklidir",
   "country-of-residence-required-validation": "İkamet ülkesi gereklidir",

   // Expert registration step four
   "now-your-professional-details-title": "Şimdi mesleki bilgileriniz",
   "profile-picture-label": "Profil Fotoğrafı",
   "education-section-title": "Eğitim",
   "select-highest-degree-placeholder": "En yüksek derecenizi seçin",
   "enter-fields-of-study-placeholder": "Çalışma alanlarını girin",
   "enter-educational-institution-placeholder": "Eğitim kurumunuzu girin",
   "area-label": "Alan",
   "enter-area-placeholder": "Alanı girin",
   "add-another-area-button": "Başka bir alan ekle",
   "level-label": "Seviye",
   "select-level-placeholder": "Seviye seçin",
   "add-another-language-button": "Başka bir dil ekle",
   "upload-cv-label": "Özgeçmişinizi yükleyin",
   "upload-certificate-label": "Bir sertifika veya özel eğitim yükleyin",
   "remove-button": "Kaldır",
   "image-file-type-badge": "JPG veya PNG",
   "pdf-file-type-badge": "PDF",
   "highest-degree-required-validation": "En yüksek derece gereklidir",
   "area-required-validation": "Alan gereklidir",
   "years-of-experience-required-validation": "Deneyim yılı gereklidir",
   "years-of-experience-number-validation": "Deneyim yılı bir sayı olmalıdır",
   "profile-picture-required-validation": "Profil fotoğrafı gereklidir",
   "invalid-image-file-type-validation": "Geçersiz dosya türü. Yalnızca PNG veya JPEG kabul edilir.",
   "file-size-too-large-validation": "Dosya boyutu çok büyük. Maksimum boyut 20MB'dir.",
   "invalid-pdf-file-type-validation": "Geçersiz dosya türü. Yalnızca PDF kabul edilir.",
   "level-required-validation": "Seviye gereklidir",
   "level-number-validation": "Seviye bir sayı olmalıdır",
   "go-back-to-profile-details-link": "Profil detaylarına geri dön",
   "uploaded-file-icon-alt": "Dosya",
   "add-icon-alt": "Ekle",

   // Confirm-code page
   "verification-code-title": "Doğrulama kodu",
   "verification-code-sent-to-text": "Lütfen size gönderdiğimiz doğrulama kodunu girin",
   "verify-code-button": "Kodu doğrula",
   "didnt-receive-code-text": "Doğrulama kodu almadıysanız,",
   "resend-code-link": "yeniden göndermek için buraya tıklayın",
   "or-send-email-at-text": "veya bize buradan e-posta gönderin",
   "verification-code-required-validation": "Doğrulama kodu gereklidir",
   "code-verified-success-description": "Kod başarıyla doğrulandı",

   // Account on review page
   "account-on-review-icon-alt": "Hesap incelemede",
   "got-your-application-title": "Başvurunuzu aldık!",
   "application-review-description-text": "Bir yönetici talebinizi onayladığında bir onay e-postası alacaksınız.",
   "in-the-meantime-prefix-text": "Bu arada, ziyaret edin",
   "in-the-meantime-suffix-text": "daha fazla bilgi için.",
   "thank-you-for-interest-text": "KAPorg'a gösterdiğiniz ilgi için teşekkür ederiz!",

   // Resources library
   "resources-library-tab-label": "Kaynak kütüphanesi",
   "resource-type-all-label": "Tüm kaynaklar",
   "resource-type-documents-label": "Belgeler",
   "resource-type-videos-label": "Videolar",
   "resource-type-links-label": "Bağlantılar",
   "resource-type-presentations-label": "Sunumlar",
   "no-resources-available-text": "Kullanılabilir kaynak yok",
   "no-collections-available-text": "Kullanılabilir koleksiyon yok",
   "which-resource-looking-for-label": "Neyi arıyorsunuz?",
   "search-ellipsis-placeholder": "Ara...",
   "assessments-placeholder": "Değerlendirmeler",
   "modules-label": "Modüller",
   "section-label": "Bölüm",
   "sections-placeholder": "Bölümler",
   "resource-icon-alt": "Kaynaklar",
   "copy-link-action": "Bağlantıyı kopyala",
   "edit-resource-icon-alt": "Kaynağı düzenle",
   "rate-this-resource-action": "Bu kaynağı değerlendir",
   "delete-resource-icon-alt": "Kaynağı sil",
   "more-suffix-text": "daha fazla",
   "rate-this-resource-title": "Bu Kaynağı Değerlendirin",
   "resource-word": "Kaynak",
   "your-rating-label": "Değerlendirmeniz:",
   "save-rating-button": "Değerlendirmeyi kaydet",
   "all-tab-label": "Tümü",
   "my-collections-label": "Koleksiyonlar",
   "my-collection-toggle-label": "Koleksiyonum",
   "all-collections-label": "Koleksiyonlar",
   "edit-collection-icon-alt": "Koleksiyonu düzenle",
   "delete-collection-icon-alt": "Koleksiyonu sil",
   "preview-colon-label": "Önizleme:",
   "resources-word": "Kaynaklar",

   // Top navigation bar: account/user menu (PopoverLinks)
   "account-summary-icon-alt": "hesap özeti",
   "account-summary-label": "Hesap özeti",
   "account-summary-upgrade-message":
      "Paket limitinize yaklaşıyorsunuz. Daha fazla alana sahip olmak ve sınırsız oluşturmak için yükseltin.",
   "upgrade-package-button": "Paketi yükselt",
   "modules-available-label": "Kullanılabilir modüller",
   "modules-created-label": "Oluşturulan modüller",
   "assessments-available-label": "Kullanılabilir değerlendirmeler",
   "assessments-created-label": "Oluşturulan değerlendirmeler",
   "workspaces-available-label": "Kullanılabilir çalışma alanları",
   "workspaces-created-label": "Oluşturulan çalışma alanları",
   "including-humanitarian-experts-created-label": "oluşturulan insani yardım uzmanları dahil",
   "amount-of-storage-label": "Depolama miktarı",
   "data-usage-label": "Veri kullanımı",
   "usage-statistics-label": "Kullanım istatistikleri",
   "available-label": "Kullanılabilir",
   "used-label": "Kullanılan",
   "profile-info-icon-alt": "profil bilgisi",
   "profile-information-label": "Profil bilgisi",
   "login-info-icon-alt": "giriş bilgisi",
   "login-information-label": "Giriş bilgisi",
   "payment-info-icon-alt": "ödeme bilgisi",
   "payment-information-label": "Ödeme bilgisi",
   "log-out-icon-alt": "çıkış yap",
   "log-out-button": "Çıkış yap",
   "account-menu-toggle-alt": "Hesap menüsü",

   // Top navigation bar: mobile header
   "menu-toggle-icon-alt": "Menü",
   "logo-alt-text": "Logo",

   // Top navigation bar: notifications popover
   "mark-all-as-read-button": "Tümünü okundu olarak işaretle",
   "unread-tab-label": "Okunmamış",
   "no-notifications-title-text": "Burada bildirim yok!",
   "up-to-date-description-text": "Her şey güncel!",

   // Terms of Service (legal document body) - translated
   "terms-last-updated-text": "Bu Hizmet Şartları en son 4 Mart 2024 tarihinde güncellenmiştir.",
   "terms-intro-websites-prefix-text": "Bu Hizmet Şartları, aşağıda belirtilen adreslerde yer alan web sitelerimizin kullanımını düzenler",
   "terms-intro-websites-suffix-text": ", ayrıca International Advisory, Products and Systems Ltd tarafından sağlanan ilgili diğer hizmetleri de kapsar. Web sitelerimize erişerek, bu Hizmet Şartlarına uymayı ve geçerli tüm yasa ve yönetmeliklere riayet etmeyi kabul etmiş olursunuz. Bu Hizmet Şartlarını kabul etmiyorsanız, söz konusu web sitelerini kullanmanız veya bunlara erişmeniz ya da International Advisory, Products and Systems Ltd tarafından sağlanan diğer hizmetleri kullanmanız yasaktır. Biz, International Advisory, Products and Systems Ltd, işbu Hizmet Şartlarının herhangi birini kendi takdirimize bağlı olarak gözden geçirme ve değiştirme hakkını saklı tutarız. Bunu yaptığımızda, bu sayfayı güncelleyeceğiz. Bu Hizmet Şartlarında yapılan her türlü değişiklik, yayımlandığı tarihten itibaren derhal yürürlüğe girer.",
   "overview-of-services-title": "Hizmetlere Genel Bakış",
   "overview-of-services-description-text": "International Advisory, Products and Systems Ltd. (i-APS), bağlı kuruluşlarıyla birlikte -bunlarla sınırlı olmamak üzere KAPsurvey, KAPorg, KAPinsights ve KAPcourse dahil (bundan böyle birlikte \"KAPtech Group\" olarak anılacaktır)- teknik danışmanlık hizmetleri, yenilikçi teknolojik çözümler ve kapsamlı veri toplama ve analiz araçları sunmaktadır. KAPtech Group'un sunduğu hizmetler, uzman ve kalkınma projelerinin yürütülmesini ve yönetimini desteklemeyi amaçlamaktadır. Bu hizmetler, ortak kuruluşların ve toplulukların uzmanlık yardımı ve kalkınma sektörlerindeki zorluklara etkili bir şekilde yanıt vermelerine ve bunların üstesinden gelmelerine yardımcı olmak amacıyla son teknolojiden yararlanmakta ve kapsamlı yerel uzmanlıktan faydalanmaktadır. Web sitelerimize erişim de dahil olmak üzere KAPtech Group tarafından sunulan hizmetleri kullanarak, işbu sözleşmede belirtilen hüküm ve koşullara uymayı ve bunlarla bağlı olmayı kabul edersiniz. Sunulan hizmetler, burada belirtilen şartların yanı sıra, belirli hizmetlere veya hizmetlerin özelliklerine uygulanabilecek her türlü ek kılavuz veya kurala tabidir.",
   "limitations-of-use-title": "Kullanım Kısıtlamaları",
   "limitations-of-use-intro-text": "Web sitelerimizi kullanarak, kendi adınıza, kullanıcılarınız adına ve temsil ettiğiniz diğer taraflar adına, aşağıdaki eylemleri gerçekleştirmeyeceğinizi taahhüt edersiniz:",
   "limitation-modify-content-text": "söz konusu web sitelerinde yer alan materyalleri ve yazılımları değiştirmek, kopyalamak, bunlardan türev çalışmalar hazırlamak, kaynak koda geri dönüştürmek (decompile) veya tersine mühendislik yapmak (reverse engineer);",
   "limitation-remove-notices-text": "söz konusu web sitelerindeki herhangi bir materyal veya yazılımdan telif hakkı veya diğer mülkiyet bildirimlerini kaldırmak;",
   "limitation-transfer-materials-text": "materyalleri başka bir kişiye aktarmak veya materyalleri başka bir sunucuda \"yansıtmak\" (mirror);",
   "limitation-abuse-networks-text": "söz konusu web sitelerini veya bunlarla ilişkili herhangi bir hizmeti, ağlarımızı veya International Advisory, Products and Systems Ltd tarafından sağlanan diğer herhangi bir hizmeti kötüye kullanacak veya aksatacak şekilde bilerek veya ihmalkârca kullanmak;",
   "limitation-unlawful-material-text": "söz konusu web sitelerini veya bunlarla ilişkili hizmetleri, taciz edici, müstehcen, ahlaka aykırı, hileli veya yasa dışı herhangi bir materyali iletmek veya yayımlamak amacıyla kullanmak;",
   "limitation-violate-laws-text": "söz konusu web sitelerini veya bunlarla ilişkili hizmetleri, geçerli herhangi bir yasa veya yönetmeliği ihlal edecek şekilde kullanmak;",
   "limitation-spam-text": "söz konusu web sitelerini, yetkisiz reklam veya istenmeyen posta (spam) göndermek amacıyla kullanmak;",
   "limitation-harvest-data-text": "kullanıcının rızası olmaksızın kullanıcı verilerini toplamak, biriktirmek veya elde etmek; veya",
   "limitation-infringe-rights-text": "söz konusu web sitelerini veya bunlarla ilişkili hizmetleri, üçüncü tarafların gizlilik, fikri mülkiyet haklarını veya diğer haklarını ihlal edebilecek şekilde kullanmak",
   "intellectual-property-title": "Fikri Mülkiyet",
   "intellectual-property-description-text": "Söz konusu web sitelerinde yer alan materyallerdeki fikri mülkiyet hakları, International Advisory, Products and Systems Ltd'ye ait olup veya bu şirkete lisanslanmış olup, geçerli telif hakkı ve marka hukuku kapsamında korunmaktadır. Kullanıcılarımıza, materyallerin kişisel, ticari olmayan ve geçici kullanım amacıyla bir kopyasını indirme izni veriyoruz. Bu, mülkiyetin devri değil, bir lisans verilmesi anlamına gelir. Bu lisans, işbu kısıtlamalardan herhangi birini veya Hizmet Şartlarını ihlal etmeniz halinde kendiliğinden sona erer ve International Advisory, Products and Systems Ltd tarafından herhangi bir zamanda sonlandırılabilir.",
   "user-generated-content-title": "Kullanıcı Tarafından Oluşturulan İçerik",
   "terms-user-generated-content-description-text": "Web sitelerimizde yayımlanmak üzere bize sunduğunuz içerik üzerindeki fikri mülkiyet haklarınızı elinde tutmaya devam edersiniz. İçeriğiniz üzerinde asla mülkiyet iddiasında bulunmayız; ancak içeriğinizi kullanabilmek için sizden bir lisans almamız gerekmektedir. Web sitelerimizi veya bunlarla ilişkili hizmetleri, fikri mülkiyet haklarının kapsadığı içerikleri yayınlamak, yüklemek, paylaşmak veya başka bir şekilde iletmek amacıyla kullandığınızda, bize; içeriğinizi gizlilik tercihlerinize ve Gizlilik Politikamıza uygun bir şekilde kullanma, dağıtma, değiştirme, çalıştırma, kopyalama, kamuya açık olarak gösterme, tercüme etme veya bundan türev çalışmalar oluşturma konusunda münhasır olmayan, telif ücreti gerektirmeyen, devredilebilir, alt lisans verilebilir, dünya çapında geçerli bir lisans vermiş olursunuz. Bize verdiğiniz bu lisans, içeriğinizi veya hesabınızı silmeniz suretiyle her zaman sona erdirilebilir. Ancak, biz (veya iş ortaklarımız) içeriğinizi ticari veya sponsorlu içerikle bağlantılı olarak kullanmış olduğumuz ölçüde, söz konusu lisans, ilgili ticari içerik veya gönderi tarafımızca yayından kaldırılana kadar devam edecektir. Bize, kullanıcı adınızı ve hesabınızla ilişkili diğer kimlik bilgilerini, gizlilik tercihlerinize ve Gizlilik Politikamıza uygun bir şekilde kullanma izni verirsiniz.",
   "registration-and-payments-title": "Kayıt ve Ödemeler",
   "registration-and-payments-description-text": "Hizmetlerimizden herhangi birini kullanabilmek için bir hesap oluşturmanız gerekmektedir. Sağlanan her türlü bilginin doğru olması ve gerektiğinde güncellenmesi gerekir. Müşteriler, hesaplarını korumaktan sorumludur ve hesapları kapsamında gerçekleşen tüm faaliyetlerden tamamen sorumludur. Hesabınıza herhangi bir kişinin yetkisiz erişim sağlaması durumunda, bizi derhal bilgilendirmeniz gerekmektedir. International Advisory, Products and Systems Ltd, hesabınızın gizliliğinin korunamamasından kaynaklanan herhangi bir kayıp veya zarardan sorumlu değildir. Hesabınızı oluştururken, seçtiğiniz ödeme yöntemiyle ilgili finansal bilgilerinizi sağlamanız gerekmektedir. Bazı durumlarda, kredi kartı bilgilerinizi sağlamanız istenebilir. Platformumuzda yapılan ödemelerin PayPal, Stripe, Square, Google Payments veya Apple Pay tarafından işleneceğini lütfen unutmayın. Bu doğrultuda, finansal bilgilerinizin işlenmesinden veya saklanmasından biz sorumlu olmayacağız. PayPal, Stripe, Square, Google Payments veya Apple Pay, tüm finansal bilgilerinizi kendi ilgili Hizmet Şartlarına göre işleyecektir ve söz konusu Hizmet Şartlarına uymayı kabul edersiniz.",
   "disclaimer-and-limitations-title": "Sorumluluk Reddi ve Sorumluluk Sınırlamaları",
   "disclaimer-websites-prefix-text": "International Advisory, Products and Systems Ltd. tarafından sağlanan web siteleri ve materyaller -bunlarla sınırlı olmamak üzere",
   "disclaimer-as-is-description-text": "- kullanıcılara \"olduğu gibi\" esasına göre sunulmaktadır. International Advisory, Products and Systems Ltd, yasaların izin verdiği ölçüde, açık veya zımni her türlü garantiyi reddeder. Buna, ticarete elverişlilik, belirli bir amaca uygunluk veya fikri mülkiyet haklarının ihlal edilmemesi garantileri dahildir ancak bunlarla sınırlı değildir. Ayrıca, tarafınızca International Advisory, Products and Systems Ltd'den veya hizmetler aracılığıyla, sözlü veya yazılı olarak elde edilen hiçbir tavsiye veya bilgi, işbu şartlarda açıkça belirtilmeyen herhangi bir garanti oluşturmayacaktır. International Advisory, Products and Systems Ltd ve tedarikçileri, hizmetlerin kullanımından veya kullanılamamasından ya da hizmetlerle ilgili herhangi bir başka konudan kaynaklanan; kâr kaybı, itibar kaybı, kullanım kaybı, veri kaybı veya diğer maddi olmayan kayıplar dahil ancak bunlarla sınırlı olmamak üzere, doğrudan, dolaylı, arızi, özel, sonuç niteliğindeki veya ibret niteliğindeki (exemplary) zararlardan sorumlu tutulamaz (International Advisory, Products and Systems Ltd bu tür zararların olasılığı konusunda bilgilendirilmiş olsa dahi). Bu sorumluluk sınırlaması, iddia edilen sorumluluğun sözleşmeye, haksız fiile, ihmale, kusursuz sorumluluğa veya başka herhangi bir dayanağa dayanmasından bağımsız olarak, International Advisory, Products and Systems Ltd bu tür bir zararın olasılığı konusunda bilgilendirilmiş olsa dahi geçerlidir. International Advisory, Products and Systems Ltd tarafından, özellikle uzman ve kalkınma sektörleri bağlamında sunulan hizmetlerin niteliği göz önüne alındığında, kullanıcılar, veri toplama ve teknoloji odaklı çözümlerin kullanımına ilişkin doğal risklerin farkında olduklarını kabul ederler. Kullanıcılar, veri koruma ve gizlilik yasaları dahil ancak bunlarla sınırlı olmamak üzere, geçerli tüm yasa ve yönetmeliklere uygunluklarını sağlamaktan yalnızca kendileri sorumludur. Özellikle küçüklerin veya hassas verilerin söz konusu olduğu durumlarda, veri toplama için gerekli onay ve izinlerin alınması sorumluluğu kullanıcıya aittir. International Advisory, Products and Systems Ltd'nin ve bağlı kuruluşlarının, yöneticilerinin, görevlilerinin, çalışanlarının, temsilcilerinin, tedarikçilerinin ve lisans verenlerinin sorumluluğu, yasaların izin verdiği azami ölçüde sınırlıdır. Hizmetlerin herhangi bir bölümünden veya işbu şartlardan herhangi birinden memnun değilseniz, tek ve münhasır çözüm yolunuz hizmetleri kullanmayı bırakmaktır. Bazı yargı bölgeleri, belirli garantilerin hariç tutulmasına veya arızi ya da sonuç niteliğindeki zararlara ilişkin sorumluluğun sınırlandırılmasına veya hariç tutulmasına izin vermemektedir; bu nedenle, yukarıdaki sınırlamaların bir kısmı sizin için geçerli olmayabilir.",
   "accuracy-of-materials-title": "Materyallerin Doğruluğu",
   "accuracy-of-materials-description-text": "Web sitelerimizde yer alan materyaller kapsamlı değildir ve yalnızca genel bilgilendirme amacı taşımaktadır. International Advisory, Products and Systems Ltd, söz konusu web sitelerindeki materyallerin kullanımının doğruluğu, olası sonuçları veya güvenilirliği konusunda ya da bu materyallerle veya söz konusu web sitelerine bağlantılı herhangi bir kaynakla ilgili olarak herhangi bir garanti vermez veya beyanda bulunmaz. Karar alırken yalnızca söz konusu materyallere güvenmemeniz gerekmektedir; daha eksiksiz diğer bilgi kaynaklarına başvurmanızı tavsiye ederiz. Web sitelerimizde yayımlanan materyallere sıkı sıkıya bağlı kalmanızdan yalnızca siz sorumlusunuz. Web sitelerimizdeki bilgileri önceden bildirimde bulunmaksızın değiştirme hakkına sahibiz ve kullanıcılar söz konusu değişiklikleri takip etmekten sorumludur.",
   "additional-tools-title": "Ek Araçlar",
   "additional-tools-description-text": "Web sitelerimizin, kontrolümüz dışında olan üçüncü taraf araçlarını içerebileceğini lütfen unutmayın. Söz konusu araçlara erişim, açık veya zımni herhangi bir garanti verilmeksizin ve herhangi bir onay teşkil etmeksizin \"olduğu gibi\" esasına göre sağlanmaktadır. Web sitelerimizde sunulan üçüncü taraf araçlarının kullanımından sorumlu değiliz. Söz konusu araçların kullanımıyla ilişkili tüm risklerden yalnızca siz sorumlusunuz; ilgili üçüncü taraf sağlayıcının Hizmet Şartlarını okumanızı tavsiye ederiz. International Advisory, Products and Systems Ltd, gelecekte yeni üçüncü taraf araçları sunma hakkına sahiptir.",
   "links-title": "Bağlantılar",
   "links-description-text": "International Advisory, Products and Systems Ltd, kendi web sitelerine bağlantı veren tüm siteleri incelememiştir ve bu tür bağlantılı sitelerin içeriğinden sorumlu değildir. Herhangi bir bağlantının bulunması, International Advisory, Products and Systems Ltd tarafından o sitenin onaylandığı, kabul edildiği veya kontrol edildiği anlamına gelmez. Bu tür bağlantılı bir sitenin kullanımı tamamen sizin kendi sorumluluğunuzdadır ve söz konusu sitelerin uygunluğu konusunda kendi araştırmalarınızı yapmanızı önemle tavsiye ederiz.",
   "inaccuracies-and-mistakes-title": "Yanlışlıklar ve Hatalar",
   "inaccuracies-and-mistakes-description-text": "Web sitelerimizde yer alan içeriklerin, hizmetin tanımı, fiyatlandırması, tanıtımı ve mevcudiyeti ile ilgili yazım hataları, yanlışlıklar veya hatalar içerebileceğini lütfen unutmayın. Tarafımızca sağlanan herhangi bir bilginin yanlış olduğu tespit edilirse, mevcut hizmetleri iptal etme veya güncelleme hakkına sahibiz. Söz konusu bilgiler, önceden bildirimde bulunulmaksızın her zaman değiştirilebilir. Yasaların gerektirdiği durumlar dışında, web sitelerimiz ve hizmetlerimizle ilgili fiyatlandırma bilgileri de dahil olmak üzere, herhangi bir bilgiyi açıklığa kavuşturma yükümlülüğümüz olmadığını lütfen unutmayın.",
   "indemnification-title": "Tazminat",
   "indemnification-description-text": "Bize karşı; iştiraklerimiz, bağlı kuruluşlarımız ve tüm ilgili yöneticilerimiz, temsilcilerimiz, iş ortaklarımız ve çalışanlarımız dahil olmak üzere, herhangi bir üçüncü tarafça aşağıdakilerden kaynaklanan veya bunlarla bağlantılı olarak ileri sürülen her türlü kayıp, zarar, sorumluluk, talep veya iddiaya karşı, makul avukatlık ücretleri ve masrafları dahil olmak üzere savunma yapmayı, tazmin etmeyi ve bizi zarardan ari tutmayı kabul edersiniz: (1) Katkılarınız; (2) web sitelerinin kullanımı; (3) işbu Hizmet Şartlarının ihlali; (4) işbu Hizmet Şartlarında yer alan beyan ve garantilerinizin ihlali; (5) fikri mülkiyet hakları dahil ancak bunlarla sınırlı olmamak üzere, bir üçüncü tarafın haklarının ihlali; veya (6) web siteleri aracılığıyla bağlantı kurduğunuz herhangi bir başka kullanıcıya yönelik açık zarar verici bir eylem.",
   "indemnification-defense-text": "Yukarıdakilere bakılmaksızın, bizi tazmin etmekle yükümlü olduğunuz herhangi bir konuda, masrafı size ait olmak üzere, münhasır savunma ve kontrolü üstlenme hakkını saklı tutarız ve bu tür iddialara karşı savunmamıza, masrafı size ait olmak üzere, işbirliği yapmayı kabul edersiniz. İşbu tazminat hükmüne tabi olan herhangi bir iddia, dava veya işlemden haberdar olduğumuzda, sizi bilgilendirmek için makul çabayı göstereceğiz.",
   "right-to-terminate-title": "Fesih Hakkı",
   "right-to-terminate-description-text": "İşbu Hizmet Şartlarının herhangi bir şekilde ihlal edilmesi durumunda, size yazılı bildirimde bulunarak, web sitelerimizi kullanma hakkınızı derhal askıya alabilir veya sonlandırabilir ve işbu Hizmet Şartlarını feshedebiliriz.",
   "severance-title": "Bölünebilirlik",
   "severance-description-text": "İşbu Hizmet Şartlarının tamamen veya kısmen geçersiz veya uygulanamaz olan herhangi bir hükmü, geçersiz veya uygulanamaz olduğu ölçüde işbu Hizmet Şartlarından ayrılır. İşbu Hizmet Şartlarının geri kalanının geçerliliği bundan etkilenmez.",
   "entire-agreement-title": "Sözleşmenin Bütünlüğü",
   "entire-agreement-description-text": "İşbu Hizmet Şartları ile web sitelerinde veya web siteleriyle ilgili olarak tarafımızca yayımlanan her türlü politika veya işletme kuralı, sizinle bizim aramızdaki sözleşmenin ve mutabakatın bütününü oluşturur. İşbu Hizmet Şartlarında yer alan herhangi bir hak veya hükmü kullanmamamız veya uygulamamamız, söz konusu hak veya hükümden feragat ettiğimiz anlamına gelmez. İşbu Hizmet Şartları, yasaların izin verdiği azami ölçüde uygulanır. Haklarımızın ve yükümlülüklerimizin tamamını veya bir kısmını herhangi bir zamanda başkalarına devredebiliriz. Makul kontrolümüz dışındaki herhangi bir nedenden kaynaklanan hiçbir kayıp, zarar, gecikme veya harekete geçmeme durumundan sorumlu tutulamayız. İşbu Hizmet Şartlarının herhangi bir hükmünün veya bir hükmün bir kısmının yasa dışı, geçersiz veya uygulanamaz olduğuna karar verilmesi halinde, söz konusu hüküm veya hükmün ilgili kısmı işbu Hizmet Şartlarından ayrılabilir sayılır ve bu durum, kalan hükümlerin geçerliliğini ve uygulanabilirliğini etkilemez. İşbu Hizmet Şartları veya web sitelerinin kullanımı sonucunda sizinle bizim aramızda herhangi bir ortak girişim, ortaklık, istihdam veya acentelik ilişkisi kurulmaz. İşbu Hizmet Şartlarının, tarafımızca hazırlanmış olması nedeniyle aleyhimize yorumlanmayacağını kabul edersiniz. İşbu belgeyle, işbu Hizmet Şartlarının elektronik formda olmasına ve taraflarca imzalanmamış olmasına dayanan her türlü savunmadan feragat edersiniz.",
   "governing-law-title": "Uygulanacak Hukuk",
   "governing-law-description-text": "İşbu Hizmet Şartları, Virginia yasalarına tabidir ve bu yasalara uygun olarak yorumlanır. Bu Eyaletteki veya bu bölgedeki mahkemelerin münhasır yargı yetkisini geri alınamaz şekilde kabul edersiniz.",

   // Cookie Policy (legal document body)
   "browser-settings-cookie-control-text": "Web tarayıcınızın ayarlarını yöneterek çerez tercihlerinizi belirleyebilir veya değiştirebilirsiniz. Her web tarayıcısı farklı olduğundan, lütfen web tarayıcınız tarafından sağlanan talimatlara (genellikle \"yardım\" bölümünde) başvurun. Çerezleri reddetmeyi veya devre dışı bırakmayı tercih etmeniz durumunda web sitelerimizi yine de kullanabilirsiniz; ancak bazı işlevleri kullanamayabilirsiniz.",
   "control-cookies-title": "Web Sitemizin Çerez Kullanımını Nasıl Kontrol Edebilirsiniz?",
   "cookie-consent-manager-description-text": "Web sitelerimizdeki çerezleri kabul etmeyi mi yoksa reddetmeyi mi seçeceğinize karar verme hakkına sahipsiniz. Çerez tercihlerinizi Cookie Consent Manager üzerinden yönetebilirsiniz. Cookie Consent Manager, hangi çerez kategorilerini kabul edeceğinizi veya reddedeceğinizi seçmenize olanak tanır. Zorunlu çerezler, web sitelerimizdeki hizmetleri size sunmak için kesinlikle gerekli olduğundan reddedilemez.",
   "cookie-definition-text": "Çerez, bir web sitesinin ziyaret ettiğinizde cihazınıza kaydettiği küçük bir veri parçasıdır. Genellikle web sitesinin kendisi hakkında bilgi, sitenin geri döndüğünüzde web tarayıcınızı tanımasını sağlayan benzersiz bir tanımlayıcı, çerezin amacına hizmet eden ek veriler ve çerezin kendi kullanım ömrünü içerir.",
   "cookie-intro-websites-prefix-text": "Web sitelerimizdeki deneyiminizi iyileştirmeye yardımcı olmak için",
   "cookie-intro-websites-suffix-text": " adresinde çerezler kullanıyoruz. Bu çerez politikası, International Advisory, Products and Systems Ltd'nin gizlilik politikasının bir parçasıdır. Bu politika, cihazınız ile sitelerimiz arasındaki çerez kullanımını kapsar.",
   "cookie-last-updated-text": "Bu Hizmet Şartları en son 4 Mart 2024 tarihinde güncellenmiştir.",
   "cookie-policy-contact-us-description-text": "Çerez Politikamızla ilgili herhangi bir soru veya endişeniz için, aşağıdaki bilgileri kullanarak bizimle iletişime geçebilirsiniz:",
   "cookie-policy-further-info-title": "Daha Fazla Bilgiyi Nereden Edinebilirsiniz?",
   "cookie-policy-update-frequency-title": "Bu Çerez Politikasını Ne Sıklıkla Güncelleyeceğiz?",
   "cookie-policy-update-reason-text": "Kullandığımız çerezlerde ve ilgili teknolojilerde yapılan değişiklikleri yansıtmak veya diğer operasyonel, hukuki ya da düzenleyici nedenlerle bu Çerez Politikasını zaman zaman güncelleyebiliriz.",
   "cookie-policy-version-notice-text": "Web sitelerimizi her kullandığınızda, Çerez Politikasının o anda geçerli olan sürümü uygulanır. Web sitelerimizi kullandığınızda, bu Çerez Politikasının tarihini (bu belgenin en üstünde yer alır) kontrol etmeli ve önceki sürümden bu yana yapılan değişiklikleri incelemelisiniz.",
   "cookie-refuse-prefix-text": "Bizden çerez kabul etmek istemiyorsanız, tarayıcınıza",
   "cookie-refuse-suffix-text": " sitesinden gelen çerezleri reddetmesi talimatını vermelisiniz. Bu durumda, size istediğiniz içerik ve hizmetlerin bir kısmını sunamayabiliriz.",
   "cookie-third-party-services-notice-text": "Ayrıca, hizmetlerinin bir parçası olarak çerez kullanabilecek olan ve kullanabileceğimiz üçüncü taraf hizmetleri hakkında temel bilgiler de sunuyoruz. Bu politika, söz konusu üçüncü tarafların çerezlerini kapsamaz.",
   "cookie-types-title": "Çerez türleri ve bunları nasıl kullandığımız",
   "cookie-usage-examples-text": "Çerezler; belirli özellikleri etkinleştirmek (örneğin oturum açma), site kullanımını izlemek (örneğin analitik), kullanıcı ayarlarınızı saklamak (örneğin saat dilimi, bildirim tercihleri) ve içeriğinizi kişiselleştirmek (örneğin reklam, dil) amacıyla kullanılır.",
   "essential-cookies-definition-text": "Zorunlu çerezler, kullanıcı girişleri, hesap yönetimi, alışveriş sepetleri ve ödeme işlemleri gibi temel özellikleri etkinleştirerek bir web sitesindeki deneyiminiz için hayati öneme sahiptir.",
   "essential-cookies-usage-text": "Web sitelerimizde belirli işlevleri etkinleştirmek için zorunlu çerezler kullanıyoruz.",
   "first-party-cookies-definition-text": "Ziyaret ettiğiniz web sitesi tarafından ayarlanan çerezlere genellikle birinci taraf çerezleri denir. Bunlar genellikle yalnızca söz konusu belirli sitedeki etkinliğinizi izler.",
   "functionality-cookies-definition-text": "İşlevsellik çerezleri, cihazınız ve ziyaret ettiğiniz web sitesinde yapılandırabileceğiniz ayarlar (dil ve saat dilimi ayarları gibi) hakkında bilgi toplamak için kullanılır. Bu bilgiler sayesinde web siteleri size özelleştirilmiş, geliştirilmiş veya optimize edilmiş içerik ve hizmetler sunabilir. Bu çerezler, ziyaret ettiğiniz web sitesi (birinci taraf) tarafından veya üçüncü taraf hizmetleri tarafından ayarlanabilir.",
   "functionality-cookies-title": "İşlevsellik çerezleri",
   "functionality-cookies-usage-text": "Sitelerimizdeki seçili özellikler için işlevsellik çerezleri kullanıyoruz.",
   "performance-cookies-definition-text": "Performans çerezleri, ziyaretiniz sırasında bir web sitesini nasıl kullandığınızı izler. Bu bilgiler genellikle anonimdir ve tüm site kullanıcılarına ait bilgilerin bir araya getirilmesiyle toplu hale getirilir. Bu çerezler, şirketlerin ziyaretçi kullanım kalıplarını anlamalarına, kullanıcılarının karşılaşabileceği sorunları veya hataları tespit edip teşhis etmelerine ve hedef kitlelerinin genel web sitesi deneyimini iyileştirmek için daha iyi stratejik kararlar almalarına yardımcı olur. Bu çerezler, ziyaret ettiğiniz web sitesi (birinci taraf) tarafından veya üçüncü taraf hizmetleri tarafından ayarlanabilir. Hakkınızda kişisel bilgi toplamazlar.",
   "performance-cookies-title": "Performans çerezleri",
   "performance-cookies-usage-text": "Sitelerimizde performans çerezleri kullanıyoruz.",
   "targeting-advertising-cookies-definition-text": "Hedefleme/reklam çerezleri, hangi tanıtım içeriğinin sizin ve ilgi alanlarınız için en uygun ve alakalı olduğunu belirlemeye yardımcı olur. Web siteleri, hedeflenmiş reklamlar sunmak veya bir reklamı görme sayınızı sınırlamak için bunları kullanabilir. Bu, şirketlerin kampanyalarının etkinliğini ve size sunulan içeriğin kalitesini artırmasına yardımcı olur. Bu çerezler, ziyaret ettiğiniz web sitesi (birinci taraf) tarafından veya üçüncü taraf hizmetleri tarafından ayarlanabilir. Üçüncü taraflarca ayarlanan hedefleme/reklam çerezleri, aynı üçüncü taraf hizmetini kullanan diğer web sitelerinde sizi izlemek için kullanılabilir.",
   "targeting-advertising-cookies-title": "Hedefleme/reklam çerezleri",
   "targeting-advertising-cookies-usage-text": "Sitelerimizde hedefleme/reklam çerezleri kullanıyoruz.",
   "third-party-cookies-definition-text": "Diğer siteler ve şirketler (yani üçüncü taraflar) tarafından ayarlanan çerezlere üçüncü taraf çerezleri denir. Bu çerezler, aynı üçüncü taraf hizmetini kullanan diğer web sitelerinde de sizi izlemek için kullanılabilir.",
   "what-is-a-cookie-title": "Çerez nedir?",

   // Privacy Policy (legal document body)
   "privacy-last-updated-text": "Bu Hizmet Şartları en son 4 Mart 2024 tarihinde güncellenmiştir.",
   "privacy-intro-websites-prefix-text": "Gizliliğiniz bizim için önemlidir. Hakkınızda, web sitelerimiz dahil olmak üzere, toplayabileceğimiz her türlü kişisel bilgiyle ilgili olarak gizliliğinize saygı duymak ve yürürlükteki her türlü kanun ve yönetmeliğe uymak, International Advisory, Products and Systems Ltd'nin politikasıdır. Bu politika,",
   "privacy-intro-websites-suffix-text": " ile sahip olduğumuz ve işlettiğimiz diğer siteler için de geçerlidir.",
   "personal-information-definition-text": "Kişisel bilgi, sizi tanımlamak için kullanılabilecek her türlü bilgidir. Bu; bir kişi olarak size ilişkin bilgileri (ad, adres ve doğum tarihi gibi), cihazlarınıza ilişkin bilgileri, ödeme bilgilerinizi ve hatta bir web sitesini veya çevrimiçi hizmeti nasıl kullandığınıza dair bilgileri de kapsar.",
   "third-party-sites-disclaimer-text": "Sitelerimizin üçüncü taraf sitelere ve hizmetlere bağlantılar içermesi halinde, bu site ve hizmetlerin kendi gizlilik politikalarına sahip olduğunu lütfen unutmayın. Herhangi bir üçüncü taraf içeriğine yönlendiren bir bağlantıyı takip ettikten sonra, kişisel bilgileri nasıl topladıklarına ve kullandıklarına ilişkin olarak yayınladıkları gizlilik politikası bilgilerini okumalısınız. Bu Gizlilik Politikası, sitelerimizden birinden ayrıldıktan sonraki hiçbir faaliyetinize uygulanmaz.",
   "information-we-collect-title": "Topladığımız Bilgiler",
   "information-categories-intro-text": "Topladığımız bilgiler iki kategoriden birine girer: \"gönüllü olarak sağlanan\" bilgiler ve \"otomatik olarak toplanan\" bilgiler",
   "voluntarily-provided-info-description-text": "\"Gönüllü olarak sağlanan\" bilgiler, hizmetlerimizden veya promosyonlarımızdan herhangi birini kullanırken veya bunlara katılırken bize bilerek ve aktif olarak sağladığınız her türlü bilgiyi ifade eder.",
   "automatically-collected-info-description-text": "\"Otomatik olarak toplanan\" bilgiler, ürünlerimize ve hizmetlerimize erişim sürecinde cihazlarınız tarafından otomatik olarak gönderilen her türlü bilgiyi ifade eder.",
   "log-data-title": "Günlük Verileri",
   "log-data-description-text": "Web sitelerimizden birini ziyaret ettiğinizde, sunucularımız web tarayıcınız tarafından sağlanan standart verileri otomatik olarak kaydedebilir. Bu veriler; cihazınızın İnternet Protokolü (IP) adresini, tarayıcı türünüzü ve sürümünüzü, ziyaret ettiğiniz sayfaları, ziyaretinizin tarih ve saatini, her sayfada geçirilen süreyi ve ziyaretinizle ilgili diğer ayrıntıları içerebilir.",
   "log-data-errors-description-text": "Ayrıca, sitelerimizi kullanırken belirli hatalarla karşılaşmanız durumunda, hata ve bu hatanın ortaya çıkışına ilişkin koşullar hakkında otomatik olarak veri toplayabiliriz. Bu veriler; cihazınızla ilgili teknik ayrıntıları, hata meydana geldiğinde ne yapmaya çalıştığınızı ve soruna ilişkin diğer teknik bilgileri içerebilir. Bu tür hatalar meydana geldiği anda dahi, hataların meydana geldiğine veya hatanın niteliğine ilişkin bir bildirim alabilir ya da almayabilirsiniz.",
   "device-data-intro-text": "Web sitelerimizi ziyaret ettiğinizde veya hizmetlerimizle etkileşime girdiğinizde, cihazınıza ilişkin aşağıdakiler gibi verileri otomatik olarak toplayabiliriz:",
   "device-data-title": "Cihaz Verileri",
   "device-type-label": "Cihaz türü",
   "log-data-combination-warning-text": "Bu bilgilerin tek başına kişisel olarak tanımlayıcı nitelikte olmayabileceğini, ancak bu bilgilerin diğer verilerle birleştirilmesi halinde bireylerin kişisel olarak tanımlanmasının mümkün olabileceğini lütfen unutmayınız.",
   "operating-system-label": "İşletim sistemi",
   "unique-device-identifiers-label": "Benzersiz cihaz tanımlayıcıları",
   "date-of-birth-label": "Doğum tarihi",
   "device-data-settings-note-text": "Topladığımız veriler, cihazınızın ve yazılımınızın bireysel ayarlarına bağlı olabilir. Bize hangi bilgileri sunduklarını öğrenmek için cihaz üreticinizin veya yazılım sağlayıcınızın politikalarını incelemenizi öneririz.",
   "geo-location-data-label": "Coğrafi konum verileri",
   "personal-information-intro-text": "Örneğin bültenimize abone olduğunuzda veya bizimle iletişime geçtiğinizde sizden kişisel bilgiler talep edebiliriz; bu bilgiler aşağıdakilerden bir veya birden fazlasını içerebilir:",
   "personal-information-title": "Kişisel Bilgiler",
   "social-media-profiles-label": "Sosyal medya profilleri",
   "phone-mobile-number-label": "Telefon/cep telefonu numarası",
   "home-mailing-address-label": "Ev/posta adresi",
   "work-related-information-label": "İşle ilgili bilgiler",
   "company-name-label": "Şirket adı",
   "title-field-label": "Unvan",
   "sensitive-information-title": "Hassas Bilgiler",
   "sensitive-information-definition-text": "\"Hassas bilgi\" veya \"özel nitelikli veri kategorileri\", daha yüksek düzeyde koruma sağlanan bir kişisel bilgi alt kümesidir. Hassas bilgi örnekleri arasında; ırksal veya etnik kökeninize, siyasi görüşlerinize, dininize, sendika üyeliğinize veya diğer mesleki birlik ya da üyeliklerinize, felsefi inançlarınıza, cinsel yönelime, cinsel pratiklere veya cinsel hayata, sabıka kayıtlarına, sağlık bilgilerine veya biyometrik bilgilere ilişkin bilgiler yer almaktadır.",
   "sensitive-information-types-intro-text": "Hakkınızda toplayabileceğimiz hassas bilgi türleri şunları içerir:",
   "sensitive-information-consent-text": "Öncelikle rızanızı almadan hakkınızda hassas bilgi toplamayacağız ve hassas bilgilerinizi yalnızca kanunen izin verildiği, gerekli kılındığı veya yetkilendirildiği ölçüde kullanacak ya da ifşa edeceğiz.",
   "privacy-user-generated-content-description-text": "\"Kullanıcı tarafından oluşturulan içerik\" ifadesini, kullanıcılarımız tarafından platformumuzda yayınlanması, işlenmesi veya kullanılması amacıyla bize gönüllü olarak sağlanan materyaller (metin, görsel ve/veya video içerikler) olarak kabul ediyoruz. Tüm kullanıcı tarafından oluşturulan içerik, materyallerin gönderilmesinde kullanılan hesap veya e-posta adresiyle ilişkilendirilir.",
   "user-generated-content-publication-notice-text": "Yayınlanması amacıyla göndereceğiniz her türlü içeriğin, yayınlandıktan sonra (ve sonrasında gerçekleştirilecek inceleme veya değerlendirme sürecinin ardından) herkese açık hale geleceğini lütfen unutmayın. Bir kez yayınlandıktan sonra, bu içerik işbu gizlilik politikası kapsamında olmayan üçüncü taraflarca erişilebilir hale gelebilir.",
   "transaction-data-title": "İşlem Verileri",
   "transaction-data-description-text": "İşlem verileri, platformumuzun olağan işleyişi sırasında biriken verileri ifade eder. Bu veriler; işlem kayıtlarını, saklanan dosyaları, kullanıcı profillerini, analiz verilerini ve diğer ölçümleri, ayrıca kullanıcıların hizmetlerimizle etkileşimi sırasında oluşturulan veya üretilen diğer bilgi türlerini içerebilir.",
   "legitimate-reasons-title": "Kişisel Verilerinizin İşlenmesine İlişkin Meşru Nedenler",
   "legitimate-reasons-description-text": "Kişisel bilgilerinizi yalnızca bunu yapmak için meşru bir nedenimiz olduğunda toplar ve kullanırız. Bu durumda, size hizmetlerimizi sunmak için makul ölçüde gerekli olan kişisel bilgileri topluyoruz.",
   "collection-and-use-title": "Bilgilerin Toplanması ve Kullanılması",
   "collection-and-use-intro-text": "Web sitelerimizde aşağıdakilerden herhangi birini yaptığınızda sizden kişisel bilgi toplayabiliriz:",
   "collect-register-account-text": "Bir hesaba kayıt olma",
   "collect-purchase-subscription-text": "Bir abonelik satın alma",
   "collect-signup-updates-text": "E-posta veya sosyal medya kanalları aracılığıyla bizden güncellemeler almak için kaydolma",
   "collect-mobile-browser-text": "İçeriğimize erişmek için bir mobil cihaz veya web tarayıcısı kullanma",
   "collect-contact-us-text": "E-posta, sosyal medya veya benzer herhangi bir teknoloji aracılığıyla bizimle iletişime geçme",
   "collect-social-media-mention-text": "Sosyal medyada bizden bahsettiğinizde",
   "collection-purposes-intro-text": "Aşağıdaki amaçlarla bilgi toplayabilir, saklayabilir, kullanabilir ve ifşa edebiliriz; kişisel bilgiler bu amaçlarla bağdaşmayacak şekilde daha fazla işlenmeyecektir:",
   "purpose-core-features-text": "size platformumuzun temel özelliklerini ve hizmetlerini sunmak amacıyla",
   "purpose-customize-experience-text": "web sitelerimizle ilgili deneyiminizi özelleştirmenizi veya kişiselleştirmenizi sağlamak amacıyla",
   "purpose-deliver-products-text": "size ürün ve/veya hizmet sunmak amacıyla",
   "purpose-contact-communicate-text": "sizinle iletişime geçmek ve iletişim kurmak amacıyla",
   "purpose-analytics-research-text": "analitik, pazar araştırması ve iş geliştirme amacıyla; bu kapsamda web sitelerimizi, ilgili uygulamaları ve ilgili sosyal medya platformlarını işletmek ve geliştirmek de dahil olmak üzere",
   "purpose-advertising-marketing-text": "reklam ve pazarlama amacıyla; bu kapsamda ürün ve hizmetlerimize ilişkin tanıtım bilgilerinin ve ilginizi çekebileceğini düşündüğümüz üçüncü taraflara ilişkin bilgilerin tarafınıza gönderilmesi dahil olmak üzere",
   "purpose-enable-access-text": "web sitelerimize, ilgili uygulamalara ve ilgili sosyal medya platformlarına erişmenizi ve bunları kullanmanızı sağlamak amacıyla",
   "purpose-record-keeping-text": "iç kayıt tutma ve idari amaçlarla",
   "purpose-legal-compliance-text": "yasal yükümlülüklerimize uymak ve taraf olabileceğimiz her türlü uyuşmazlığı çözmek amacıyla",
   "purpose-attribute-content-text": "tarafınızca gönderilen ve web sitelerimizde yayınladığımız içeriklerin (örneğin gönderiler ve yorumlar) kaynağını belirtmek amacıyla",
   "purpose-security-fraud-text": "güvenlik ve dolandırıcılığın önlenmesi amacıyla, ayrıca sitelerimizin ve uygulamalarımızın güvenli, emniyetli olmasını ve kullanım şartlarımıza uygun şekilde kullanılmasını sağlamak amacıyla",
   "purpose-technical-assessment-text": "teknik değerlendirme amacıyla, uygulamamızı, ilgili uygulamaları ve ilgili sosyal medya platformlarını işletmek ve geliştirmek dahil olmak üzere",
   "collection-combine-sources-text": "Gönüllü olarak sağlanan ve otomatik olarak toplanan kişisel bilgileri, diğer güvenilir kaynaklardan aldığımız genel bilgiler veya araştırma verileriyle birleştirebiliriz. Örneğin, bize konumunuzu bildirmeniz halinde, sitelerimiz ve hizmetimize ilişkin size geliştirilmiş bir deneyim sunmak amacıyla bu bilgiyi para birimi ve dil hakkındaki genel bilgilerle birleştirebiliriz.",
   "security-of-information-title": "Kişisel Bilgilerinizin Güvenliği",
   "security-measures-description-text": "Kişisel bilgileri topladığımızda ve işlediğimizde, ayrıca bu bilgileri sakladığımız süre boyunca, kaybolmasını, çalınmasını ya da yetkisiz şekilde erişilmesini, ifşa edilmesini, kopyalanmasını, kullanılmasını veya değiştirilmesini önlemek amacıyla bu bilgileri ticari açıdan kabul edilebilir yöntemlerle koruyacağız.",
   "security-no-guarantee-text": "Bize sağladığınız kişisel bilgileri korumak için elimizden geleni yapacak olsak da, hiçbir elektronik iletim veya depolama yönteminin %100 güvenli olmadığını ve hiç kimsenin mutlak veri güvenliğini garanti edemeyeceğini belirtiriz.",
   "security-password-responsibility-text": "Herhangi bir şifre seçmekten ve bu şifrenin genel güvenlik gücünden, hizmetlerimiz kapsamında kendi bilgilerinizin güvenliğini sağlamaktan siz sorumlusunuz. Örneğin, kişisel bilgilerinize ve hesaplarınıza erişimle ilişkili şifrelerin güvenli ve gizli olmasını sağlamak sizin sorumluluğunuzdadır.",
   "retention-period-title": "Kişisel Verilerinizi Ne Kadar Süreyle Sakladığımız",
   "retention-period-description-text": "Kişisel verilerinizi yalnızca ihtiyaç duyduğumuz süre boyunca saklarız. Bu süre, işbu gizlilik politikasına uygun olarak, bilgilerinizi hangi amaçla kullandığımıza bağlı olabilir. Örneğin, bizimle bir hesap oluşturmanın bir parçası olarak bize kişisel verilerinizi sağlamışsanız, bu bilgileri hesabınızın sistemimizde var olduğu süre boyunca saklayabiliriz. Kişisel verileriniz artık bu amaç için gerekli olmadığında, bu verileri sileriz veya sizi tanımlayan tüm ayrıntıları kaldırarak anonim hale getiririz.",
   "retention-legal-obligation-text": "Bununla birlikte, gerekli olması hâlinde, yasal, muhasebe veya raporlama yükümlülüğümüze uymak amacıyla ya da kamu yararına arşivleme, bilimsel veya tarihi araştırma amaçları veya istatistiksel amaçlar için kişisel verilerinizi saklayabiliriz.",
   "childrens-privacy-title": "Çocukların Gizliliği",
   "childrens-privacy-description-text": "Ürün veya hizmetlerimizin hiçbirini doğrudan 13 yaşın altındaki çocuklara yönelik olarak sunmuyoruz ve 13 yaşın altındaki çocuklara ait kişisel verileri bilerek toplamıyoruz.",
   "disclosure-to-third-parties-title": "Kişisel Verilerin Üçüncü Taraflara İfşası",
   "disclosure-intro-text": "Kişisel bilgileri şunlara ifşa edebiliriz:",
   "disclose-affiliate-text": "şirketimizin ana şirketine, bağlı ortaklığına veya iştirakine",
   "disclose-service-providers-text": "hizmetlerini sunmalarını sağlamak amacıyla, BT hizmet sağlayıcıları, veri depolama, barındırma ve sunucu sağlayıcıları, reklam ağları, analiz sağlayıcıları, hata kaydedicileri, borç tahsilat şirketleri, bakım veya sorun giderme sağlayıcıları, pazarlama veya reklam sağlayıcıları, profesyonel danışmanlar ve ödeme sistemi operatörleri dahil ancak bunlarla sınırlı olmamak üzere üçüncü taraf hizmet sağlayıcılarına",
   "disclose-employees-text": "çalışanlarımıza, yüklenicilerimize ve/veya ilişkili kuruluşlara",
   "disclose-business-partners-text": "mevcut veya potansiyel acentelerimize veya iş ortaklarımıza",
   "disclose-credit-agencies-text": "size sağladığımız mal veya hizmetler için ödeme yapmamanız halinde, kredi bilgi kuruluşlarına, mahkemelere, yargı mercilerine ve düzenleyici otoritelere",
   "disclose-law-enforcement-text": "kanunen gerekli olduğu hallerde, mevcut veya olası herhangi bir yasal işlemle bağlantılı olarak ya da yasal haklarımızı tesis etmek, kullanmak veya savunmak amacıyla mahkemeler, yargı mercileri, düzenleyici kurumlar ve kolluk kuvvetleri görevlileri",
   "disclose-agents-subcontractors-text": "size bilgi, ürün, hizmet veya doğrudan pazarlama sağlamamıza yardımcı olan acenteler veya alt yükleniciler dahil olmak üzere üçüncü taraflar",
   "disclose-collect-process-text": "verileri toplamak ve işlemek üzere üçüncü taraflar",
   "disclose-business-transfer-text": "varlıklarımızın ve işimizin tamamını veya tamamına yakınını satın alan ya da bunların kendisine devredildiği bir kuruluş",
   "third-parties-currently-used-text": "Şu anda kullanmakta olduğumuz üçüncü taraflar şunları içermektedir:",
   "international-transfers-title": "Kişisel Bilgilerin Uluslararası Aktarımı",
   "international-transfers-description-text": "Topladığımız kişisel bilgiler, Amerika Birleşik Devletleri'nde veya bizim ya da iş ortaklarımızın, bağlı kuruluşlarımızın ve üçüncü taraf hizmet sağlayıcılarımızın tesislerinin bulunduğu yerlerde saklanmakta ve/veya işlenmektedir.",
   "international-transfers-legal-note-text": "Kişisel bilgilerinizi sakladığımız, işlediğimiz veya aktardığımız ülkeler, bilgileri ilk olarak sağladığınız ülke ile aynı veri koruma yasalarına sahip olmayabilir. Kişisel bilgilerinizi diğer ülkelerdeki üçüncü taraflara aktarmamız halinde: (i) bu aktarımları yürürlükteki mevzuatın gerekliliklerine uygun olarak gerçekleştireceğiz; ve (ii) aktarılan kişisel bilgileri işbu gizlilik politikasına uygun şekilde koruyacağız.",
   "your-rights-title": "Haklarınız ve Kişisel Bilgileriniz Üzerindeki Kontrolünüz",
   "your-choice-description-text": "Tercihiniz: Bize kişisel bilgi sağlayarak, kişisel bilgilerinizi işbu gizlilik politikasına uygun olarak topladığımızı, sakladığımızı, kullandığımızı ve ifşa ettiğimizi anlamış olursunuz. Bize kişisel bilgi sağlamak zorunda değilsiniz; ancak bunu yapmamanız, web sitelerimizi veya bunlar üzerinden ya da bunlar aracılığıyla sunulan ürün ve/veya hizmetleri kullanmanızı etkileyebilir.",
   "info-from-third-parties-text": "Üçüncü taraflardan alınan bilgiler: Hakkınızdaki kişisel bilgileri bir üçüncü taraftan almamız halinde, bu bilgileri işbu gizlilik politikasında belirtildiği şekilde koruyacağız. Başka birine ait kişisel bilgileri sağlayan bir üçüncü taraf iseniz, söz konusu kişinin bu kişisel bilgileri bize sağlamanız için onayını almış olduğunuzu beyan ve taahhüt edersiniz.",
   "marketing-permission-text": "Pazarlama izni: Daha önce kişisel bilgilerinizi doğrudan pazarlama amaçlarıyla kullanmamıza onay vermişseniz, aşağıdaki iletişim bilgilerini kullanarak bizimle iletişime geçmek suretiyle fikrinizi istediğiniz zaman değiştirebilirsiniz.",
   "access-rights-text": "Erişim: Hakkınızda sakladığımız kişisel bilgilere ilişkin ayrıntıları talep edebilirsiniz.",
   "correction-rights-text": "Düzeltme: Hakkınızda sakladığımız herhangi bir bilginin yanlış, güncel olmayan, eksik, ilgisiz veya yanıltıcı olduğunu düşünüyorsanız, lütfen bu gizlilik politikasında belirtilen iletişim bilgilerini kullanarak bizimle iletişime geçin. Yanlış, eksik, yanıltıcı veya güncel olmadığı tespit edilen bilgileri düzeltmek için makul adımları atacağız.",
   "non-discrimination-text": "Ayrımcılık Yapılmaması: Kişisel bilgileriniz üzerindeki haklarınızdan herhangi birini kullanmanız nedeniyle size karşı ayrımcılık yapmayacağız. Kişisel bilgileriniz size belirli bir hizmet veya teklif sunmak için gerekli olmadıkça (örneğin işlem verilerinin işlenmesi), size mal veya hizmet sağlamayı reddetmeyeceğiz ve/veya indirim ya da diğer avantajlar sağlanması veya ceza uygulanması dahil olmak üzere mal veya hizmetler için size farklı fiyat veya ücretler uygulamayacağız ya da size farklı düzey veya kalitede mal veya hizmet sunmayacağız.",
   "download-personal-info-text": "Kişisel Bilgilerin İndirilmesi: Sitelerimiz aracılığıyla paylaştığınız kişisel bilgileri indirmeniz için size bir imkan sunmaktayız. Daha fazla bilgi için lütfen bizimle iletişime geçin.",
   "data-breach-notification-text": "Veri İhlallerinin Bildirimi: Herhangi bir veri ihlaliyle ilgili olarak bize uygulanabilir yasalara uyacağız.",
   "complaints-rights-text": "Şikayetler: İlgili bir veri koruma kanununu ihlal ettiğimizi düşünüyor ve şikayette bulunmak istiyorsanız, lütfen aşağıda belirtilen iletişim bilgilerini kullanarak bizimle iletişime geçin ve iddia edilen ihlale ilişkin tüm ayrıntıları bize iletin. Şikayetinizi derhal inceleyecek ve size, incelememizin sonucunu ve şikayetinizi ele almak için atacağımız adımları belirten yazılı bir yanıt vereceğiz. Ayrıca şikayetinizle ilgili olarak bir düzenleyici kuruma veya veri koruma otoritesine başvurma hakkına da sahipsiniz.",
   "unsubscribe-rights-text": "Abonelikten Çıkma: E-posta veritabanımızdan çıkmak veya iletişimlerden (pazarlama iletişimleri dahil) çıkmak için lütfen işbu gizlilik politikasında belirtilen iletişim bilgilerini kullanarak bizimle iletişime geçiniz ya da ilgili iletişimde sunulan çıkış (opt-out) imkanlarını kullanınız. Kimliğinizi doğrulamamıza yardımcı olmak amacıyla sizden belirli bilgiler talep etmemiz gerekebilir.",
   "use-of-cookies-title": "Çerezlerin Kullanımı",
   "use-of-cookies-description-text": "Sitelerimiz genelinde size ve etkinliklerinize ilişkin bilgi toplamak amacıyla \"çerezler\" kullanmaktayız. Çerez, web sitelerimizin bilgisayarınızda sakladığı ve sitelerimizi nasıl kullandığınızı anlayabilmemiz için her ziyaretinizde eriştiği küçük bir veri parçasıdır. Bu, size belirtmiş olduğunuz tercihlere dayalı içerik sunmamıza yardımcı olur.",
   "refer-to-cookie-policy-text": "Daha fazla bilgi için lütfen Çerez Politikamıza başvurunuz.",
   "business-transfers-title": "İşletme Devirleri",
   "business-transfers-description-text": "Şirketimizin veya varlıklarımızın devralınması ya da olası olmamakla birlikte faaliyetlerimize son vermemiz veya iflas etmemiz halinde, kişisel bilgileriniz de dahil olmak üzere veriler, bizi devralan taraflara devredilen varlıklar arasında yer alacaktır. Bu tür devirlerin gerçekleşebileceğini ve bizi devralan tarafların, yürürlükteki mevzuatın izin verdiği ölçüde, söz konusu bilgiler üzerindeki her türlü mülkiyet veya kullanım hakkımızın dayanağı olan işbu politikayı benimsemek zorunda kalacakları ve bu politikaya uygun olarak kişisel bilgilerinizi kullanmaya devam edebileceklerini kabul edersiniz.",
   "limits-of-policy-title": "Politikamızın Sınırları",
   "limits-of-policy-description-text": "Web sitelerimiz, tarafımızca işletilmeyen harici sitelere bağlantı içerebilir. Bu sitelerin içerikleri ve politikaları üzerinde herhangi bir kontrolümüz bulunmadığını ve bu sitelerin gizlilik uygulamaları bakımından sorumluluk veya yükümlülük kabul edemeyeceğimizi lütfen unutmayınız.",
   "changes-to-policy-title": "Bu Politikada Yapılacak Değişiklikler",
   "changes-to-policy-description-text": "Kendi takdirimize bağlı olarak, iş süreçlerimizdeki güncellemeleri, güncel kabul edilebilir uygulamaları veya yasal ya da düzenleyici değişiklikleri yansıtmak amacıyla gizlilik politikamızda değişiklik yapabiliriz. Bu gizlilik politikasında değişiklik yapmaya karar vermemiz halinde, değişiklikleri bu gizlilik politikasına erişmekte olduğunuz aynı bağlantı üzerinden burada yayımlayacağız.",
   "changes-significant-notice-text": "Değişikliklerin önemli olması veya yürürlükteki mevzuat tarafından gerekli kılınması halinde, sizinle (bizden gelecek iletişimlere ilişkin seçtiğiniz tercihler doğrultusunda) ve kayıtlı tüm kullanıcılarımızla, yeni ayrıntıları ve güncellenmiş veya değiştirilmiş politikaya ilişkin bağlantıları paylaşarak iletişime geçeceğiz.",
   "changes-permission-text": "Kanunen gerekli görülmesi halinde, kişisel bilgilerinizin herhangi bir yeni kullanımı için sizden onay alacağız veya duruma göre bu kullanıma katılım sağlama (opt in) ya da bundan çıkma (opt out) imkânı sunacağız.",
   "au-privacy-act-title": "Avustralya Gizlilik Yasası'na (AU) Uyum İçin Ek Açıklamalar",
   "au-privacy-act-description-text": "Kişisel bilgilerinizin ifşa edilmesinin yalnızca Avustralya gizlilik yasalarına tabi olduğu durumlarda, bazı üçüncü tarafların Gizlilik Yasası ve Gizlilik Yasası'nda yer alan Avustralya Gizlilik İlkeleri tarafından düzenlenmeyebileceğini kabul edersiniz. Bu tür bir üçüncü tarafın Avustralya Gizlilik İlkeleri'ni ihlal eden herhangi bir eylem veya uygulamada bulunması halinde, söz konusu tarafın Gizlilik Yasası kapsamında sorumlu tutulamayacağını ve Gizlilik Yasası kapsamında herhangi bir tazminat talep edemeyeceğinizi kabul edersiniz.",
   "gdpr-compliance-title": "Genel Veri Koruma Tüzüğü'ne (GDPR) Uyum İçin Ek Açıklamalar (AB)",
   "data-controller-processor-title": "Veri Sorumlusu / Veri İşleyen",
   "data-controller-processor-description-text": "GDPR, kişisel bilgileri kendi amaçları doğrultusunda işleyen kuruluşlar (\"veri sorumluları\" olarak bilinir) ile kişisel bilgileri diğer kuruluşlar adına işleyen kuruluşlar (\"veri işleyenler\" olarak bilinir) arasında bir ayrım yapmaktadır. Bize Ulaşın bölümünde belirtilen adreste bulunan biz, International Advisory, Products and Systems Ltd, bize sağladığınız kişisel bilgiler bakımından bir Veri Sorumlusu ve/veya Veri İşleyen sıfatına sahibiz.",
   "legal-bases-title": "Kişisel Bilgilerinizin İşlenmesine İlişkin Hukuki Dayanaklar",
   "legal-bases-description-text": "Kişisel bilgilerinizi yalnızca bunu yapmaya yasal hakkımız olduğunda toplayacak ve kullanacağız. Bu durumda, kişisel bilgilerinizi hukuka uygun, adil ve şeffaf bir şekilde toplayacak ve kullanacağız. Kişisel bilgilerinizi işlemek için rızanızı talep etmemiz halinde ve 16 yaşından küçükseniz, bu belirli amaç doğrultusunda kişisel bilgilerinizi işlemek için ebeveyninizin veya yasal vasinizin rızasını talep edeceğiz.",
   "legal-bases-grounds-text": "Hukuki dayanaklarımız, kullandığınız hizmetlere ve bunları nasıl kullandığınıza bağlıdır. Bu, bilgilerinizi yalnızca aşağıdaki gerekçelerle topladığımız ve kullandığımız anlamına gelir:",
   "consent-from-you-title": "Sizden Alınan Rıza",
   "consent-from-you-description-text": "Belirli bir amaç doğrultusunda kişisel bilgilerinizi toplamamız ve kullanmamız için bize rıza verdiğiniz durumlarda. Sağladığımız imkanları kullanarak rızanızı istediğiniz zaman geri çekebilirsiniz; ancak bu, bilgilerinizin daha önce gerçekleşmiş olan herhangi bir kullanımını etkilemeyecektir. Bizden pazarlama e-postaları almak amacıyla e-posta adresinizi sağlamaya rıza gösterebilirsiniz. İstediğiniz zaman abonelikten çıkabilirsiniz; ancak zaten göndermiş olduğumuz herhangi bir e-postayı geri çağıramayız. Rızanızı nasıl geri çekeceğinize ilişkin herhangi bir sorunuz varsa, lütfen bu gizlilik politikasının Bize Ulaşın bölümünde verilen bilgileri kullanarak bizimle iletişime geçmekten çekinmeyin.",
   "performance-of-contract-title": "Bir Sözleşmenin veya İşlemin İfası",
   "performance-of-contract-description-text": "Bizimle bir sözleşme veya işlem yapmış olduğunuz durumlarda ya da sizinle bir sözleşme veya işlem yapmamızdan önceki hazırlık adımlarını atmak amacıyla. Örneğin, bizden bir ürün, hizmet veya abonelik satın almanız halinde, siparişinizi işleme koymak ve teslim etmek için kişisel ve ödeme bilgilerinizi kullanmamız gerekebilir.",
   "legitimate-interests-title": "Meşru Menfaatlerimiz",
   "legitimate-interests-description-text": "Hizmetlerimizi sunmamız, işletmemiz, geliştirmemiz ve bunlar hakkında bilgi vermemiz gibi amaçlarla, bunun meşru menfaatlerimiz açısından gerekli olduğunu değerlendirdiğimiz hâllerde. Meşru menfaatlerimizin araştırma ve geliştirmeyi, hedef kitlemizi anlamayı, hizmetlerimizin pazarlanmasını ve tanıtımını, hizmetlerimizin verimli bir şekilde işletilmesine yönelik önlemleri, pazarlama analizini ve yasal hak ve menfaatlerimizin korunmasına yönelik önlemleri kapsadığını değerlendiriyoruz.",
   "compliance-with-law-title": "Yasalara Uyum",
   "compliance-with-law-description-text": "Bazı durumlarda, kişisel bilgilerinizi kullanmak veya saklamak konusunda yasal bir yükümlülüğümüz olabilir. Bu tür durumlar, bunlarla sınırlı olmamak üzere, mahkeme kararlarını, ceza soruşturmalarını, resmi makam taleplerini ve düzenleyici yükümlülükleri içerebilir. Kişisel bilgileri yasalara uymak amacıyla nasıl sakladığımıza ilişkin başka sorularınız varsa, lütfen bu gizlilik politikasının Bize Ulaşın bölümünde verilen bilgileri kullanarak bizimle iletişime geçmekten çekinmeyin.",
   "eea-transfers-title": "Avrupa Ekonomik Alanı (AEA) Dışına Uluslararası Aktarımlar",
   "eea-transfers-description-text": "Kişisel bilgilerin Avrupa Ekonomik Alanı (AEA) içindeki ülkelerden AEA dışındaki ülkelere aktarılmasının, örneğin Avrupa Komisyonu tarafından onaylanan standart veri koruma hükümlerinin kullanılması veya bağlayıcı şirket kurallarının ya da diğer yasal olarak kabul edilen araçların kullanılması yoluyla, uygun güvencelerle korunmasını sağlayacağız.",
   "data-portability-text": "Veri taşınabilirliği: Hakkınızda sahip olduğumuz kişisel bilgilerin bir kopyasını talep etme hakkına sahip olabilirsiniz. Mümkün olduğu ölçüde, bu bilgileri CSV formatında veya kolayca okunabilir başka bir makine formatında sunacağız. Ayrıca bu kişisel bilgilerin bir üçüncü tarafa aktarılmasını talep etme hakkına da sahip olabilirsiniz.",
   "deletion-rights-text": "Silme: Hakkınızda sahip olduğumuz kişisel bilgileri her zaman silmemizi talep etme hakkına sahip olabilirsiniz ve kişisel bilgilerinizi mevcut kayıtlarımızdan silmek için makul adımları atacağız. Kişisel bilgilerinizi silmemizi talep etmeniz halinde, bu silme işleminin web sitelerimizin veya ürün ve hizmetlerimizin kullanımınızı nasıl etkileyeceğini size bildireceğiz. Bu hakka ilişkin, geçerli olması halinde talebinize verdiğimiz yanıtta size açıklayacağımız belirli hukuki nedenlere dayalı istisnalar bulunabilir. Hesabınızı feshetmeniz veya silmeniz halinde, kişisel bilgilerinizi hesabınızın silinmesinden itibaren 45 gün içinde sileceğiz. Lütfen, arama motorlarının ve benzeri üçüncü tarafların, hizmetlerimizden bilgileri silmiş veya hesabınızı devre dışı bırakmış olsanız dahi, belirli profil bilgileri ve herkese açık yorumlar gibi en az bir kez kamuya açıklanmış kişisel bilgilerinizin kopyalarını hâlâ saklayabileceğinin farkında olun.",
   "objecting-to-processing-text": "İşlemeye itiraz: Kişisel bilgilerinizin, meşru menfaatlerimize veya kamu yararına dayalı olarak işlenmesine itiraz etme hakkına sahipsiniz. Bu itiraz gerçekleştirildiğinde, kişisel bilgilerinizin işlenmesine devam edebilmemiz için, sizin menfaatlerinizi, haklarınızı ve özgürlüklerinizi aşan zorlayıcı meşru gerekçeler sunmamız gerekir.",
   "restrict-processing-rights-text": "Kısıtlama: Aşağıdaki durumlarda kişisel bilgilerinizin işlenmesini kısıtlamamızı talep etme hakkına sahipsiniz: (i) kişisel bilgilerinizin doğruluğu konusunda endişeniz olması; (ii) kişisel bilgilerinizin hukuka aykırı bir şekilde işlendiğine inanmanız; (iii) kişisel bilgilerin yalnızca bir hukuki talebin amaçları doğrultusunda tarafımızca muhafaza edilmesine ihtiyaç duymanız; veya (iv) meşru menfaatler temelinde yapılan işlemeye ilişkin itirazınızı değerlendirme sürecinde olmamız.",
   "us-states-privacy-title": "ABD Eyaletleri Gizlilik Kanunlarına Uyum Kapsamında Ek Açıklamalar.",
   "us-states-privacy-description-text": "Aşağıdaki bölüm, bu eyaletlerin (California, Colorado, Delaware, Florida, Virginia ve Utah) gizlilik kanunlarına uyumlu hükümler içermekte olup yalnızca bu eyaletlerin sakinlerine uygulanır. Belirli bir eyalete yapılan atıflar (bir başlıkta veya metin içinde) yalnızca o eyaletin kanununa bir atıf niteliğindedir ve yalnızca o eyaletin sakinlerine uygulanır. Eyalete özgü olmayan ifadeler ise yukarıda sayılan eyaletlerin tamamına uygulanır.",
   "do-not-track-title": "Takip Etme",
   "do-not-track-description-text": "Bazı tarayıcılar, çevrimiçi etkinliklerinizin takip edilmesini istemediğinizi web sitelerine bildirmenizi sağlayan bir \"Takip Etme\" özelliğine sahiptir. Şu an itibarıyla, tarayıcıların \"Takip Etme\" sinyallerine yanıt vermemekteyiz.",
   "do-not-track-standards-text": "Kişisel verileri hukuka uygun, dürüst ve şeffaf bir şekilde ve bunu yapmak için meşru, hukuki gerekçelerle toplamamızı ve işlememizi sağlamak amacıyla, işbu gizlilik politikasında belirtilen standartlara uyuyoruz.",
   "cookies-and-pixels-title": "Çerezler ve Pikseller",
   "cookies-and-pixels-description-text": "Tarayıcınız izin verdiği sürece, sitelerimizden gelen çerezleri her zaman reddedebilirsiniz. Çoğu tarayıcı, tüm çerezlerin veya bazı çerezlerin ayarlanmasını reddetmek üzere tarayıcınızda ayar yapmanıza olanak tanır. Buna göre, çerezleri sınırlama konusundaki yeteneğiniz yalnızca tarayıcınızın özelliklerine bağlıdır. Daha fazla bilgi için lütfen işbu gizlilik politikasının Çerezler bölümüne bakınız.",
   "california-privacy-laws-title": "California Gizlilik Kanunları - CPPA",
   "california-privacy-financial-incentive-text": "California Medeni Kanunu'nun 1798.83. Bölümü uyarınca, California'da yaşıyorsanız ve bizimle olan iş ilişkiniz esas olarak kişisel, ailevi veya hane halkına yönelik amaçlarla ise, pazarlama amaçları için diğer kuruluşlara ifşa ettiğimiz bilgiler hakkında bizden bilgi talep edebilirsiniz. Ayrımcılığa uğramama hakkınız doğrultusunda, sağladığımız mal veya hizmetler için farklı fiyatlar, ücretler veya kalite düzeyleriyle sonuçlanabilecek, California Tüketici Gizliliği Yasası ve California Gizlilik Hakları Yasası (birlikte \"CCPA\" olarak anılır) tarafından izin verilen belirli mali teşvikler sunabiliriz. Sunduğumuz CCPA kapsamında izin verilen herhangi bir mali teşvik, kişisel bilgilerinizin değeriyle makul ölçüde ilişkili olacaktır ve bu tür bir teklifin niteliğini açıkça açıklayan yazılı şartlar sunacağız. Bir mali teşvik programına katılım, önceden onayınızı gerektirir ve bu onayı istediğiniz zaman geri alabilirsiniz.",
   "california-privacy-request-info-text": "California Medeni Kanunu'nun 1798.83. Bölümü uyarınca, California'da yaşıyorsanız ve bizimle olan iş ilişkiniz esas olarak kişisel, ailevi veya hane halkına yönelik amaçlarla ise, pazarlama amaçları için diğer kuruluşlara ifşa ettiğimiz bilgiler hakkında bizden bilgi talep edebilirsiniz. Böyle bir talepte bulunmak için lütfen konu satırına \"California gizlilik bilgisi talebi\" yazarak, bu gizlilik politikasında belirtilen iletişim bilgilerini kullanarak bizimle iletişime geçin. Bu tür bir talebi her takvim yılında yalnızca bir kez yapabilirsiniz. Son takvim yılında pazarlama amaçları için diğer kuruluşlara ifşa ettiğimiz kişisel bilgi kategorilerinin bir listesini, bu kuruluşların isim ve adresleriyle birlikte size e-posta yoluyla göndereceğiz. Bu şekilde paylaşılan kişisel bilgilerin tümü değil, bir kısmı California Medeni Kanunu'nun 1798.83. Bölümü kapsamına girer.",
   "california-notice-of-collection-title": "California Toplama Bildirimi",
   "california-notice-of-collection-intro-text": "Son 12 ay içinde, CCPA'da sayılan aşağıdaki kişisel bilgi kategorilerini topladık:",
   "ccpa-identifiers-text": "Ad, e-posta adresi, telefon numarası, hesap adı, IP adresi ve hesabınıza atanan bir kimlik veya numara gibi tanımlayıcılar.",
   "ccpa-customer-records-text": "Fatura ve teslimat adresi ile kredi veya banka kartı verileri gibi müşteri kayıtları.",
   "ccpa-demographics-text": "Yaşınız veya cinsiyetiniz gibi demografik bilgiler. Bu kategori, diğer California veya federal yasalar kapsamında korunan sınıflandırmalar olarak nitelendirilebilecek verileri içerir.",
   "ccpa-commercial-info-text": "Ürün veya hizmet geçmişi ve satın alımlar gibi ticari bilgiler.",
   "ccpa-internet-activity-text": "Hizmetimizle olan etkileşimleriniz gibi internet etkinliği.",
   "ccpa-audio-visual-text": "Bizimle paylaştığınız veya hizmet üzerinde yayınladığınız fotoğraflar ya da videolar gibi işitsel veya görsel veriler.",
   "ccpa-geolocation-text": "Coğrafi konum verileri.",
   "ccpa-employment-education-text": "Bizimle bir işe başvurduğunuzda sağladığınız veriler gibi istihdam ve eğitim verileri.",
   "ccpa-inferences-text": "İlgi alanlarınız, tercihleriniz ve favorileriniz hakkındaki bilgiler gibi çıkarımlar.",
   "california-notice-of-collection-outro-text": "Bilgi aldığımız kaynaklar da dahil olmak üzere, topladığımız bilgiler hakkında daha fazla bilgi için \"Topladığımız Bilgiler\" bölümünü inceleyiniz. Bu kişisel veri kategorilerini, Hizmetimizi sağlamak ve yönetmek de dahil olmak üzere \"Bilgilerin Toplanması ve Kullanılması\" bölümünde açıklanan ticari amaçlar için topluyor ve kullanıyoruz.",
   "right-to-know-delete-title": "Bilgi Edinme ve Silme Hakkı",
   "right-to-know-delete-intro-text": "Topladığımız kişisel verilerinizi sildirme ve son 12 ay içindeki veri uygulamalarımıza ilişkin belirli bilgileri öğrenme hakkına sahipsiniz. Özellikle, bizden aşağıdakileri talep etme hakkına sahipsiniz:",
   "know-delete-categories-collected-text": "Hakkınızda topladığımız kişisel veri kategorileri;",
   "know-delete-categories-sources-text": "Kişisel verilerin toplandığı kaynak kategorileri;",
   "know-delete-categories-disclosed-text": "Bir iş amacı için ifşa ettiğimiz veya sattığımız, size ilişkin kişisel bilgi kategorileri;",
   "know-delete-third-parties-text": "Kişisel bilgilerin bir iş amacı için ifşa edildiği veya satıldığı üçüncü taraf kategorileri;",
   "know-delete-business-purpose-text": "Kişisel bilgilerin toplanmasının veya satılmasının iş veya ticari amacı; ve",
   "know-delete-specific-pieces-text": "Size ilişkin olarak topladığımız kişisel bilgilerin belirli parçaları.",
   "right-to-know-delete-outro-text": "Bu haklardan herhangi birini kullanmak için lütfen işbu gizlilik politikasında belirtilen iletişim bilgilerini kullanarak bizimle iletişime geçin.",
   "shine-the-light-title": "Shine the Light",
   "contact-us-title": "Bize Ulaşın",
   "customer-service-label": "Müşteri Hizmetleri",
   "privacy-contact-us-description-text": "Gizliliğinizle ilgili her türlü soru veya endişe için bizimle aşağıdaki bilgileri kullanarak iletişime geçebilirsiniz:",
   "shine-the-light-description-text": "Yukarıda belirtilen haklara ek olarak, yürürlükteki mevzuatta tanımlandığı şekilde, belirli kişisel bilgileri üçüncü taraflar ve iştiraklerle kendi doğrudan pazarlama amaçları doğrultusunda paylaşma şeklimiz hakkında bizden bilgi talep etme hakkına sahipsiniz.",
   "shine-the-light-request-text": "Bu bilgiyi almak için, işbu gizlilik politikasında belirtilen iletişim bilgilerini kullanarak bize bir talep gönderiniz. Taleplerin açıklamanın ilk satırında \"Privacy Rights Request\" ifadesini içermesi ve adınızı, açık adresinizi, şehrinizi, eyaletinizi ve posta kodunuzu içermesi gerekmektedir.",

   // My Performance (Staff)
   "loading-ellipsis-text": "Yükleniyor...",
   "failed-to-load-modules-error": "Modüller yüklenemedi",
   "failed-to-load-details-error": "Detaylar yüklenemedi",
   "my-assessments-title": "Değerlendirmelerim",
   "my-assessments-description-text":
      "Modüllerini ve performans bilgilerini görmek için bir değerlendirme seçerek başlayın.",
   "no-assessments-yet-title": "Henüz değerlendirme yok gibi görünüyor!",
   "no-assessments-yet-description-text":
      "Değerlendirmelerin sonuçları olduğunda, keşfetmeniz için burada görünecekler.",
   "modules-in-assessment-label": "Bu değerlendirmedeki modüller:",
   "choose-module-to-see-results-text": "Sonuçları görmek için bir modül seçin",
   "status-closed-label": "Kapalı",
   "select-module-alt-text": "Modül seç",
   "select-module-results-text": "Sonuçlarını görüntülemek için listeden bir modül seçin",
   "target-label": "Hedef",
   "action-plan-label": "Eylem planı",
   "assessment-preview-title": "Değerlendirme önizlemesi",
   "no-data-for-assessment-text": "Bu değerlendirme için şu anda kullanılabilir veri yok",
   "my-upcoming-tasks-title": "Yaklaşan görevlerim",
   "my-improvement-over-time-title": "Zaman içindeki gelişimim",
   "no-data-for-survey-text": "Bu anket için şu anda kullanılabilir veri yok",
   "your-score-label": "Puanınız",
   "target-score-label": "Hedef puan",
   "previous-label": "Önceki",
   "next-label": "Sonraki",

   // Task Management (Staff)
   "task-management-title": "Görev yönetimi",
   "tasks-tab-label": "Görevler",
   "assigned-modules-title": "Atanan modüller",
   "collapse-all-button": "Tümünü daralt",
   "expand-all-button": "Tümünü genişlet",
   "assigned-tasks-title": "Atanan Görevler",
   "board-tab-label": "Pano",
   "timeline-tab-label": "Zaman çizelgesi",
   "no-available-modules-text": "Bu değerlendirme için kullanılabilir modül yok",
   "no-available-tasks-text": "Bu değerlendirme için kullanılabilir görev yok",
   "go-alt-text": "Git",
   "view-alt-text": "Görüntüle",
   "notes-alt-text": "Notlar",
   "change-status-to-label": "Durumu şuna değiştir:",
   "priority-low-label": "Düşük",
   "priority-medium-label": "Orta",
   "priority-high-label": "Yüksek",
   "priority-urgent-label": "Acil",
   "show-less-link": "Daha az göster",
   "monthly-toggle-label": "Aylık",
   "quarterly-toggle-label": "Üç Aylık",
   "week-prefix-text": "Hafta",
   "to-do-status": "Yapılacak",
   "tasks-column-header": "Görevler",
   "linked-questions-prefix-text": "Bağlantılı sorular:",
   "assigned-status": "Atandı",
   "action-plan-dashboard-title": "Aksiyon Planı Panosu",
   "action-plan-for-label": "Aksiyon planı için",

   "role-vendor-label": "Tedarikçi",
   "switch-role-label": "Rol değiştir",
   "current-role-label": "Mevcut rol",
   "switch-role-error-description": "Rolünüz değiştirilemedi, lütfen tekrar deneyin.",
   "approver-role-added-to-existing-user-description":
      "Bu kullanıcının zaten bir hesabı vardı, bu yüzden davet e-postası gönderilmedi. Mevcut şifresiyle giriş yapıp Onaylayan rolüne geçebilir.",

   // Dual role (Expert + Approver on the same account)
   "expert-role-column": "Uzman",
   "expert-role-enabled-success-title": "Uzman rolü eklendi",
   "expert-role-enabled-success-description": "Bu onaylayan artık uzman olarak da çalışabilir.",
   "expert-role-disabled-success-title": "Uzman rolü kaldırıldı",
   "expert-role-disabled-success-description": "Bu onaylayanın artık uzman rolü yok.",
   "expert-role-toggle-error-description": "Uzman rolü güncellenemedi, lütfen tekrar deneyin.",
   "expert-role-not-found-description": "Bu onaylayan artık mevcut değil. Liste yenilendi.",
   "approver-role-column": "Onaylayan",
   "approver-role-enabled-success-title": "Onaylayan rolü eklendi",
   "approver-role-enabled-success-description": "Bu uzman artık onaylayan olarak da çalışabilir.",
   "approver-role-disabled-success-title": "Onaylayan rolü kaldırıldı",
   "approver-role-disabled-success-description": "Bu uzmanın artık onaylayan rolü yok.",
   "approver-role-toggle-error-description": "Onaylayan rolü güncellenemedi, lütfen tekrar deneyin.",
   "approver-role-not-found-description": "Bu uzman artık mevcut değil. Liste yenilendi.",
   "expert-exists-redirect-title": "Zaten Uzman",
   "expert-exists-redirect-description":
      "Bu e-posta zaten bir Uzmana ait. Sizi, onaylayan rolünü verebileceğiniz Uzmanlar listesine yönlendiriyoruz.",

   "linked-assessment-edit-notice":
      "Bu değerlendirme başka bir değerlendirmeye bağlı olduğu için yalnızca yeni turlar eklenebilir. Burada eklediğiniz her tur bağlı değerlendirmeye de eklenir.",
   "start-date-in-past-validation": "Başlangıç tarihi geçmişte olamaz.",
   "end-date-must-be-future-validation": "Bitiş tarihi gelecekte olmalıdır.",
   "round-overlaps-another-round-validation": "Bu tur başka bir turla çakışıyor.",
   "view-all-notifications-button": "Tüm bildirimleri gör",
   "notifications-page-title": "Bildirimler",
   "notifications-empty-title": "Henüz bildirim yok",
   "notifications-unread-empty-title": "Okunmamış bildirim yok",
   "notifications-empty-text": "Her şeyi gördünüz. Yeni bildirimler burada görünecek.",
   "guided-assessment-completed-prefix-text": "Rehberli değerlendirmeniz",
   "guided-assessment-completed-suffix-text": "tamamlandı.",
   "notification-title-org-signup": "Yeni kuruluş kaydı",
   "notification-title-expert-signup": "Yeni uzman kaydı",
   "notification-title-workspace-join-request": "Kuruluşun çalışma alanına katılma talebi",
   "notification-title-workspace-approved": "Çalışma alanı talebi onaylandı",
   "notification-title-workspace-rejected": "Çalışma alanı talebi reddedildi",
   "notification-title-guided-request": "Rehberli değerlendirme talebi",
   "notification-title-guided-approved": "Rehberli değerlendirme talebi onaylandı",
   "notification-title-guided-rejected": "Rehberli değerlendirme talebi reddedildi",
   "notification-title-guided-completed": "Rehberli değerlendirme tamamlandı",
   "notification-title-self-assigned": "Yeni öz değerlendirme atandı",
   "notification-title-self-unassigned": "Öz değerlendirme ataması kaldırıldı",
   "notification-title-expert-assigned": "Rehberli değerlendirmeye atandı",
   "notification-title-ticket-created": "Yeni destek talebi oluşturuldu",
   "notification-title-ticket-updated": "Destek talebi güncellendi",
   "notification-title-submission-review": "Gönderim incelemeye hazır",
   "notification-title-submission-approved-by-approver": "Gönderim onaylayıcı tarafından onaylandı",
   "notification-title-submission-rejected-by-approver": "Gönderim onaylayıcı tarafından reddedildi",
   "notification-title-module-assigned": "Yeni modül atandı",
   "notification-title-module-unassigned": "Modül ataması kaldırıldı",
   "notification-title-submission-approved": "Gönderim onaylandı",
   "notification-title-submission-rejected": "Gönderim reddedildi",
   "notification-title-submission-approval": "Gönderim onaya hazır",
   "mark-as-read-label": "Okundu olarak işaretle",
   "notification-actions-label": "Bildirim işlemleri"
};
